/**
 * The panel's Turkish: English as it appears in the code → Turkish. Keys are the words exactly as written (the template
 * transform passes them without the whitespace around them). A missing key shows the English.
 * build/panel-i18n-extract.cjs lists the words the panel shows, so missing ones can be found (--missing).
 * Made 2026-11-03 from the template words of pg_dev, lr_dev and mb_dev, the menu, and the notifications in the code;
 * 2026-11-04 the text built in JavaScript (tr / trf calls, labels kept in scripts) was added.
 */
export default {
  "#{0} · by {1}": "#{0} · oluşturan: {1}",
  "$ off the order": "$ sipariş indirimi",
  "$5 off orders over $30": "$30 üzeri siparişlerde $5 indirim",
  "% OF TOTAL": "% TOPLAMDAKİ PAY",
  "% off (100 = free), up to": "% indirimle (100 = ücretsiz), en fazla",
  "% off items": "% ürün indirimi",
  "% off these items:": "% indirim, şu ürünlerde:",
  "% off.": "% indirimle.",
  "(ADDITIONAL AREA)": "(EK BÖLGE)",
  "(BRAND)": "(MARKA)",
  "(custom pizza)": "(özel pizza)",
  "(customer #{0})": "(müşteri #{0})",
  "(empty)": "(boş)",
  "(leave empty = another of what they bought)": "(boş bırakın = aldığı üründen bir tane daha)",
  "(leave empty = any item on the menu)": "(boş bırakın = menüdeki herhangi bir ürün)",
  "(leave empty = any item)": "(boş bırakın = herhangi bir ürün)",
  "(leave empty = every item on the menu)": "(boş bırakın = menüdeki tüm ürünler)",
  "(MAIN AREA)": "(ANA BÖLGE)",
  "(nothing selected = any size)": "(hiçbiri seçilmezse = her boy)",
  "(optional)": "(isteğe bağlı)",
  "(participant #{0})": "(katılımcı #{0})",
  "(sent {0}): {1} The form shows it on top of the website's version; saving again replaces it.": "(gönderim: {0}): {1} Form, değişikliğinizi web sitesindeki sürümün üzerinde gösterir; yeniden kaydederseniz yeni hâli bunun yerine geçer.",
  "(STORE)": "(MAĞAZA)",
  "(unknown product)": "(bilinmeyen ürün)",
  "(unnamed)": "(adsız)",
  "(up to {0} sends in total, then set it again)": "(toplam en fazla {0} gönderim; sonra yeniden ayarlayın)",
  "({0} from scans)": "({0} taramadan)",
  "({0} in this window)": "(bu aralıkta {0})",
  "({0} only)": "(yalnızca {0})",
  "+ 3P {0}": "+ 3. taraf {0}",
  "+ Add a choice": "+ Seçim ekle",
  "+ Add a reward": "+ Ödül ekle",
  "+ Add another deal": "+ Başka bir kampanya ekle",
  "+ New Banner": "+ Yeni banner",
  "+ New Notification": "+ Yeni bildirim",
  "+ {0} third-party": "+ {0} üçüncü taraf",
  "+50 or -50": "+50 veya -50",
  "+{0} guest": "+{0} misafir",
  "+{0} more": "+{0} daha",
  ", against": ", buna karşılık",
  ", created": ", oluşturulma tarihi",
  ", or sooner when the customer stays silent for": ", müşteri sessiz kalırsa daha erken biter; sessizlik sınırı",
  ", order number": ", sipariş numarası",
  ", so this is the whole store, not app performance.": ", yani bu rakamlar uygulama performansını değil, mağazanın tamamını gösterir.",
  ", unit {0}": ", daire {0}",
  ", worth about {0}": ", toplam değeri yaklaşık {0}",
  ", worth {0}": ", toplam değeri {0}",
  ". New messages open at once, and the older ones come back as soon as a colleague's panel is open.": ". Yeni mesajlar hemen açılır; eskileri de bir iş arkadaşınızın paneli açıldığı anda geri gelir.",
  ". New messages open at once; older ones come back as soon as a colleague's panel is open. Nothing is lost while one person on the team still has their key.": ". Yeni mesajlar hemen açılır; eskileri bir iş arkadaşınızın paneli açıldığı anda geri gelir. Ekipte anahtarı olan bir kişi kaldığı sürece hiçbir şey kaybolmaz.",
  ". Someone marked": ". Şöyle işaretlenmiş biri:",
  ". Tips ({0}) and sales tax ({1}) are not sales.": ". Bahşiş ({0}) ve satış vergisi ({1}) satış sayılmaz.",
  ". Two things are deliberately kept out, and putting either back is what produces a number roughly three times higher.": ". İki şey bilerek dışarıda bırakılır; bunlardan birini geri eklemek, yaklaşık üç kat yüksek bir sayı ortaya çıkarır.",
  ". {0} items you left empty stay untouched.": ". Boş bıraktığınız {0} kalem olduğu gibi kalır.",
  "/promotions/campaign or https://…": "/promotions/campaign veya https://…",
  "0 = all matching items in the cart.": "0 = sepetteki tüm uygun ürünler.",
  "0 = no limit. Any limit hides the deal from customers who are not signed in, because there is no account to count against.": "0 = sınır yok. Herhangi bir sınır, kampanyayı giriş yapmamış müşterilerden gizler; çünkü sayımın yapılacağı bir hesap yoktur.",
  "0 = toppings are charged as usual.": "0 = malzemeler her zamanki gibi ücretlendirilir.",
  "1 = the discount starts with the first item.": "1 = indirim ilk üründen başlar.",
  "1 banner": "1 banner",
  "1 change": "1 değişiklik",
  "1 change waiting": "1 değişiklik bekliyor",
  "1 day": "1 gün",
  "1 day up to today": "Bugüne kadarki 1 gün",
  "1 day up to yesterday": "Düne kadarki 1 gün",
  "1 location": "1 mağaza",
  "1 notification": "1 bildirim",
  "1 qualifying product": "1 geçerli ürün",
  "1 reward product": "1 ödül ürünü",
  "1 segment": "1 segment",
  "1 specific product": "1 belirli ürün",
  "1 store": "1 mağaza",
  "1 tier": "1 seviye",
  "1 use": "1 kullanım",
  "1. List": "1. Liste",
  "1.000 is clean; above 1.02 means orders are being sent twice": "1.000 temizdir; 1.02'nin üstü siparişlerin iki kez gönderildiği anlamına gelir",
  "100% off = free. 50 = half price. “0” in the first box means every extra item is rewarded, with no cap.": "%100 indirim = ücretsiz. 50 = yarı fiyat. İlk kutudaki “0”, her ek ürünün üst sınır olmadan ödüllendirileceği anlamına gelir.",
  "20% off all pastas": "Tüm makarnalarda %20 indirim",
  "30 Days": "30 gün",
  "7 days": "7 gün",
  "7 Days": "7 gün",
  "7-Day Rolling": "7 günlük hareketli ortalama",
  "7-DAY ROLLING": "7 GÜNLÜK HAREKETLİ ORT.",
  "7×24 Heatmap ({0})": "7×24 ısı haritası ({0})",
  "8-4-4-4-12 letters and digits, from the Simli dashboard": "8-4-4-4-12 harf ve rakam, Simli panosundan",
  ": recent enough to remember you.": ": sizi hatırlayacak kadar yakın zamanda gelmişler.",
  "; the story has no page of its own.": "; hikayenin kendine ait bir sayfası yoktur.",
  "<product>": "<ürün>",
  "= target − on hand + used by then. That middle column is why an item can be above its target and still need ordering: the stock has to last until the delivery actually turns up. Cases are rounded up, so slightly more arrives than the gap — Sysco does not split a case.": "= hedef − eldeki + o zamana kadar kullanılacak. Bir ürünün hedefinin üstünde olup yine de sipariş gerektirebilmesinin nedeni bu ortadaki sütundur: stok, teslimat gerçekten gelene kadar yetmelidir. Koliler yukarı yuvarlanır, bu yüzden açıktan biraz fazlası gelir — Sysco koli bölmez.",
  "? This cannot be undone.": "? Bu işlem geri alınamaz.",
  "[product]": "[ürün]",
  "a case, from invoice {0} ({1}, {2}).": "koli başına, {0} numaralı faturadan ({1}, {2}).",
  "a choice from anything": "tüm menüden bir seçim",
  "a choice from {0}": "{0} arasından bir seçim",
  "A combo needs at least one choice.": "Kombo en az bir seçim içermelidir.",
  "A count belongs to one store. Choose which one from the selector at the top left, then come back — otherwise the numbers would land somewhere you did not mean.": "Sayım tek bir mağazaya aittir. Sol üstteki seçiciden hangi mağaza olduğunu seçin, sonra geri gelin — aksi halde sayılar istemediğiniz bir yere kaydedilir.",
  "A coupon code has only letters, digits, - and _.": "Kupon kodunda yalnızca harf, rakam, - ve _ olabilir.",
  "A customer belongs to the brand, and the store on their record is only filled in once they actually order — so filtering signups by store would quietly keep only the people who ordered and report an activation rate of 100%. This table is that field read honestly: the store each activated signup first ordered from, with the ones who have not ordered on the last row.": "Müşteri markaya aittir ve kaydındaki mağaza ancak gerçekten sipariş verdiğinde doldurulur — bu yüzden kayıtları mağazaya göre filtrelemek sessizce yalnızca sipariş verenleri bırakır ve %100 aktivasyon oranı gösterirdi. Bu tablo o alanı dürüstçe okur: aktive olan her kaydın ilk sipariş verdiği mağaza; henüz sipariş vermeyenler son satırdadır.",
  "a customer is offered the deal if they match": "müşteri şuna uyarsa kampanya ona sunulur:",
  "A customer who orders every week builds a streak. At the weeks set here they can claim the reward in the app; each tier has its own list.": "Her hafta sipariş veren müşteri bir seri oluşturur. Burada belirlenen haftalara ulaştığında ödülü uygulamada alabilir; her seviyenin kendi listesi vardır.",
  "A date range overrides the time window below.": "Tarih aralığı, aşağıdaki saat aralığının yerine geçer.",
  "A delivery arrives at one store. Choose which one from the selector at the top left.": "Teslimat tek bir mağazaya gelir. Sol üstteki seçiciden hangi mağaza olduğunu seçin.",
  "A flat amount off the bill once it passes a minimum.": "Hesap belirli bir tutarı geçtiğinde sabit bir tutar düşülür.",
  "a free item": "bir ürün",
  "A map of the addresses orders were sent to": "Siparişlerin gönderildiği adreslerin haritası",
  "A member started checkout": "Bir üye ödemeyi başlattı",
  "A percentage off specific items, or the whole menu.": "Belirli ürünlerde ya da tüm menüde yüzde indirim.",
  "A phrase you make up now, like a second password for the chat only. You type it once here; it is asked again only when you open the chat on another browser or phone.": "Şimdi belirlediğiniz, yalnızca sohbete özel ikinci bir şifre gibi bir ifade. Burada bir kez yazarsınız; yalnızca sohbeti başka bir tarayıcıda veya telefonda açtığınızda yeniden sorulur.",
  "A rate is only meaningful when the top and bottom describe the same people. This one counts": "Bir oran ancak pay ile payda aynı kişileri anlattığında anlamlıdır. Bu oran şunu ölçer:",
  "A role is a set of permissions you choose. Give it to a person on the Users page. Built-in roles are locked: copy one to start from it.": "Rol, seçtiğiniz yetkilerden oluşan bir kümedir. Rolü Kullanıcılar sayfasında bir kişiye verin. Yerleşik roller kilitlidir: başlangıç için birini kopyalayın.",
  "A role says": "Rol, kişinin",
  "A short reason helps the engine avoid proposing the same thing again.": "Kısa bir gerekçe, motorun aynı şeyi yeniden önermesini önler.",
  "A shortcut when naming every item one by one is too much. Exact items above still work.": "Her ürünü tek tek seçmek zahmetli olduğunda bir kısayol. Yukarıda seçilen ürünler de geçerli olmaya devam eder.",
  "A Simli face ID; empty means the order server's own default face.": "Bir Simli yüz kimliği; boş bırakılırsa sipariş sunucusunun kendi varsayılan yüzü kullanılır.",
  "A till record is a phone or counter customer keyed in by staff. They rarely leave an e-mail address, so an e-mail campaign cannot reach most of them however large the number looks — check the reachable figure above before planning one.": "Kasa kaydı, personelin sisteme girdiği telefon veya kasa müşterisidir. Bu kişiler nadiren e-posta adresi bırakır; bu yüzden sayı ne kadar büyük görünse de bir e-posta kampanyası çoğuna ulaşamaz — planlamadan önce yukarıdaki ulaşılabilir sayıyı kontrol edin.",
  "A voice session ends after": "Sesli oturumun azami süresi",
  "A web page starts with https://": "Web sayfası adresi https:// ile başlar",
  "A-Z": "A-Z",
  "A/B Tests": "A/B testleri",
  "above, then add the order to that day's shift on the store POS with this order ID.": "düğmesini (yukarıda) kullanın, ardından siparişi bu sipariş kimliğiyle mağaza POS'undaki o günün vardiyasına ekleyin.",
  "Accept all {0} suggestions": "{0} önerinin tümünü kabul et",
  "Access request": "Erişim isteği",
  "Access requests": "Erişim istekleri",
  "Accessing Permissions": "Erişim yetkileri",
  "Accordion Body": "Akordeon içeriği",
  "accounts on the brand": "markaya kayıtlı hesap",
  "across every channel": "tüm kanallarda",
  "across every cohort shown": "gösterilen tüm kohortlarda",
  "across the top of the page": "sayfanın üstünde, boydan boya",
  "across this page": "bu sayfa genelinde",
  "Actions": "İşlemler",
  "Activate": "Etkinleştir",
  "Activation": "Aktivasyon",
  "Activation rate": "Aktivasyon oranı",
  "Active": "Aktif",
  "Active orders": "Aktif siparişler",
  "Active right now": "Şu anda aktif",
  "Active Stores": "Aktif mağazalar",
  "Activity, last 50": "Etkinlik, son 50",
  "ad set, audience…": "reklam seti, hedef kitle…",
  "Add": "Ekle",
  "Add a product": "Ürün ekle",
  "Add an item…": "Ürün ekle…",
  "Add at least one choice to the combo": "Komboya en az bir seçim ekleyin",
  "Add Code": "Kod ekle",
  "Add Common Products": "Ortak ürünleri ekle",
  "Add Date": "Tarih ekle",
  "Add item": "Kalem ekle",
  "Add Line": "Satır ekle",
  "Add link": "Bağlantı ekle",
  "Add more": "Daha fazla ekle",
  "Add New Stock": "Yeni stok ekle",
  "Add New Vendor": "Yeni tedarikçi ekle",
  "Add or remove: {0}": "Ekle veya kaldır: {0}",
  "Add Pattern": "Tekrar düzeni ekle",
  "Add pictures": "Görsel ekle",
  "Add Recurring Patterns": "Tekrar düzenleri ekle",
  "Add the other page": "Diğer sayfayı ekle",
  "Add to": "Şuraya ekle:",
  "Add {0}": "Ekle",
  "Added between": "Eklenme aralığı",
  "Added item(s)": "Eklenen ürün(ler)",
  "Added Reports": "Ekleme raporları",
  "Added Reports (old)": "Ekleme raporları (eski)",
  "added to stock on {0}.": "{0} tarihinde stoğa eklendi.",
  "Added {0} points.": "{0} puan eklendi.",
  "ADDITIONAL": "EK",
  "Address": "Adres",
  "address": "adres",
  "Address cannot be empty!": "Adres boş olamaz!",
  "Address of the story's page": "Hikaye sayfasının adresi",
  "Admin Notes": "Yönetici notları",
  "After": "Sonra",
  "after discount; no tax, tips, delivery fees or deposits": "indirim sonrası; vergi, bahşiş, teslimat ücretleri ve depozitolar hariç",
  "again to {0} at the time you pick, and at every repeat. The original stays as it is.": "bildirimini seçtiğiniz saatte ve her tekrarda yeniden şu kitleye gönderir: {0}. Orijinali olduğu gibi kalır.",
  "against": "bölü",
  "AI conversations": "AI sohbetleri",
  "AI image prompt": "AI görsel istemi",
  "AI Panel": "AI paneli",
  "All": "Tümü",
  "ALL": "TÜMÜ",
  "All categories": "Tüm kategoriler",
  "all clear": "her şey yolunda",
  "All Customers": "Tüm müşteriler",
  "All deals": "Tüm kampanyalar",
  "All locations": "Tüm mağazalar",
  "all locations": "tüm mağazalar",
  "ALL OPTIONS": "TÜM SEÇENEKLER",
  "All Products": "Tüm ürünler",
  "ALL PRODUCTS": "TÜM ÜRÜNLER",
  "All segments": "Tüm segmentler",
  "All Services": "Tüm hizmetler",
  "All stores": "Tüm mağazalar",
  "All Stores": "Tüm mağazalar",
  "All stores ranked side-by-side — heat-colored by performance": "Tüm mağazalar yan yana sıralı — performansa göre renklendirilmiş",
  "All stores: {0} of {1} stores added together.": "Tüm mağazalar: {1} mağazadan {0} tanesinin toplamı.",
  "All stores: {0} stores added together.": "Tüm mağazalar: {0} mağazanın toplamı.",
  "All time": "Tüm zamanlar",
  "All {0} stores": "Tüm {0} mağazaları",
  "all-time spend across the base": "tüm müşteri tabanının bugüne kadarki harcaması",
  "Allow the microphone for this site to talk with Connect.": "Connect ile konuşmak için bu siteye mikrofon izni verin.",
  "Allowed sizes": "İzin verilen boylar",
  "Already paid": "Zaten ödendi",
  "Also show it in the app's Special Offers carousel on the home screen": "Uygulamanın ana ekranındaki Special Offers (Özel Teklifler) karuselinde de göster",
  "Also waiting for this story:": "Bu hikaye için bekleyen diğer istekler:",
  "Amount": "Tutar",
  "AMOUNT": "TUTAR",
  "amount content": "tutar içeriği",
  "an administrator": "bir yönetici",
  "An animated orb as one more look in the AI host's mode picker.": "AI asistanının mod seçicisinde ek bir görünüm olarak hareketli bir küre.",
  "An error occurred": "Bir hata oluştu",
  "An error occurred while copying menus.": "Menüler kopyalanırken bir hata oluştu.",
  "an item": "bir ürün",
  "Analytics counts an order the moment it is paid for; we count it after cancellations, so it running a shade above 100% is expected rather than alarming. This row is also the only thing that would catch the Analytics property being switched to another timezone, which nothing else on this page could detect.": "Analytics bir siparişi ödendiği anda sayar; biz ise iptallerden sonra sayarız, bu yüzden oranın %100'ün biraz üzerinde çıkması endişe verici değil, beklenen bir durumdur. Bu satır, Analytics mülkünün başka bir saat dilimine geçirilmesini yakalayabilecek tek şeydir; bu sayfadaki başka hiçbir şey bunu fark edemez.",
  "and": "ve",
  "another of the same": "aynı ürün",
  "Another Pattern": "Bir düzen daha",
  "Answer five short questions. The deal is created switched OFF, so nothing reaches customers until you turn it on from the Dashboard.": "Beş kısa soruyu yanıtlayın. Kampanya KAPALI olarak oluşturulur; siz Pano'dan açana kadar müşterilere hiçbir şey ulaşmaz.",
  "any": "herhangi bir",
  "Any": "Herhangi biri",
  "Any 14\" pizza + 1 dessert + 2 pops for $35.99": "Herhangi bir 14\" pizza + 1 tatlı + 2 gazlı içecek, $35.99 fiyatına",
  "Any dates, compared with the days before them and with the same days last year": "İstediğiniz tarihler; önceki günlerle ve geçen yılın aynı günleriyle karşılaştırmalı",
  "Any day": "Herhangi bir gün",
  "Any deal can also go in the app's home-screen carousel — you tick that in step 4. The picture banners on the website's Deals page are managed under Marketing → Banners, not here.": "Her kampanya uygulamanın ana ekran karuselinde de yer alabilir — bunu 4. adımda işaretlersiniz. Web sitesinin Kampanyalar sayfasındaki görselli banner'lar burada değil, Pazarlama → Banner'lar altında yönetilir.",
  "any item": "herhangi bir ürün",
  "Any two dates you choose": "Seçtiğiniz herhangi iki tarih arası",
  "anything named “{0}”": "adında “{0}” geçen ürün",
  "anything on the menu": "menüdeki herhangi bir ürün",
  "APP": "UYGULAMA",
  "App": "Uygulama",
  "App AI": "Uygulama AI",
  "App AI · publish": "Uygulama AI · yayımla",
  "App Banner Image": "Uygulama banner görseli",
  "APP ORDERS": "UYGULAMA SİPARİŞLERİ",
  "App orders stay out of the top": "Uygulama siparişleri payın dışında kalır",
  "Appears as “This deal adds: …” in the cart.": "Sepette “This deal adds: …” (Bu kampanya şunu ekler: …) olarak görünür.",
  "Applied at checkout": "Ödeme adımında uygulanır",
  "Apply": "Uygula",
  "Apply it at the store selected in the panel (or the first one), check it, then apply the rest": "Önce panelde seçili mağazada (ya da ilkinde) uygulayın, kontrol edin, sonra kalanlara uygulayın",
  "Apply the rest: {0}": "Kalanlara uygula: {0}",
  "Approval": "Onay",
  "Approvals": "Onaylar",
  "Approve": "Onayla",
  "Approve creation #{0}?": "Kreasyon #{0} onaylansın mı?",
  "Approve it and put it on the website now?": "Onaylanıp hemen web sitesinde yayımlansın mı?",
  "Approve it and run it now?": "Onaylanıp hemen çalıştırılsın mı?",
  "Approve it and take the story off the website now?": "Onaylanıp yazı hemen web sitesinden kaldırılsın mı?",
  "Approve photo": "Fotoğrafı onayla",
  "Approve the customer photo on #{0}?": "Kreasyon #{0} için müşteri fotoğrafı onaylansın mı?",
  "Approve “{0}”?": "“{0}” bildirimi onaylansın mı?",
  "Approved": "Onaylandı",
  "approved": "onaylandı",
  "Approved — it goes out to customers at its scheduled time.": "Onaylandı — planlanan zamanda müşterilere gönderilecek.",
  "Approved — the role is assigned.": "Onaylandı — rol atandı.",
  "Approved.": "Onaylandı.",
  "Approve…": "Onayla…",
  "approx weight": "yaklaşık ağırlık",
  "Are you sure you want to delete this coupon?": "Bu kuponu silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this delivery area?": "Bu teslimat bölgesini silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this group?": "Bu grubu silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this invoice?": "Bu faturayı silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this menu?": "Bu menüyü silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this option item?": "Bu seçeneği silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this product?": "Bu ürünü silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this stock audit?": "Bu stok denetimini silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this stock?": "Bu stoğu silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this this vendor?": "Bu tedarikçiyi silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this user?": "Bu kullanıcıyı silmek istediğinizden emin misiniz?",
  "Are you sure you want to send this SMS to all brand customers?": "Bu SMS'i markanın tüm müşterilerine göndermek istediğinizden emin misiniz?",
  "Are you sure you want to send this SMS to all selected store customers?": "Bu SMS'i seçili mağazaların tüm müşterilerine göndermek istediğinizden emin misiniz?",
  "ARRIVED": "GELEN",
  "As a check, the same rate computed entirely inside Google Analytics for {0} days from {1} is": "Kontrol olarak, {1} tarihinden itibaren {0} gün boyunca tamamen Google Analytics içinde hesaplanan aynı oran",
  "As soon as it is on": "Açılır açılmaz",
  "Ask before changes: Off": "Değişikliklerden önce sor: Kapalı",
  "Ask before changes: On": "Değişikliklerden önce sor: Açık",
  "Ask Connect… Enter to send": "Connect'e sorun… Enter ile gönderin",
  "Ask for a role": "Rol iste",
  "Ask out loud in any language. It answers by voice.": "Herhangi bir dilde sesli sorun. Sesli yanıt verir.",
  "Ask out loud in any language; it answers by voice.": "Herhangi bir dilde sesli sorun; sesli yanıt verir.",
  "Ask to delete “{0}”?": "“{0}” için silme isteği gönderilsin mi?",
  "Ask to delete…": "Silinmesini iste…",
  "Asked for": "İstenen",
  "assistant": "asistan",
  "Assistant": "Asistan",
  "At every store.": "Tüm mağazalarda.",
  "At least this many in the cart": "Sepette en az bu kadar",
  "At Risk": "Risk altında",
  "At risk": "Risk altında",
  "at Stock list prices": "Stok listesi fiyatlarıyla",
  "At the time this goes out the deal is not running (its dates, days or hours), so checkout will not apply it.": "Bu gönderildiği anda kampanya geçerli değil (tarihleri, günleri veya saatleri nedeniyle); bu yüzden ödeme adımında uygulanmaz.",
  "at {0}": "· {0}",
  "ATLAS": "ATLAS",
  "Atlas could not be opened.": "Atlas açılamadı.",
  "Atlas's AI Studio and archive, signed in as you": "Atlas'ın AI Studio'su ve arşivi; sizin hesabınızla giriş yapılmış olarak",
  "Atlas's SMS panel, signed in as you": "Atlas'ın SMS paneli; sizin hesabınızla giriş yapılmış olarak",
  "Attach an image (JPEG or PNG)": "Görsel ekle (JPEG veya PNG)",
  "Attached to the items you pick. Customers see the badge on those items in the menu, a nudge in the cart, and the deal on the Deals page.": "Seçtiğiniz ürünlere bağlıdır. Müşteriler menüde bu ürünlerin üzerinde rozeti, sepette teşvik edici bir mesajı ve Kampanyalar sayfasında kampanyayı görür.",
  "Attempts": "Denemeler",
  "ATTEMPTS": "DENEMELER",
  "Audits": "Denetimler",
  "Audits (old)": "Denetimler (eski)",
  "Automation": "Otomasyon",
  "Availability Settings": "Uygunluk ayarları",
  "Available groups ({0}) were left empty.": "Seçilebilir gruplar ({0}) boş bırakıldı.",
  "AVERAGE": "ORTALAMA",
  "average across the window": "dönem ortalaması",
  "Average Hourly Sales — {0}": "Saatlik ortalama satış — {0}",
  "Average order value": "Ortalama sipariş tutarı",
  "Average order, 7 days": "Ortalama sipariş, 7 gün",
  "AVERAGE TICKET": "ORTALAMA SEPET",
  "AVG (PERIOD)": "ORT. (DÖNEM)",
  "AVG DAILY SALES": "ORT. GÜNLÜK SATIŞ",
  "AVG ITEM PRICE": "ORT. ÜRÜN FİYATI",
  "Avg order": "Ort. sipariş",
  "AVG ORDER": "ORT. SİPARİŞ",
  "AVG PRICE": "ORT. FİYAT",
  "avg ticket": "ortalama sepet",
  "Avg ticket": "Ortalama sepet",
  "AVG TICKET": "ORTALAMA SEPET",
  "Avg Ticket Trend": "Ortalama sepet trendi",
  "Avg Ticket Trend Error": "Ortalama sepet trendi hatası",
  "AVG TICKET {0}": "ORTALAMA SEPET {0}",
  "Avg wait": "Ort. bekleme",
  "avg {0}": "ort. {0}",
  "avg. {0}": "ort. {0}",
  "B": "B",
  "Back": "Geri",
  "Back to deals": "Kampanyalara dön",
  "Badge on the free item": "Ücretsiz üründe rozet",
  "Badge on the items": "Ürünlerde rozet",
  "Bag Product": "Poşet ürünü",
  "banner": "banner",
  "Banner": "Banner",
  "Banner created successfully.": "Banner oluşturuldu.",
  "Banner Type": "Banner türü",
  "Banner updated successfully.": "Banner güncellendi.",
  "Banners": "Banner'lar",
  "Barcode": "Barkod",
  "Barcode cannot be empty!": "Barkod boş olamaz!",
  "Base": "Taban",
  "Base price": "Taban fiyat",
  "BASE UNIT": "TEMEL BİRİM",
  "Based on the order total, not on an item. No badge in the menu — customers see a progress nudge in the cart (“Add $12 more…”) and the deal on the Deals page.": "Bir ürüne değil, sipariş toplamına bağlıdır. Menüde rozet yoktur — müşteriler sepette bir ilerleme mesajı (“Add $12 more…”) ve Kampanyalar sayfasında kampanyayı görür.",
  "Basic Information": "Temel bilgiler",
  "BASIS": "MATRAH",
  "Beer": "Bira",
  "Before": "Önceki hali",
  "before tax": "vergi öncesi",
  "before tax, the customer gets this for free:": "vergi hariç olduğunda müşteri şunu ücretsiz alır:",
  "before tax.": "vergi hariç.",
  "Before this can be saved:": "Kaydedebilmek için önce:",
  "being prepared": "hazırlanıyor",
  "Below target": "Hedefin altında",
  "BELOW TARGET": "HEDEFİN ALTINDA",
  "between open and {0}": "açılış ile {0} arası",
  "Between the last two counts, with everything that arrived in between added in. No recipes are involved — this is simply what went missing from the shelf, which is the number that says how much to order.": "Son iki sayım arası, aradaki tüm gelenler de eklenerek. Tarifler işin içinde değildir — bu yalnızca raftan eksilen miktardır; ne kadar sipariş verileceğini söyleyen sayı da budur.",
  "between {0} and close": "{0} ile kapanış arası",
  "between {0} and {1}": "{0} ile {1} arası",
  "Big text on the deal card.": "Kampanya kartındaki büyük yazı.",
  "Billing Address cannot be empty": "Fatura adresi boş olamaz",
  "Bills and invoices": "Fiş ve faturalar",
  "blank": "boş",
  "block is normal for a brand with a long tail of one-time guests — those people were never really retained. The rows worth spending money on are": "bloğu, tek seferlik misafirlerden oluşan uzun bir kuyruğu olan markalar için normaldir — bu kişiler hiçbir zaman gerçekten elde tutulmamıştı. Para harcamaya değer satırlar",
  "Body": "Metin",
  "Bold": "Kalın",
  "Both empty = all day. Example: 17:00 to 21:00 for an evening-only deal. A window that passes midnight (22:00 to 02:00) works too.": "İkisi de boş = tüm gün. Örnek: yalnızca akşam geçerli bir kampanya için 17:00 ile 21:00 arası. Gece yarısını geçen bir aralık (22:00 ile 02:00 arası) da çalışır.",
  "Bottom picture": "Alt görsel",
  "bottom picture": "alt görsel",
  "Boxing Status": "Kutulama durumu",
  "Branch Settings": "Mağaza ayarları",
  "BRAND": "MARKA",
  "Brand": "Marka",
  "Brand Menu": "Marka menüsü",
  "BRAND'S MENU": "MARKA MENÜSÜ",
  "Brand-wide, whatever the location picker says. The seven-day figures cover the seven complete days ending yesterday, so today is never counted twice or plotted half-finished. Sales are net, as the POS reports them: after discounts, without tax, tips, delivery fees or bottle deposits, on the day the order was closed out. Uber, DoorDash and Skip are not included.": "Mağaza seçicide ne seçili olursa olsun marka geneli. Yedi günlük rakamlar dünle biten son yedi tam günü kapsar; böylece bugün asla iki kez sayılmaz ya da yarım çizilmez. Satışlar POS'un bildirdiği gibi nettir: indirimler düşülmüş; vergi, bahşiş, teslimat ücretleri ve şişe depozitoları hariç; siparişin kapatıldığı güne göre. Uber, DoorDash ve Skip dahil değildir.",
  "Breadcrumb": "Sayfa yolu",
  "Bring it back": "Geri getir",
  "Bronze": "Bronz",
  "Bronze is where everyone starts. Each tier needs at least what the tier before it needs; only the measure chosen here decides the tier.": "Herkes Bronz seviyeden başlar. Her seviye en az bir önceki seviye kadar şart ister; seviyeyi yalnızca burada seçilen ölçüt belirler.",
  "Build": "Oluştur",
  "Build a deal, switch it on, see what it gave away": "Kampanya kurun, açın, ne kadar indirim verdiğini görün",
  "Build a set of permissions and give it a name": "Bir yetki kümesi oluşturun ve ona bir ad verin",
  "Build a trackable link for a post or an email": "Bir gönderi ya da e-posta için izlenebilir bağlantı oluşturun",
  "Build campaign URLs, and see what the campaign actually did": "Kampanya URL'leri oluşturun ve kampanyanın gerçekte ne getirdiğini görün",
  "Build links": "Bağlantı oluştur",
  "Building…": "Oluşturuluyor…",
  "Built-in role. It cannot be edited, only copied.": "Yerleşik rol. Düzenlenemez, yalnızca kopyalanabilir.",
  "Bulleted list": "Madde işaretli liste",
  "Bundle": "Birlikte al",
  "Busiest hours": "En yoğun saatler",
  "BUSIEST SLOT": "EN YOĞUN DİLİM",
  "busy": "yoğun",
  "Button text": "Düğme metni",
  "button text": "düğme metni",
  "Button text on the card": "Karttaki düğme metni",
  "Buy 2 pizzas, get the 2nd free": "2 pizza al, ikincisi ücretsiz",
  "Buy a large pizza, add a pop free": "Büyük boy pizza al, yanına gazlı içecek ücretsiz",
  "Buy some, get one": "Birkaç al, bir tane kazan",
  "BUYERS": "ALICILAR",
  "Buying certain items adds another item free or discounted.": "Belirli ürünler alındığında başka bir ürün ücretsiz ya da indirimli olarak eklenir.",
  "Buying {0} of {1} adds {2} at no charge (up to {3}).": "{0} adet {1} alındığında {2} ücretsiz eklenir (en fazla {3} adet).",
  "Buying {0} of {1} adds {2} at no charge.": "{0} adet {1} alındığında {2} ücretsiz eklenir.",
  "Buying {0} of {1} adds {2} at {3}% off (up to {4}).": "{0} adet {1} alındığında {2} %{3} indirimle eklenir (en fazla {4} adet).",
  "Buying {0} of {1} adds {2} at {3}% off.": "{0} adet {1} alındığında {2} %{3} indirimle eklenir.",
  "by": "yapan",
  "by default, the way Sysco delivers them — the case size on each line comes from the order guide, so there is no need to work anything out in kilos. Switch a line to its own unit if a case was split.": "cinsindendir (varsayılan olarak), tıpkı Sysco'nun teslim ettiği gibi — her satırdaki koli büyüklüğü sipariş kılavuzundan gelir, bu yüzden kilo hesabı yapmanız gerekmez. Bir koli bölündüyse o satırı kendi birimine çevirin.",
  "By e-mail, phone, name or customer number. Open one to see their points history or to give some back.": "E-posta, telefon, ad veya müşteri numarasıyla. Puan geçmişini görmek ya da puan iade etmek için birini açın.",
  "By Order Source": "Sipariş kaynağına göre",
  "By send time, newest first": "Gönderim saatine göre, en yeni önce",
  "By send time, oldest first": "Gönderim saatine göre, en eski önce",
  "By store": "Mağazaya göre",
  "By store — {0}": "Mağazaya göre — {0}",
  "by {0}": "({0} tarafından)",
  "by {0} · {1}": "isteyen: {0} · {1}",
  "by {0} · {1} — goes out to customers at {2}": "{0} tarafından · {1} — müşterilere {2} tarihinde gönderilir",
  "by {0} · {1} — goes out to customers on the sender’s next run": "{0} tarafından · {1} — müşterilere gönderim görevinin bir sonraki çalışmasında gönderilir",
  "By {0}; the bar is each one's share of the leader's.": "Ölçüt: {0}; çubuk, her birinin liderinkine oranını gösterir.",
  "Calendar": "Takvim",
  "Calories": "Kalori",
  "Came back after a gap.": "Bir aradan sonra geri döndü.",
  "came back the month after joining": "katıldıktan sonraki ay geri geldi",
  "Campaign": "Kampanya",
  "CAMPAIGN": "KAMPANYA",
  "Campaign links": "Kampanya bağlantıları",
  "Campaign outcomes": "Kampanya sonuçları",
  "Campaign Performance Error": "Kampanya performansı hatası",
  "Campaign Title": "Kampanya başlığı",
  "Campaign title is required": "Kampanya başlığı gerekli",
  "CAMPAIGNS SEEN": "GÖRÜLEN KAMPANYALAR",
  "can tell one offer from another.": "sütunu ayırt edebilir.",
  "Canadian": "Kanada ürünü",
  "Cancel": "İptal",
  "Cancel this session for everyone?": "Bu oturum herkes için iptal edilsin mi?",
  "Cancelled": "İptal edildi",
  "Cannot change once the deal exists — orders reference it.": "Kampanya oluşturulduktan sonra değiştirilemez — siparişler bu anahtara bağlı.",
  "Cannot get coupon product list.": "Kupon ürün listesi alınamadı.",
  "Card colour": "Kart rengi",
  "Card picture": "Kart görseli",
  "card picture": "kart görseli",
  "Card, cash and the rest": "Kart, nakit ve diğerleri",
  "Carousel icon name": "Karusel simge adı",
  "CARRYOUT": "GEL-AL",
  "Cart nudge": "Sepet mesajı",
  "Cart progress nudge": "Sepet ilerleme mesajı",
  "Cart was updated": "Sepet güncellendi",
  "case": "koli",
  "CASE": "CASE",
  "CASE PRICE": "CASE FİYATI",
  "cases": "koli",
  "Cases": "Vakalar",
  "Cashier": "Kasiyer",
  "Cashier/Manager": "Kasiyer/Müdür",
  "Catch weight": "Değişken ağırlık",
  "CATEGORY": "KATEGORİ",
  "Category mix": "Kategori dağılımı",
  "cell is a month that cohort has not lived through yet. The two used to look identical, which made a real zero read as missing data.": "hücre ise o kohortun henüz yaşamadığı bir aydır. İkisi eskiden aynı görünüyordu; bu da gerçek bir sıfırın eksik veri gibi okunmasına yol açıyordu.",
  "Champion": "Şampiyon",
  "Change": "Değiştir",
  "CHANGE": "DEĞİŞİM",
  "Change it": "Değiştir",
  "Change something": "Bir şeyi değiştir",
  "Change the menu": "Menüyü değiştir",
  "changed in the panel": "panelde değiştirildi",
  "Changes apply the moment you save — this deal is {0}.": "Değişiklikler kaydettiğiniz anda geçerli olur — bu kampanya {0}.",
  "changes as you type": "yazdıkça değişir",
  "CHANNEL": "KANAL",
  "Channel Breakdown": "Kanal dağılımı",
  "Channel Detail": "Kanal ayrıntısı",
  "Channel Distribution by Store": "Mağazaya göre kanal dağılımı",
  "Channel Mix Error": "Kanal dağılımı hatası",
  "Channels": "Kanallar",
  "Channels ›": "Kanallar ›",
  "Chart": "Grafik",
  "Chat": "Sohbet",
  "Chat is not installed on this server yet.": "Sohbet bu sunucuda henüz kurulu değil.",
  "check": "kontrol et",
  "Check & save": "Kontrol et & kaydet",
  "Check and create": "Kontrol et ve oluştur",
  "Check and finish": "Kontrol et ve bitir",
  "Check and save": "Kontrol et ve kaydet",
  "Check on the stores": "Mağazaları kontrol et",
  "check this": "bunu kontrol edin",
  "Checked": "Seçili",
  "Checked out:": "Sipariş verildi:",
  "Checkout completed": "Ödeme tamamlandı",
  "Chicken": "Tavuk",
  "Choice {0}": "Seçim {0}",
  "Choice {0} needs a name (e.g. “Pick a pizza”)": "Seçim {0} için bir ad gerekli (ör. “Pick a pizza”)",
  "Choice {0}: pick a category or some items": "Seçim {0}: bir kategori ya da birkaç ürün seçin",
  "Choose a date": "Bir tarih seçin",
  "Choose a deal type": "Bir kampanya türü seçin",
  "Choose a deal type in step 1 first.": "Önce 1. adımda bir kampanya türü seçin.",
  "Choose a deal type to see what customers will get.": "Müşterilerin ne alacağını görmek için bir kampanya türü seçin.",
  "Choose a deal…": "Kampanya seçin…",
  "Choose a month": "Bir ay seçin",
  "Choose a picture": "Resim seç",
  "Choose a picture from this computer": "Bu bilgisayardan görsel seç",
  "Choose a product…": "Ürün seçin…",
  "Choose a store special…": "Mağazaya özel ürün seçin…",
  "Choose a week": "Bir hafta seçin",
  "Choose an image": "Bir görsel seçin",
  "Choose another picture": "Başka bir görsel seç",
  "Choose the dates": "Tarihleri seçin",
  "Choose the free item": "Ücretsiz ürünü seçin",
  "Choose what is added to the order": "Siparişe eklenecek ürünü seçin",
  "Choose…": "Seçin…",
  "chosen items": "seçilen ürünler",
  "Churn": "Kayıp riski",
  "CHURN": "KAYIP RİSKİ",
  "Clear": "Temizle",
  "Clear the filters": "Filtreleri temizle",
  "Clear this conversation": "Bu sohbeti temizle",
  "Clear this conversation?": "Bu sohbet temizlensin mi?",
  "Clear {0} not approved": "Onaylanmayan {0} bildirimi temizle",
  "Click a store to open its stock on hand. Stock value uses the prices on the Stock list, and \"To order\" is the same suggestion each store sees on its Reorder page.": "Eldeki stoğunu açmak için bir mağazaya tıklayın. Stok değeri Stok listesindeki fiyatları kullanır; \"Sipariş edilecek\" ise her mağazanın kendi Yeniden sipariş sayfasında gördüğü önerinin aynısıdır.",
  "Click to upload image": "Görsel yüklemek için tıklayın",
  "Clickable": "Tıklanabilir",
  "Clickable Link": "Tıklanabilir bağlantı",
  "Close": "Kapat",
  "Close {0}": "Kapat: {0}",
  "CLOSED": "KAPANIŞ",
  "Closed": "Kapandı",
  "Closed: {0}": "Kapatıldı: {0}",
  "Closing": "Kapanış",
  "Closing text": "Kapanış metni",
  "closing text": "kapanış metni",
  "Code": "Kod",
  "CODE": "KOD",
  "CODE ATTEMPTS": "KOD DENEMELERİ",
  "CODE CARRIED, NOT APPLIED": "KOD GETİRİLDİ, UYGULANMADI",
  "COHORT": "KOHORT",
  "Cohort triangle": "Kohort üçgeni",
  "Cohorts are rebuilt nightly; check back after the next run.": "Kohortlar her gece yeniden oluşturulur; bir sonraki çalışmadan sonra tekrar bakın.",
  "COHORTS TRACKED": "İZLENEN KOHORTLAR",
  "Collapse the menu": "Menüyü daralt",
  "COLLECTED": "TAHSİL EDİLEN",
  "columns are empty for all of them. Until that changes, only": "sütunları hepsi için boştur. Bu değişene kadar teklifleri birbirinden yalnızca",
  "Combo": "Kombo",
  "Combo builder screen": "Kombo oluşturma ekranı",
  "Coming soon": "Çok yakında",
  "Commands": "Komutlar",
  "Comment": "Yorum",
  "Company": "Firma",
  "Company Address": "Firma adresi",
  "Company cannot be empty": "Firma boş olamaz",
  "Company E-mail": "Firma e-postası",
  "compared with {0}, and with {1} a year ago, on the same weekdays": "{0} ve bir yıl önceki {1} ile aynı hafta günleri bazında karşılaştırma",
  "Completed": "Tamamlandı",
  "Complimentary": "İkram",
  "Confirm": "Onayla",
  "Confirmed": "Onaylandı",
  "Confirmed by store": "Mağaza onayladı",
  "Connect": "Connect",
  "Connect change": "Connect değişikliği",
  "Connect changes waiting": "Bekleyen Connect değişiklikleri",
  "Connect could not answer just now.": "Connect şu anda yanıt veremedi.",
  "Connect could not answer.": "Connect yanıt veremedi.",
  "Connect could not reach the voice service.": "Connect ses servisine ulaşamadı.",
  "Connect is speaking": "Connect konuşuyor",
  "Connect is thinking…": "Connect düşünüyor…",
  "Connect Panel": "Connect Panel",
  "Connect proposes": "Connect öneriyor",
  "Connect, the assistant": "Connect, asistanınız",
  "Connect, the assistant: ask it anything about the panel": "Connect, asistanınız: panelle ilgili her şeyi sorun",
  "Connecting…": "Bağlanıyor…",
  "Connect’s Deliveries page has {0} {1} for this month ({2}).": "Connect’in Teslimatlar sayfasında bu ay için {0} fatura var ({2}).",
  "Connect’s sales for this month changed since you checked them (late orders were closed out). Please look at them again.": "Connect’in bu ayki satışları siz kontrol ettikten sonra değişti (geç gelen siparişler kapatıldı). Lütfen bunlara yeniden bakın.",
  "Contact": "İletişim",
  "CONTACT": "İLETİŞİM",
  "Continue the sync": "Eşitlemeye devam et",
  "Conversations could not be loaded.": "Sohbetler yüklenemedi.",
  "Conversion Error": "Dönüşüm hatası",
  "Conversion rate": "Dönüşüm oranı",
  "Conversions": "Dönüşümler",
  "Cooking Time (secs)": "Pişirme süresi (sn)",
  "Copied": "Kopyalandı",
  "Copy": "Kopyala",
  "Copy all": "Tümünü kopyala",
  "Copy Menu": "Menüyü kopyala",
  "Copy Menus": "Menüleri kopyala",
  "Copy Product": "Ürünü kopyala",
  "Copy this role": "Bu rolü kopyala",
  "Copying...": "Kopyalanıyor...",
  "COST": "MALİYET",
  "Cost": "Maliyet",
  "Cost: {0}": "Maliyet: {0}",
  "Could not apply the rest just now.": "Geri kalanı şu anda uygulanamadı.",
  "Could not apply the rest.": "Geri kalanı uygulanamadı.",
  "Could not approve the proposal.": "Öneri onaylanamadı.",
  "Could not approve.": "Onaylanamadı.",
  "Could not build links": "Bağlantılar oluşturulamadı",
  "Could not change banner status.": "Banner durumu değiştirilemedi.",
  "Could not change that just now.": "Bu şu anda değiştirilemedi.",
  "Could not change that.": "Bu ayar değiştirilemedi.",
  "Could not change the deal status.": "Kampanya durumu değiştirilemedi.",
  "Could not change the model just now.": "Model şu anda değiştirilemedi.",
  "Could not change the model.": "Model değiştirilemedi.",
  "Could not change the points.": "Puanlar değiştirilemedi.",
  "Could not change the role.": "Rol değiştirilemedi.",
  "Could not clear the conversation.": "Sohbet temizlenemedi.",
  "Could not close the session.": "Oturum kapatılamadı.",
  "Could not confirm the order.": "Sipariş onaylanamadı.",
  "Could not copy product": "Ürün kopyalanamadı",
  "Could not create the group.": "Grup oluşturulamadı.",
  "Could not delete banner.": "Banner silinemedi.",
  "Could not delete notification.": "Bildirim silinemedi.",
  "Could not delete that file just now.": "Bu dosya şu anda silinemedi.",
  "Could not delete that file.": "Bu dosya silinemedi.",
  "Could not delete the deal.": "Kampanya silinemedi.",
  "Could not delete the group.": "Grup silinemedi.",
  "Could not delete the message.": "Mesaj silinemedi.",
  "Could not delete the role.": "Rol silinemedi.",
  "Could not do that just now.": "Bu işlem şu anda yapılamadı.",
  "Could not do that.": "Bu işlem yapılamadı.",
  "Could not encrypt the message.": "Mesaj şifrelenemedi.",
  "Could not get the file just now.": "Dosya şu anda alınamadı.",
  "Could not load creations.": "Kreasyonlar yüklenemedi.",
  "Could not load deals.": "Kampanyalar yüklenemedi.",
  "Could not load earlier messages.": "Önceki mesajlar yüklenemedi.",
  "Could not load featured products.": "Öne çıkan ürünler yüklenemedi.",
  "Could not load group orders.": "Grup siparişleri yüklenemedi.",
  "Could not load live orders.": "Canlı siparişler yüklenemedi.",
  "Could not load notifications.": "Bildirimler yüklenemedi.",
  "Could not load performance data.": "Performans verileri yüklenemedi.",
  "Could not load proposals.": "Öneriler yüklenemedi.",
  "Could not load roles.": "Roller yüklenemedi.",
  "Could not load targeting.": "Hedefleme yüklenemedi.",
  "Could not load that person's stores.": "Bu kişinin mağazaları yüklenemedi.",
  "Could not load the conversation.": "Sohbet yüklenemedi.",
  "Could not load the creation.": "Kreasyon yüklenemedi.",
  "Could not load the customer's points.": "Müşterinin puanları yüklenemedi.",
  "Could not load the deal.": "Kampanya yüklenemedi.",
  "Could not load the notification.": "Bildirim yüklenemedi.",
  "Could not load the order list.": "Sipariş listesi yüklenemedi.",
  "Could not load the order.": "Sipariş yüklenemedi.",
  "Could not load the permission list.": "Yetki listesi yüklenemedi.",
  "Could not load the product list.": "Ürün listesi yüklenemedi.",
  "Could not load the request.": "Talep yüklenemedi.",
  "Could not load the session.": "Oturum yüklenemedi.",
  "Could not load the story.": "Yazı yüklenemedi.",
  "Could not load users.": "Kullanıcılar yüklenemedi.",
  "Could not load your files just now.": "Dosyalarınız şu anda yüklenemedi.",
  "Could not load your files.": "Dosyalarınız yüklenemedi.",
  "Could not make the channel key.": "Kanal anahtarı oluşturulamadı.",
  "Could not make the file in this browser.": "Dosya bu tarayıcıda oluşturulamadı.",
  "Could not mark the order paid.": "Sipariş ödendi olarak işaretlenemedi.",
  "Could not prepare that just now.": "Bu şu anda hazırlanamadı.",
  "Could not prepare that.": "Bu işlem hazırlanamadı.",
  "Could not reach the blog service. It may not be installed on this server yet.": "Blog servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the creations service. It may not be installed on this server yet.": "Kreasyon servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the featured-products service. It may not be installed on this server yet.": "Öne çıkan ürünler servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the group-orders service. It may not be installed on this server yet.": "Grup siparişleri servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the live-orders service. It may not be installed on this server yet.": "Canlı siparişler servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the loyalty service.": "Sadakat servisine ulaşılamadı.",
  "Could not reach the permissions service. It may not be installed on this server yet.": "Yetkiler servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the server just now.": "Şu anda sunucuya ulaşılamadı.",
  "Could not reach the server.": "Sunucuya ulaşılamadı.",
  "Could not reject the proposal.": "Öneri reddedilemedi.",
  "Could not reject.": "Reddedilemedi.",
  "Could not remove it.": "Kaldırılamadı.",
  "Could not reorder banner.": "Banner'ın sırası değiştirilemedi.",
  "Could not reschedule.": "Yeniden planlanamadı.",
  "Could not resolve the request.": "Talep sonuçlandırılamadı.",
  "Could not retry just now.": "Şu anda yeniden denenemedi.",
  "Could not save": "Kaydedilemedi",
  "Could not save rates": "Oranlar kaydedilemedi",
  "Could not save targeting.": "Hedefleme kaydedilemedi.",
  "Could not save the deal.": "Kampanya kaydedilemedi.",
  "Could not save the loyalty rules.": "Sadakat kuralları kaydedilemedi.",
  "Could not save the role.": "Rol kaydedilemedi.",
  "Could not save the settings.": "Ayarlar kaydedilemedi.",
  "Could not save the stores.": "Mağazalar kaydedilemedi.",
  "Could not search customers.": "Müşteri araması yapılamadı.",
  "Could not send notification.": "Bildirim gönderilemedi.",
  "Could not send the message.": "Mesaj gönderilemedi.",
  "Could not send the request.": "Talep gönderilemedi.",
  "Could not set up the encryption in this browser.": "Bu tarayıcıda şifreleme kurulamadı.",
  "Could not submit": "Gönderilemedi",
  "Could not test notification.": "Bildirim test edilemedi.",
  "Could not update the creation.": "Kreasyon güncellenemedi.",
  "Could not update the photo.": "Fotoğraf güncellenemedi.",
  "Count not saved": "Sayım kaydedilmedi",
  "Count submitted": "Sayım gönderildi",
  "COUNTED": "SAYILAN",
  "Counted only": "Yalnızca sayılanlar",
  "counted orders": "sayılan sipariş",
  "COUNTER & MARKETPLACE": "KASA & PAZAR YERİ",
  "counts distinct visitors doing it. With a store selected these are placed at that store by following the visitor session to the order it placed or the cart it built, so a code advertised for one store showing attempts at another is customers trying it at the wrong till. A campaign with attempts but no redemptions is being tried and refused. A campaign with no attempts at all was applied at the till or automatically, never typed — which is why its redeem rate is blank rather than zero.": "bunu yapan farklı ziyaretçileri sayar. Bir mağaza seçiliyken bunlar, ziyaretçi oturumu verdiği siparişe ya da oluşturduğu sepete kadar izlenerek o mağazaya atanır; bu yüzden bir mağaza için duyurulan bir kodun başka bir mağazada deneme göstermesi, müşterilerin kodu yanlış kasada denediği anlamına gelir. Denemesi olup kullanımı olmayan bir kampanya deneniyor ama reddediliyor demektir. Hiç denemesi olmayan bir kampanya ise kasada ya da otomatik olarak uygulanmıştır, hiç yazılmamıştır — kullanım oranının sıfır yerine boş görünmesinin nedeni budur.",
  "counts every time the code was typed into the online coupon box,": "kodun online kupon kutusuna her yazılışını sayar,",
  "Coupon": "Kupon",
  "COUPON": "KUPON",
  "coupon": "kupon",
  "Coupon Code": "Kupon kodu",
  "Coupon code cannot be empty!": "Kupon kodu boş olamaz!",
  "Coupon code is required for coupon notifications.": "Kupon bildirimleri için kupon kodu gerekli.",
  "Coupon code must be at least 6 characters!": "Kupon kodu en az 6 karakter olmalı!",
  "coupon code, e.g. LRCQ50": "kupon kodu, ör. LRCQ50",
  "Coupon code, e.g. SAVE10": "Kupon kodu, ör. SAVE10",
  "Coupon Description": "Kupon açıklaması",
  "Coupon discount cannot be empty or zero!": "Kupon indirimi boş veya sıfır olamaz!",
  "Coupon discount cannot be negative!": "Kupon indirimi negatif olamaz!",
  "Coupon has been deleted successfully!": "Kupon silindi!",
  "Coupon has been saved successfully.": "Kupon kaydedildi.",
  "Coupon has been updated successfully.": "Kupon güncellendi.",
  "Coupon Name": "Kupon adı",
  "Coupon name cannot be empty!": "Kupon adı boş olamaz!",
  "Coupon Product": "Kupon ürünü",
  "Coupon Products": "Kupon ürünleri",
  "Coupon status updated": "Kupon durumu güncellendi",
  "Coupon Title": "Kupon başlığı",
  "Coupon: {0}": "Kupon: {0}",
  "Coupons": "Kuponlar",
  "coupons": "kupon",
  "Coupons are doing the work: {0} orders used one, against {1} that used a deal.": "İşi kuponlar yapıyor: {0} siparişte kupon, buna karşılık {1} siparişte kampanya kullanıldı.",
  "Create": "Oluştur",
  "Create a code and choose where it works": "Bir kod oluşturun ve nerede geçerli olacağını seçin",
  "Create a code customers can type in at checkout": "Müşterilerin ödeme adımında girebileceği bir kod oluşturun",
  "Create a new role": "Yeni rol oluştur",
  "Create Area": "Bölge oluştur",
  "Create Audit": "Denetim oluştur",
  "Create Bag": "Poşet oluştur",
  "Create Banner": "Banner oluştur",
  "Create Coupon": "Kupon oluştur",
  "Create Coupon Item": "Kupon ürünü oluştur",
  "Create deal (stays OFF)": "Kampanyayı oluştur (KAPALI kalır)",
  "Create Invoice": "Faturayı oluştur",
  "Create Menu": "Menü oluştur",
  "Create Menuboard": "Menü ekranı oluştur",
  "Create New Notification": "Yeni bildirim oluştur",
  "Create Notification": "Bildirim oluştur",
  "Create Option Item": "Seçenek oluştur",
  "Create or change an offer, step by step": "Adım adım kampanya oluşturun veya değiştirin",
  "Create Product": "Ürün oluştur",
  "Create role": "Rol oluştur",
  "Create Screen": "Ekran oluştur",
  "Create SMS Campaign": "SMS kampanyası oluştur",
  "Create Stock": "Stok oluştur",
  "Create Template": "Şablon oluştur",
  "Create User": "Kullanıcı oluştur",
  "Create Vendor": "Tedarikçi oluştur",
  "Create your first banner to start promoting.": "Tanıtıma başlamak için ilk banner'ınızı oluşturun.",
  "Create your first push notification to get started.": "Başlamak için ilk anlık bildiriminizi oluşturun.",
  "Create {0}": "{0} adet oluştur",
  "Created": "Oluşturulma",
  "CREATED": "OLUŞTURULMA",
  "Created Date": "Oluşturulma tarihi",
  "Created:": "Oluşturulma:",
  "Creates {0} notifications: first {1}, last {2}.": "{0} bildirim oluşturur: ilki {1}, sonuncusu {2}.",
  "Creating...": "Oluşturuluyor...",
  "Creation #{0}": "Kreasyon #{0}",
  "Creation #{0} approved.": "Kreasyon #{0} onaylandı.",
  "Creation #{0} deleted.": "Kreasyon #{0} silindi.",
  "Creation #{0} flagged.": "Kreasyon #{0} işaretlendi.",
  "Creation #{0} hidden.": "Kreasyon #{0} gizlendi.",
  "Creation #{0} {1}.": "Kreasyon #{0}: {1}.",
  "Creation Time": "Oluşturulma zamanı",
  "Creations": "Kreasyonlar",
  "Creations could not be loaded.": "Kreasyonlar yüklenemedi.",
  "Creator:": "Oluşturan:",
  "CRM Analytics": "CRM analizi",
  "CRM Error": "CRM hatası",
  "Cross-Sell": "Çapraz satış",
  "Cross-Sell Manager": "Çapraz satış yöneticisi",
  "Curating: {0}": "Düzenlenen: {0}",
  "Current Image": "Mevcut görsel",
  "Current Image:": "Mevcut görsel:",
  "Current menu image": "Mevcut menü görseli",
  "Current product image": "Mevcut ürün görseli",
  "Currently featured": "Şu an öne çıkanlar",
  "currently switched off": "şu anda kapalı",
  "Custom": "Özel",
  "Custom Range Error": "Özel aralık hatası",
  "Customer": "Müşteri",
  "CUSTOMER": "MÜŞTERİ",
  "Customer #{0}": "Müşteri #{0}",
  "Customer Acquisition Error": "Müşteri kazanımı hatası",
  "customer brought a code and paid full price": "müşteri kod getirdi ama tam fiyat ödedi",
  "Customer creations": "Müşteri kreasyonları",
  "Customer Insights": "Müşteri içgörüleri",
  "Customer list": "Müşteri listesi",
  "Customer notes:": "Müşteri notları:",
  "Customer photo": "Müşteri fotoğrafı",
  "Customer Queue Screens": "Müşteri sıra ekranları",
  "Customer's real photo": "Müşterinin gerçek fotoğrafı",
  "Customers": "Müşteriler",
  "CUSTOMERS": "MÜŞTERİLER",
  "Customers build a combo for {0}: no choices yet.": "Müşteriler {0} fiyatına kendi kombolarını oluşturur: henüz seçim yok.",
  "Customers build a combo for {0}: {1}.": "Müşteriler {0} fiyatına kendi kombolarını oluşturur: {1}.",
  "Customers Error": "Müşteriler hatası",
  "customers of every store": "tüm mağazaların müşterileri",
  "customers of its stores": "kendi mağazalarının müşterileri",
  "customers of {0}": "{0} müşterileri",
  "CUSTOMERS TRACKED": "İZLENEN MÜŞTERİ",
  "Customers who buy {0} of {1} get {2} × {3} at no charge.": "{0} adet {1} alan müşteriler, {2} × {3} ücretsiz alır.",
  "Customers who buy {0} of {1} get {2} × {3} at {4}% off.": "{0} adet {1} alan müşteriler, {2} × {3} %{4} indirimle alır.",
  "Customers who stopped": "Sipariş vermeyi bırakan müşteriler",
  "Customers' tiers, points and weekly streaks; give or take back points": "Müşterilerin seviyeleri, puanları ve haftalık serileri; puan verin veya geri alın",
  "CustomerScreen name cannnot be empty!.": "Müşteri ekranı adı boş olamaz!",
  "CustomerScreen Title": "Müşteri ekranı başlığı",
  "Daily": "Günlük",
  "Daily average ticket with 7-day rolling average": "Günlük ortalama sepet ve 7 günlük hareketli ortalama",
  "Daily Avg": "Günlük ortalama",
  "DAILY AVG ORDERS": "GÜNLÜK ORT. SİPARİŞ",
  "DAILY AVG SALES": "GÜNLÜK ORT. SATIŞ",
  "Daily Avg Ticket": "Günlük ortalama sepet",
  "Daily Breakdown": "Günlük döküm",
  "Daily Online Orders Trend": "Günlük online sipariş trendi",
  "Daily Report": "Günlük rapor",
  "Daily Report Error": "Günlük rapor hatası",
  "Daily Revenue": "Günlük ciro",
  "Daily Revenue Trend": "Günlük ciro trendi",
  "Daily Revenue Trend by Channel": "Kanala göre günlük ciro trendi",
  "Daily Revenue — {0} to {1}": "Günlük ciro — {0} – {1}",
  "Daily sales for the last seven complete days, with the seven days before as a dashed line": "Son yedi tam günün günlük satışları; önceki yedi gün kesikli çizgiyle",
  "Daily Size Sales": "Günlük boy satışları",
  "Daily, weekly and monthly takings, and what sold": "Günlük, haftalık ve aylık hasılat ve neyin satıldığı",
  "DATA AS OF": "VERİ TARİHİ",
  "date": "tarih",
  "Date": "Tarih",
  "DATE": "TARİH",
  "Dates": "Tarihler",
  "Day": "Gün",
  "DAY": "GÜN",
  "day": "gün",
  "DAY BY DAY": "GÜN GÜN",
  "Day Part Error": "Gün dilimi hatası",
  "Day Part Summary": "Gün dilimi özeti",
  "Day-by-Day Breakdown": "Gün gün döküm",
  "Day-by-Day Revenue — {0}": "Gün gün ciro — {0}",
  "Day-by-Day Sales — {0}": "Gün gün satış — {0}",
  "Day:": "Gün:",
  "days": "gün",
  "DAYS IN PERIOD": "DÖNEMDEKİ GÜN",
  "days of order tracking": "günlük sipariş takibi",
  "Days of the week": "Haftanın günleri",
  "Days since": "Son siparişten beri",
  "DAYS SINCE": "SON SİPARİŞTEN BERİ",
  "days up to today": "gün, bugüne kadar",
  "days up to yesterday": "gün, düne kadar",
  "DAYS W/ DISCOUNTS": "İNDİRİMLİ GÜN",
  "Deactivate": "Devre dışı bırak",
  "deal": "kampanya",
  "Deal": "Kampanya",
  "Deal applied": "Kampanya uygulandı",
  "Deal Builder": "Kampanya oluşturucu",
  "Deal created and left OFF — switch it on when you are ready.": "Kampanya oluşturuldu ve KAPALI bırakıldı — hazır olduğunuzda açın.",
  "Deal created — it is OFF until you switch it on.": "Kampanya oluşturuldu — siz açana kadar KAPALI kalır.",
  "Deal Engine": "Kampanya motoru",
  "Deal has been removed.": "Kampanya kaldırıldı.",
  "Deal has been updated.": "Kampanya güncellendi.",
  "Deal is no longer offered.": "Kampanya artık sunulmuyor.",
  "Deal is now visible to customers.": "Kampanya artık müşterilere görünüyor.",
  "Deal title": "Kampanya başlığı",
  "Deal: {0}": "Kampanya: {0}",
  "Deals": "Kampanyalar",
  "Deals on specific items": "Belirli ürünlere yönelik kampanyalar",
  "Deals on the whole order": "Siparişin tamamına yönelik kampanyalar",
  "Deals page": "Kampanyalar sayfası",
  "Deals the engine drafted from ordering patterns. Nothing here reaches a customer until you approve it and switch it on.": "Motorun sipariş alışkanlıklarından taslak olarak hazırladığı kampanyalar. Siz onaylayıp açana kadar buradakilerin hiçbiri müşteriye ulaşmaz.",
  "Deals: {0}": "Kampanyalar: {0}",
  "Decide in Approvals": "Onaylar'da karar ver",
  "Decide which customers an offer is shown to": "Kampanyanın hangi müşterilere gösterileceğine karar verin",
  "Decide who each deal is offered to. Leave a deal untargeted and everyone sees it.": "Her kampanyanın kime sunulacağına karar verin. Bir kampanyayı hedefsiz bırakırsanız herkes görür.",
  "Decline": "Reddet",
  "Decline {0}’s request?": "{0} adlı kişinin isteği reddedilsin mi?",
  "Declined": "Reddedildi",
  "Declined.": "Reddedildi.",
  "default": "varsayılan",
  "Default": "Varsayılan",
  "Delete": "Sil",
  "DELETE ALL": "TÜMÜNÜ SİL",
  "Delete Banner": "Banner'ı sil",
  "Delete creation #{0}?": "Kreasyon #{0} silinsin mi?",
  "Delete group": "Grubu sil",
  "Delete Notification": "Bildirimi sil",
  "Delete this draft": "Bu taslağı sil",
  "Delete this file?": "Bu dosya silinsin mi?",
  "Delete this group": "Bu grubu sil",
  "Delete this group?": "Bu grup silinsin mi?",
  "Delete this order's rows in": "Bu siparişin satırlarını şu tablolardan silin:",
  "Delete “{0}” from the website?": "“{0}” web sitesinden silinsin mi?",
  "Delete “{0}”?": "“{0}” silinsin mi?",
  "Deleted": "Silindi",
  "Delete…": "Sil…",
  "Deliverect": "Deliverect",
  "Deliverect recorded {0}. Leave blank to use it, or type the platform statement figure to replace it.": "Deliverect kaydı: {0}. Bunu kullanmak için boş bırakın ya da yerine geçmesi için platform ekstresindeki rakamı yazın.",
  "Deliverect Sync Completed": "Deliverect eşitlemesi tamamlandı",
  "Deliveries": "Teslimatlar",
  "DELIVERIES": "TESLİMATLAR",
  "Deliveries Error": "Teslimatlar hatası",
  "Delivery": "Teslimat",
  "DELIVERY": "TESLİMAT",
  "Delivery address:": "Teslimat adresi:",
  "Delivery by Distance": "Mesafeye göre teslimat",
  "Delivery by Hour": "Saate göre teslimat",
  "Delivery fee": "Teslimat ücreti",
  "DELIVERY FEE": "TESLİMAT ÜCRETİ",
  "Delivery Fees": "Teslimat ücretleri",
  "DELIVERY FEES": "TESLİMAT ÜCRETLERİ",
  "Delivery Locations": "Teslimat noktaları",
  "DELIVERY MAP": "TESLİMAT HARİTASI",
  "Delivery Map": "Teslimat haritası",
  "Delivery not recorded": "Teslimat kaydedilmedi",
  "Delivery Price:": "Teslimat fiyatı:",
  "Delivery recorded": "Teslimat kaydedildi",
  "Delivery Report Error": "Teslimat raporu hatası",
  "DELIVERY REV": "TESLİMAT CİROSU",
  "Delivery/Pickup": "Teslimat/Gel-al",
  "Deposit": "Depozito",
  "Deposits": "Depozitolar",
  "DEPOSITS": "DEPOZİTOLAR",
  "Description": "Açıklama",
  "Description...": "Açıklama...",
  "Description:": "Açıklama:",
  "Destination": "Hedef sayfa",
  "DESTINATION": "HEDEF SAYFA",
  "Details": "Ayrıntılar",
  "DIFFERENCE": "FARK",
  "Dine-in is counted per ticket, where the POS counts per table, so a dine-in store shows more orders and a lower average ticket than the POS report. Its sales are the same.": "Restoranda yenen siparişler burada fiş başına sayılır, POS ise masa başına sayar; bu yüzden restoranda yemek servisi olan bir mağaza, POS raporuna göre daha fazla sipariş ve daha düşük ortalama sepet gösterir. Satışları aynıdır.",
  "Dip Sauce": "Dip sos",
  "Direct messages": "Doğrudan mesajlar",
  "DISC %": "İND. %",
  "Discard": "Vazgeç",
  "Discard your unsaved changes?": "Kaydedilmemiş değişikliklerinizden vazgeçilsin mi?",
  "Discount": "İndirim",
  "DISCOUNT": "İNDİRİM",
  "DISCOUNT %": "İNDİRİM %",
  "Discount ({0})": "İndirim ({0})",
  "Discount depth": "İndirim oranı",
  "DISCOUNT DEPTH": "İNDİRİM ORANI",
  "Discount Detail": "İndirim ayrıntısı",
  "Discount for Same Second Product (%)": "Aynı ikinci ürüne indirim (%)",
  "Discount given at the till": "Kasada yapılan indirim",
  "Discount totals by date and store — alert if >5% of revenue": "Tarih ve mağazaya göre indirim toplamları — ciro içindeki payı >%5 olursa uyarı",
  "Discount Trend": "İndirim trendi",
  "Discount Type": "İndirim türü",
  "Discounts": "İndirimler",
  "DISCOUNTS": "İNDİRİMLER",
  "Discounts & Voids": "İndirimler ve iptaller",
  "Discounts & Voids Error": "İndirimler ve iptaller hatası",
  "Dispatch Board": "Dağıtım panosu",
  "Distance Breakdown": "Mesafe dökümü",
  "DISTANCE ZONE": "MESAFE BÖLGESİ",
  "Do they come back?": "Geri geliyorlar mı?",
  "Done": "Tamamlanan",
  "Done. {0}’s report for {1} is saved, and head office can see it.": "Tamamdır. {0} için {1} raporu kaydedildi; merkez ofis artık görebilir.",
  "DOORDASH": "DOORDASH",
  "DOUBLE": "ÇİFT",
  "down {0}% on the day before": "önceki güne göre %{0} düşüş",
  "Download": "İndir",
  "Download Excel": "Excel indir",
  "Download the Excel file": "Excel dosyasını indir",
  "Draft": "Taslak",
  "Drafted": "Taslak tarihi",
  "Drag to resize · double-click to reset": "Boyutlandırmak için sürükleyin · sıfırlamak için çift tıklayın",
  "Draw an area with at least 3 points before saving.": "Kaydetmeden önce en az 3 noktalı bir alan çizin.",
  "Drinks": "İçecekler",
  "Drive-Thru": "Arabaya servis",
  "Driver": "Kurye",
  "Driver notes:": "Kurye notları:",
  "DUE": "ÖDENECEK",
  "E-mail": "E-posta",
  "E-mail address cannot be empty!": "E-posta adresi boş olamaz!",
  "E-mail, phone, name or customer number…": "E-posta, telefon, ad veya müşteri numarası…",
  "E-mail:": "E-posta:",
  "e.g. Free 2L pop": "ör. Free 2L pop",
  "e.g. Kelowna Grand Opening": "ör. Kelowna Grand Opening",
  "e.g. Marketing": "ör. Marketing",
  "e.g. Pick a pizza": "ör. Pick a pizza",
  "e.g. pizza — counts every item with “pizza” in its name": "ör. pizza — adında “pizza” geçen her ürünü sayar",
  "e.g. soda — for the rewarded item": "ör. soda — ödül olarak verilen ürün için",
  "e.g. SY-88014": "ör. SY-88014",
  "Each customer can use it {0} time(s).": "Her müşteri en fazla {0} kez kullanabilir.",
  "Each repeat becomes its own notification in this list, with the same text, image and stores.": "Her tekrar, aynı metin, görsel ve mağazalarla bu listede ayrı bir bildirim olur.",
  "Each store manager fills in their own report with the assistant. Open a store to see its answers, or to fill it in for them.": "Her mağaza müdürü kendi raporunu asistanla doldurur. Yanıtlarını görmek ya da raporu onun yerine doldurmak için bir mağazayı açın.",
  "Each store's own numbers, one card per store": "Her mağazanın kendi rakamları, mağaza başına bir kart",
  "earned": "kazanıldı",
  "Easiest option. New items added to the category later join the combo by themselves.": "En kolay seçenek. Kategoriye sonradan eklenen ürünler komboya kendiliğinden katılır.",
  "Edit": "Düzenle",
  "Edit Audit": "Denetimi düzenle",
  "Edit Bag Item": "Poşet ürününü düzenle",
  "Edit Coupon": "Kuponu düzenle",
  "Edit Coupon Item": "Kupon ürününü düzenle",
  "Edit deal": "Kampanyayı düzenle",
  "Edit Image": "Görseli düzenle",
  "Edit Invoice": "Faturayı düzenle",
  "Edit Menu": "Menüyü düzenle",
  "Edit Notification": "Bildirimi düzenle",
  "Edit Option Item": "Seçeneği düzenle",
  "Edit Product Item": "Ürünü düzenle",
  "Edit role": "Rolü düzenle",
  "Edit Stock": "Stoğu düzenle",
  "Edit User": "Kullanıcıyı düzenle",
  "Edit Vendor": "Tedarikçiyi düzenle",
  "Email": "E-posta",
  "Email Campaigns": "E-posta kampanyaları",
  "Email cannot be empty": "E-posta boş olamaz",
  "Email not verified": "E-posta doğrulanmamış",
  "Emerald": "Zümrüt",
  "Empty = as soon as you switch it on.": "Boş = açtığınız anda başlar.",
  "Empty = until you switch it off. It stops by itself after this moment.": "Boş = siz kapatana kadar sürer. Bu andan sonra kendiliğinden durur.",
  "Encrypted in your browser; the server stores ciphertext": "Tarayıcınızda şifrelenir; sunucu şifreli metni saklar",
  "Encrypted with a key this browser does not have yet. It opens once a member with the key has the panel open.": "Bu tarayıcıda henüz bulunmayan bir anahtarla şifrelenmiş. Anahtara sahip bir üye paneli açtığında açılır.",
  "Encrypted — no key for it in this browser yet": "Şifreli — bu tarayıcıda henüz anahtarı yok",
  "End after silence": "Sessizlikten sonra bitir",
  "End date": "Bitiş tarihi",
  "End Date": "Bitiş tarihi",
  "End Time": "Bitiş saati",
  "End Time:": "Bitiş saati:",
  "End-to-end encryption": "Uçtan uca şifreleme",
  "ended {0}": "{0} tarihinde bitti",
  "Ends": "Bitiş",
  "Ends on": "Bitiş tarihi",
  "Engagement:": "Etkileşim:",
  "Enter an area name before saving.": "Kaydetmeden önce bir alan adı girin.",
  "Enter campaign title": "Kampanya başlığını girin",
  "Enter coupon code": "Kupon kodunu girin",
  "Enter coupon code if any": "Varsa kupon kodunu girin",
  "Enter notification message": "Bildirim mesajını girin",
  "Enter notification title": "Bildirim başlığını girin",
  "Enter product description...": "Ürün açıklamasını girin...",
  "Enter your email": "E-postanızı girin",
  "Enter your password": "Şifrenizi girin",
  "Enter your SMS message (max 250 characters)": "SMS mesajınızı girin (en fazla 250 karakter)",
  "Error": "Hata",
  "Error POS Sync": "POS eşitleme hatası",
  "Estimated total": "Tahmini toplam",
  "estimated, this page": "tahmini, bu sayfa",
  "events per order": "sipariş başına etkinlik",
  "every accepted order in this period, promotion or not": "bu dönemde kabul edilen tüm siparişler, promosyonlu olsun olmasın",
  "every extra one": "sınırsız",
  "every item": "menüdeki tüm ürünler",
  "Every item with a target level is above it. Nothing needs ordering right now.": "Hedef seviyesi olan her ürün bu seviyenin üzerinde. Şu anda sipariş verilmesi gereken bir şey yok.",
  "Every item, its prices and its photo": "Tüm ürünler, fiyatları ve fotoğrafları",
  "Every item, its prices and its photo.": "Tüm ürünler, fiyatları ve fotoğrafları.",
  "Every offer {0} runs. Switching one on makes it visible to customers straight away.": "{0} tarafından yürütülen tüm kampanyalar. Birini açtığınızda müşteriler onu hemen görür.",
  "Every offer, and whether it is switched on": "Tüm kampanyalar ve hangilerinin açık olduğu",
  "Every page, explained": "Tüm sayfalar, açıklamalarıyla",
  "Every registered account, and what they have spent": "Tüm kayıtlı hesaplar ve harcadıkları tutar",
  "Every registered account, what they have spent, and where they sit in the lifecycle": "Tüm kayıtlı hesaplar, harcadıkları tutar ve yaşam döngüsündeki yerleri",
  "Every store of the brand, added together": "Markanın tüm mağazaları, toplam olarak",
  "Every store ranked against the others": "Tüm mağazaların birbirine göre sıralaması",
  "Every store ›": "Tüm mağazalar ›",
  "Every store, including ones opened later.": "Sonradan açılacaklar dahil tüm mağazalar.",
  "Every store’s report compares its month with these targets, and uses these rates when a store asks Connect to estimate a cost.": "Her mağazanın raporu, kendi ayını bu hedeflerle karşılaştırır ve bir mağaza Connect'ten bir maliyeti tahmin etmesini istediğinde bu oranları kullanır.",
  "Every trading store side by side, and when they are busy": "Faaliyetteki tüm mağazalar yan yana ve yoğun oldukları saatler",
  "Every trading store side by side, today against yesterday": "Faaliyetteki tüm mağazalar yan yana, bugün ile dün karşılaştırmalı",
  "Every trading store side-by-side for the selected window": "Faaliyetteki tüm mağazalar, seçilen aralıkta yan yana",
  "every {0}": "her {0}",
  "Every {0}": "Her {0}",
  "Everyone": "Herkes",
  "everyone starts here": "herkes buradan başlar",
  "Everyone who can sign in to this panel, and the role each one holds.": "Bu panele giriş yapabilen herkes ve her birinin sahip olduğu rol.",
  "Everything": "Tümü",
  "Everything matched what the system expected.": "Her şey sistemin beklediğiyle eşleşti.",
  "Everything needed is filled in.": "Gerekli her şey dolduruldu.",
  "everything they ever spent, not a forecast": "şimdiye kadar harcadıklarının tamamı, tahmin değil",
  "Excel": "Excel",
  "Excel file": "Excel dosyası",
  "Exclude bottle deposits": "Şişe depozitolarını hariç tut",
  "Exclude delivery fees": "Teslimat ücretlerini hariç tut",
  "Expand": "Büyüt",
  "Expand the menu": "Menüyü genişlet",
  "EXPECTED": "BEKLENEN",
  "Expired": "Süresi doldu",
  "Expired Date": "Son geçerlilik tarihi",
  "Expires:": "Sona erme:",
  "Extra": "Ekstra",
  "EXTRA": "EKSTRA",
  "Extras": "Ekstralar",
  "Failed": "Başarısız",
  "Failed to copy menus.": "Menüler kopyalanamadı.",
  "Failed to copy product": "Ürün kopyalanamadı",
  "Failed to create SMS campaign": "SMS kampanyası oluşturulamadı",
  "Failed to load delivery map data": "Teslimat haritası verileri yüklenemedi",
  "Failed to load menus for selected store": "Seçilen mağazanın menüleri yüklenemedi",
  "Failed to load options data": "Seçenek verileri yüklenemedi",
  "Failed to load overview data": "Genel bakış verileri yüklenemedi",
  "Failed to load products data": "Ürün verileri yüklenemedi",
  "Failed to load report": "Rapor yüklenemedi",
  "Failed to load SMS campaigns": "SMS kampanyaları yüklenemedi",
  "Failed to reload store data": "Mağaza verileri yeniden yüklenemedi",
  "Failed to search coupon.": "Kupon aranamadı.",
  "Failed to send SMS to brand customers": "Marka müşterilerine SMS gönderilemedi",
  "Failed to send SMS to stores": "Mağazalara SMS gönderilemedi",
  "Failed to send test SMS": "Test SMS'i gönderilemedi",
  "Failed to sync with Deliverect": "Deliverect ile eşitlenemedi",
  "Family Feast": "Family Feast",
  "Featured": "Öne çıkanlar",
  "Featured products": "Öne çıkan ürünler",
  "Featured products could not be loaded.": "Öne çıkan ürünler yüklenemedi.",
  "Fees Paid to Driver": "Kuryeye ödenen ücretler",
  "figures getting old": "rakamlar eskiyor",
  "Files": "Dosyalar",
  "Filter products...": "Ürünleri filtrele...",
  "Filter...": "Filtrele...",
  "FINANCE": "FİNANS",
  "Financial Summary": "Finansal özet",
  "Find a customer": "Müşteri bul",
  "Find a page": "Sayfa bul",
  "Find a page…": "Sayfa bul…",
  "Find an item or code…": "Ürün veya kod bul…",
  "Find an item…": "Ürün bul…",
  "find this order and set": "tablosunda bu siparişi bulun ve şunu ayarlayın:",
  "Finish and make the Excel file": "Bitir ve Excel dosyasını oluştur",
  "Finished": "Tamamlandı",
  "FINISHED": "TAMAMLANAN",
  "First Register Coupon Selected": "İlk kayıt kuponu seçili",
  "First store they ordered from": "İlk sipariş verdikleri mağaza",
  "Fix the items listed above first": "Önce yukarıda listelenen maddeleri düzeltin",
  "Flag": "İşaretle",
  "Flag creation #{0}?": "Kreasyon #{0} işaretlensin mi?",
  "Flag photo": "Fotoğrafı işaretle",
  "Flag the customer photo on #{0}?": "Kreasyon #{0} için müşteri fotoğrafı işaretlensin mi?",
  "Flagged": "İşaretli",
  "Flagged or hidden": "İşaretli veya gizli",
  "Flash Deals": "Flaş kampanyalar",
  "Food Cost": "Yemek maliyeti",
  "Food Cost AvT": "Yemek maliyeti (gerçek/teorik)",
  "For": "İlgili soru",
  "For a store-specific code, pick that store's order page rather than the home page — it lands the customer on the menu": "Mağazaya özel bir kod için ana sayfa yerine o mağazanın sipariş sayfasını seçin — müşteriyi doğrudan menüye götürür",
  "For when the store's POS cannot close the order itself. Every action is saved to the audit log with your reason; the POS may still need a sync.": "Mağazanın POS'u siparişi kendisi kapatamadığında kullanılır. Her işlem, gerekçenizle birlikte denetim kaydına yazılır; POS'un yine de senkronize edilmesi gerekebilir.",
  "Force close": "Zorla kapat",
  "Force confirm": "Zorla onayla",
  "Force-confirm this order?": "Bu sipariş zorla onaylansın mı?",
  "Forgot it?": "Unuttunuz mu?",
  "Forgot the passphrase?": "Parolayı mı unuttunuz?",
  "Franchise royalty and marketing fees by store": "Mağaza bazında franchise royalti ve pazarlama ücretleri",
  "Free": "Ücretsiz",
  "Free Dif": "Ücretsiz fark",
  "Free garlic bread": "Free garlic bread",
  "Free Item": "Ücretsiz ürün",
  "Free item(s)": "Ücretsiz ürün(ler)",
  "Free soft drink": "Free soft drink",
  "Free toppings included": "Dahil ücretsiz malzeme",
  "Frequent and high value.": "Sık sipariş verir ve yüksek değerlidir.",
  "Fri": "Cum",
  "Friday": "Cuma",
  "From": "Başlangıç",
  "from account type": "hesap türünden",
  "from order #{0}": "sipariş #{0} ile kazanıldı",
  "from our own order table. Two independent sources, {0} of a point apart.": "kendi sipariş tablomuzdan geliyor. Birbirinden bağımsız iki kaynak; aralarındaki fark {0} puan.",
  "From Store": "Kaynak mağaza",
  "From the starting date on, with no end date": "Başlangıç tarihinden itibaren, bitiş tarihi olmadan",
  "From time": "Başlangıç saati",
  "from {0}": "{0} itibarıyla",
  "Fulfilment": "Teslim şekli",
  "GAP": "FARK",
  "GAP TO LEADER": "LİDERE FARK",
  "General": "Genel",
  "Generate Dates from Patterns": "Düzenlerden tarih oluştur",
  "Generated {0} date ranges from patterns!": "Düzenlerden {0} tarih aralığı oluşturuldu!",
  "Generating image…": "Görsel oluşturuluyor…",
  "Gift Cards": "Hediye kartları",
  "Give": "Ver",
  "Give or take back points": "Puan ver veya geri al",
  "Give the deal a title": "Kampanyaya bir başlık verin",
  "Give the role a name.": "Role bir ad verin.",
  "Give {0} the {1} role?": "{0} adlı kişiye {1} rolü verilsin mi?",
  "Given away": "Verilen indirim",
  "Go to a month": "Bir aya git",
  "Goes out on {0}.": "{0} tarihinde gönderilir.",
  "Gold": "Altın",
  "Good afternoon": "İyi günler",
  "Good evening": "İyi akşamlar",
  "Good morning": "Günaydın",
  "Goods and Services Tax cannot be empty!": "Mal ve Hizmet Vergisi (GST) boş olamaz!",
  "Gross sales (before discount)": "Brüt satış (indirim öncesi)",
  "Gross Sales (before discount)": "Brüt satış (indirim öncesi)",
  "Group created.": "Grup oluşturuldu.",
  "Group customers by the month they first ordered, then follow them forward": "Müşterileri ilk sipariş verdikleri aya göre gruplayın, sonra zaman içinde izleyin",
  "Group deleted.": "Grup silindi.",
  "Group name": "Grup adı",
  "Group Name": "Grup adı",
  "Group name is required": "Grup adı gerekli",
  "Group orders": "Grup siparişleri",
  "Group orders could not be loaded.": "Grup siparişleri yüklenemedi.",
  "GST": "GST",
  "GST (%)": "GST (%)",
  "gst content": "gst içeriği",
  "Guest": "Misafir",
  "Guest checkout, no account": "Misafir olarak ödeme, hesap yok",
  "Half & Half": "Yarım yarım",
  "Half & half:": "Yarım yarım:",
  "Hand out a coupon": "Kupon dağıt",
  "Has its own step-by-step screen in the app. Customers open it from the Deals page or the home-screen carousel.": "Uygulamada adım adım ilerleyen kendi ekranı vardır. Müşteriler onu Kampanyalar sayfasından ya da ana ekran karuselinden açar.",
  "Has never ordered.": "Hiç sipariş vermemiş.",
  "has not been given a role on this page, so the one shown is what their old account type has always meant. A person linked to fewer than all stores sees and changes only those stores, everywhere in the panel.": "bu sayfada henüz bir rol almamıştır; bu yüzden gösterilen rol, eski hesap türünün öteden beri karşılığı olan roldür. Tüm mağazalara değil de yalnızca bazılarına bağlı olan biri, panelin her yerinde yalnızca o mağazaları görür ve değiştirir.",
  "Has not ordered yet": "Henüz sipariş vermedi",
  "Has real photo": "Gerçek fotoğrafı var",
  "heading": "sayfa başlığı",
  "Heading": "Ana başlık",
  "Heatmap": "Isı haritası",
  "Heatmap Error": "Isı haritası hatası",
  "Hibernating": "Uykuda",
  "Hidden": "Gizli",
  "HIDDEN": "GİZLİ",
  "Hidden for this window: placing an attempt at a store means following its visitor session, which is skipped beyond four months. Narrow the range and the rate comes back.": "Bu aralıkta gizli: bir denemeyi bir mağazaya atamak, ziyaretçi oturumunu izlemeyi gerektirir; bu da dört ayı aşan aralıklarda atlanır. Aralığı daraltın, oran geri gelir.",
  "Hide": "Gizle",
  "Hide creation #{0}?": "Kreasyon #{0} gizlensin mi?",
  "Hide filters": "Filtreleri gizle",
  "Hide link box": "Bağlantı kutusunu gizle",
  "Hide password": "Şifreyi gizle",
  "Hide Pattern": "Tekrar düzenini gizle",
  "Hide POS reset help": "POS sıfırlama yardımını gizle",
  "Hide rates": "Oranları gizle",
  "Hide the list": "Listeyi gizle",
  "High": "Yüksek",
  "Highest spenders.": "En çok harcama yapanlar.",
  "Hi{0}. Let’s do {1}’s report for {2}. I’ll ask you one thing at a time and fill in what Connect already knows. You can type, talk to me, or scan your bills. Every answer is saved, so you can stop and come back.": "Merhaba{0}. {1} için {2} raporunu hazırlayalım. Size her seferinde tek bir şey soracağım ve Connect’in zaten bildiklerini dolduracağım. Yazabilir, benimle konuşabilir ya da faturalarınızı tarayabilirsiniz. Her yanıt kaydedilir; ara verip sonra kaldığınız yerden devam edebilirsiniz.",
  "Home": "Ana sayfa",
  "Host": "Düzenleyen",
  "Host locked the session for checkout": "Düzenleyen, oturumu ödeme için kilitledi",
  "Host removed a member": "Düzenleyen bir üyeyi çıkardı",
  "Host unlocked the session": "Düzenleyen oturumun kilidini açtı",
  "Host:": "Düzenleyen:",
  "Hour-of-week heatmap": "Haftanın saatlerine göre ısı haritası",
  "Hourly Revenue": "Saatlik ciro",
  "Hourly Sales by Channel": "Kanala göre saatlik satış",
  "Hourly Sales by Size": "Boya göre saatlik satış",
  "hours": "çalışma saatleri",
  "HOURS": "SAATLER",
  "Hours has been updated successfully": "Saatler güncellendi",
  "How customers can talk to the app's AI host: the voice modes on offer, the avatar's face and how long a voice session may last. Changes reach customers from their next voice session.": "Müşterilerin uygulamanın AI asistanıyla nasıl konuşabileceği: sunulan ses modları, avatarın yüzü ve bir sesli oturumun ne kadar sürebileceği. Değişiklikler müşterilere bir sonraki sesli oturumlarından itibaren yansır.",
  "How does the “buy some, get one” work?": "“Birkaç al, bir tane kazan” nasıl işlesin?",
  "How many do they pick here?": "Burada kaç tane seçecekler?",
  "How many free items per order": "Sipariş başına kaç ücretsiz ürün",
  "How many items get the discount": "Kaç ürün indirim alır",
  "how many orders": "kaç sipariş",
  "How many people signed up, and how many went on to order": "Kaç kişinin kaydolduğu ve kaçının ardından sipariş verdiği",
  "How many people who looked ended up ordering": "Bakanlardan kaçının sonunda sipariş verdiği",
  "How many visits to the website turn into an order": "Web sitesi ziyaretlerinin kaçı siparişe dönüşüyor",
  "How matching works:": "Eşleştirme nasıl çalışır:",
  "How much comes off, and from what order size?": "Ne kadar indirim olsun, hangi sipariş tutarından itibaren?",
  "how much each spends": "her birinin ne kadar harcadığı",
  "How often each offer was put in front of a customer, and what came of it. The engine leans on these numbers when it picks which offer to show.": "Her kampanyanın bir müşteriye ne sıklıkla gösterildiği ve bunun sonucu. Motor, hangi kampanyayı göstereceğini seçerken bu rakamlara dayanır.",
  "How often each offer was shown, and what came of it": "Her kampanyanın ne sıklıkla gösterildiği ve sonucu",
  "How people paid": "Müşteriler nasıl ödedi",
  "How recoverable they are": "Ne kadar geri kazanılabilirler",
  "How the pizza sizes sell against each other": "Pizza boylarının birbirine kıyasla satışı",
  "How those records were created": "Bu kayıtlar nasıl oluşturuldu",
  "How today was ordered": "Bugün nasıl sipariş verildi",
  "How {0} customers split across the tiers. Tiers come from {1}, counted every night.": "{0} müşterinin seviyelere dağılımı. Seviyeler şuna göre belirlenir: {1}; her gece yeniden sayılır.",
  "https://…": "https://…",
  "https://… or a page of the website, like /menu": "https://… veya web sitesinden bir sayfa, ör. /menu",
  "I": "I",
  "If you list several, the customer chooses one of them.": "Birden fazla eklerseniz müşteri bunlardan birini seçer.",
  "Image": "Görsel",
  "Image error:": "Görsel hatası:",
  "Image is required.": "Görsel gereklidir.",
  "Image worker:": "Görsel işleyici:",
  "Impressions": "Gösterimler",
  "In": "Eklendi:",
  "in cart": "sepette",
  "In carts": "Sepetlerde",
  "IN PROGRESS": "DEVAM EDEN",
  "In store": "Mağazada",
  "In the app": "Uygulamada",
  "In the apps a tap opens: {0}": "Uygulamalarda dokununca açılan: {0}",
  "in the Chat tab.": "düğmesini Sohbet sekmesinde bulabilirsiniz.",
  "in the kitchen now": "şu an mutfakta",
  "In the oven": "Fırında",
  "in this window": "bu aralıkta",
  "In this window that is {0} from {1} marketplace orders, not included below.": "Bu aralıkta bunlar {1} pazaryeri siparişinden {0} tutarındadır ve aşağıdaki rakamlara dahil değildir.",
  "In use": "Kullanımda",
  "In view": "Listelenen",
  "in {0}": "{0} cinsinden",
  "In {0}": "Eklendi: {0}",
  "In-Store": "Mağaza içi",
  "Inactive": "Pasif",
  "included": "dahil",
  "Incomplete Area": "Eksik alan",
  "Info": "Bilgi",
  "Information": "Bilgilendirici",
  "Informative": "Bilgilendirici",
  "Ingredient Amount: {0}": "Malzeme miktarı: {0}",
  "Ingredient Hash: {0}": "Malzeme hash değeri: {0}",
  "Ingredient is required in Group Name {0}": "{0} grubunda malzeme gerekli",
  "Ingredient Name: {0}": "Malzeme adı: {0}",
  "Ingredient Unit: {0}": "Malzeme birimi: {0}",
  "Ingredient {0} is not registered correctly in Group Name {1}": "{1} grubundaki {0}. malzeme doğru kaydedilmemiş",
  "Ink": "Antrasit",
  "Instore": "Mağaza içi",
  "Internal key": "Dahili anahtar",
  "Invalid e-mail address!": "Geçersiz e-posta adresi!",
  "Invalid email format!": "Geçersiz e-posta biçimi!",
  "Invalid phone number!": "Geçersiz telefon numarası!",
  "Inventory": "Envanter",
  "Inventory (old)": "Envanter (eski)",
  "Inviting a friend": "Arkadaş daveti",
  "Invoice": "Fatura",
  "INVOICE": "FATURA",
  "invoice": "fatura",
  "Invoice Date": "Fatura tarihi",
  "Invoice Date cannot be empty": "Fatura tarihi boş olamaz",
  "Invoice has been deleted successfully": "Fatura silindi",
  "Invoice has been saved successfully": "Fatura kaydedildi",
  "Invoice has been updated successfully": "Fatura güncellendi",
  "Invoice has not been deleted successfully": "Fatura silinemedi",
  "Invoice has not been saved successfully": "Fatura kaydedilemedi",
  "Invoice has not been updated successfully": "Fatura güncellenemedi",
  "Invoice list has not been loaded successfully": "Fatura listesi yüklenemedi",
  "Invoice number": "Fatura numarası",
  "Invoice Number": "Fatura numarası",
  "Invoice Number cannot be empty": "Fatura numarası boş olamaz",
  "Invoice Picture cannot be empty": "Fatura görseli boş olamaz",
  "Invoice price differs": "Fatura fiyatı farklı",
  "Invoices": "Faturalar",
  "invoices": "fatura",
  "is a month that has already passed with nobody coming back; a": "kimsenin geri dönmediği, çoktan geçmiş bir aydır;",
  "is an order that carried the code and still paid full price; above roughly a quarter of the campaign that points at a rule the customer cannot satisfy.": "kodu taşıdığı hâlde yine de tam fiyat ödenen siparişi ifade eder; bu oran kampanyanın kabaca dörtte birini aşıyorsa, müşterinin karşılayamadığı bir kurala işaret eder.",
  "is net sales on those orders divided by what the offer gave away; it is a ratio, not profit, and it does not prove the order would have been smaller without the offer. Under $1.00 is red: the offer gave away more than the orders brought in. An order can carry a coupon and a deal at once, so it appears in both tables and its money is split evenly between them; it is still counted once in \"orders on a promotion\".": "o siparişlerdeki net satışın, promosyonun verdiği indirime bölünmesiyle bulunur; bu bir orandır, kâr değildir ve promosyon olmasaydı siparişin daha küçük olacağını kanıtlamaz. $1.00'ın altı kırmızıdır: promosyon, siparişlerin getirdiğinden fazlasını vermiştir. Bir sipariş aynı anda hem kupon hem kampanya taşıyabilir; bu yüzden iki tabloda da görünür ve tutarı ikisi arasında eşit bölünür; yine de \"promosyonlu siparişler\" içinde bir kez sayılır.",
  "Is the free item something different?": "Ücretsiz ürün farklı bir şey mi?",
  "is the same figure as every Connect sales page: after discount, without tax, tips, delivery fees or bottle deposits, accepted orders only, on the day the POS closed them out. Tax and tips are collected on the restaurant's behalf, so counting them would flatter every number on this page.": "Connect'in tüm satış sayfalarındaki rakamla aynıdır: indirim sonrası; vergi, bahşiş, teslimat ücreti ve şişe depozitosu hariç; yalnızca kabul edilen siparişler, POS'un onları kapattığı güne göre. Vergi ve bahşiş restoran adına toplanır; bunları saymak bu sayfadaki her rakamı olduğundan iyi gösterirdi.",
  "It becomes visible to every customer.": "Tüm müşterilere görünür hâle gelir.",
  "It could not be saved.": "Kaydedilemedi.",
  "It deletes or takes away 1 thing.": "Bu işlem 1 öğeyi siler veya kaldırır.",
  "It deletes or takes away {0} things.": "Bu işlem {0} öğeyi siler veya kaldırır.",
  "It goes off the stories page and its address stops working now.": "Yazılar sayfasından hemen kalkar ve adresi çalışmaz hâle gelir.",
  "It goes out to every customer at its scheduled time, or on the sender’s next run if that time has passed.": "Planlanan zamanda tüm müşterilere gönderilir; bu zaman geçtiyse gönderim görevinin bir sonraki çalışmasında gönderilir.",
  "It is hidden from other customers.": "Diğer müşterilerden gizlenir.",
  "It is marked flagged and taken out of the public feed.": "İşaretlenir ve herkese açık akıştan çıkarılır.",
  "it is on the website.": "web sitesinde yayında.",
  "It opens another page": "Başka bir sayfa açar",
  "It opens the story's own page": "Yazının kendi sayfasını açar",
  "It runs now with {0}’s permissions and stores; they see the result in their chat with Connect.": "Hemen {0} adlı kişinin yetkileri ve mağazalarıyla çalışır; sonucu Connect ile olan sohbetinde görür.",
  "It stays in the database but nobody sees it.": "Veritabanında kalır ama kimse göremez.",
  "It stays on the website until an administrator approves.": "Bir yönetici onaylayana kadar web sitesinde kalır.",
  "Italic": "İtalik",
  "ITEM": "ÜRÜN",
  "item": "kalem",
  "Item Price": "Birim fiyat",
  "item price content": "birim fiyat içeriği",
  "items": "ürün",
  "Items": "Ürünler",
  "ITEMS": "KALEM",
  "Items ({0})": "Ürünler ({0})",
  "Items that must be bought": "Satın alınması gereken ürünler",
  "items, all stores": "kalem, tüm mağazalar",
  "JOINED": "KAYIT TARİHİ",
  "JPG, PNG or WebP, up to 2 MB. No picture = the app shows the picture of the first item in the deal.": "JPG, PNG veya WebP, en fazla 2 MB. Görsel yok = uygulama, kampanyadaki ilk ürünün görselini gösterir.",
  "Just now": "Az önce",
  "Keep at least the avatar or the voice-only mode on, so customers always have one that works.": "Müşterilerin her zaman çalışan bir seçeneği olması için en azından avatar ya da yalnızca ses modunu açık tutun.",
  "Keep it": "Kalsın",
  "Keep it under {0} characters.": "En fazla {0} karakter yazın.",
  "Keep the answer as it was": "Yanıtı olduğu gibi bırak",
  "Keep the current picture": "Mevcut görsel kalsın",
  "Key {0}": "Anahtar {0}",
  "Keyed in at the counter or on the phone. Usually no e-mail, and the record is created as the order is taken.": "Kasada veya telefonda personel tarafından sisteme girilir. Genellikle e-posta adresi yoktur; kayıt, sipariş alınırken oluşturulur.",
  "Kind of discount": "İndirim türü",
  "Kiosk": "Kiosk",
  "Kiosk: OFF": "Kiosk: KAPALI",
  "Kiosk: ON": "Kiosk: AÇIK",
  "Kitchen & Cooking Settings": "Mutfak & pişirme ayarları",
  "Kitchen Hash": "Mutfak hash kodu",
  "Kitchen Status": "Mutfak durumu",
  "KPI summary for any custom period": "İstediğiniz herhangi bir dönem için KPI özeti",
  "label": "etiket",
  "Label": "Etiket",
  "LABEL": "ETİKET",
  "Label on the picture": "Görselin üzerindeki etiket",
  "label this set, e.g. August BOGO push": "bu sete ad verin, ör. Ağustos BOGO kampanyası",
  "lands on": "açılış sayfası:",
  "Lapsed": "Uzaklaşan",
  "Lapsed customers": "Uzaklaşan müşteriler",
  "Lapsed Customers Error": "Uzaklaşan müşteriler hatası",
  "LARGEST CHANNEL": "EN BÜYÜK KANAL",
  "Last 14 days": "Son 14 gün",
  "Last 3 days": "Son 3 gün",
  "Last 30 days": "Son 30 gün",
  "Last 6 hours": "Son 6 saat",
  "Last 7 days": "Son 7 gün",
  "Last 7 days, biggest first by what those orders were worth.": "Son 7 gün; bu siparişlerin değerine göre büyükten küçüğe.",
  "Last 90 days": "Son 90 gün",
  "Last activity {0}": "Son etkinlik: {0}",
  "Last activity:": "Son etkinlik:",
  "LAST CHANGE": "SON DEĞİŞİKLİK",
  "Last changed {0}": "Son değişiklik: {0}",
  "Last conversation": "Son sohbet",
  "LAST COUNT": "SON SAYIM",
  "LAST COUNTED": "SON SAYIM",
  "Last counted here: {0}": "Bu mağazada son sayım: {0}",
  "Last counted {0}.": "Son sayım: {0}.",
  "Last hour": "Son 1 saat",
  "LAST INVOICE": "SON FATURA",
  "Last message": "Son mesaj",
  "Last month": "Geçen ay",
  "Last streak week": "Son seri haftası",
  "Last Update:": "Son güncelleme:",
  "Last week": "Geçen hafta",
  "Last week (Mon – Sun)": "Geçen hafta (Pzt – Paz)",
  "Last week (Sun – Sat)": "Geçen hafta (Paz – Cmt)",
  "Last {0} days": "Son {0} gün",
  "LEAD DAYS": "TEDARİK SÜRESİ",
  "Leave at least one mode on, or the app has no voice at all.": "En az bir modu açık bırakın; yoksa uygulamanın hiç sesi olmaz.",
  "Leave without saving your changes to this story?": "Bu yazıdaki değişiklikleri kaydetmeden çıkılsın mı?",
  "LEFT": "SOL",
  "Lifetime spend now quiet": "Sessizleşen müşterilerin toplam harcaması",
  "LIFETIME VALUE": "YAŞAM BOYU DEĞER",
  "Light": "Az",
  "Like a giveaway or a promotion": "Çekiliş ya da promosyon gibi",
  "like EVENT": "ör. EVENT",
  "Limit per customer": "Müşteri başına sınır",
  "line": "satır",
  "lines": "satır",
  "Link": "Bağlantı",
  "Link not saved": "Bağlantı kaydedilmedi",
  "Link the selected words": "Seçili sözcüklere bağlantı ekle",
  "Links to the old address stop working.": "Eski adrese giden bağlantılar artık çalışmaz.",
  "List": "Liste",
  "Listening…": "Dinleniyor…",
  "Live": "Yayında",
  "LIVE": "CANLI",
  "live": "yayında",
  "Live orders": "Canlı siparişler",
  "Live orders could not be loaded.": "Canlı siparişler yüklenemedi.",
  "live to customers right now": "şu anda müşteriler için yayında",
  "Load earlier": "Öncekileri yükle",
  "Loading banners...": "Bannerlar yükleniyor...",
  "Loading conversation…": "Sohbet yükleniyor…",
  "Loading creation…": "Kreasyon yükleniyor…",
  "Loading customer…": "Müşteri yükleniyor…",
  "Loading menus...": "Menüler yükleniyor...",
  "Loading notifications...": "Bildirimler yükleniyor...",
  "Loading order…": "Sipariş yükleniyor…",
  "Loading product catalogue…": "Ürün kataloğu yükleniyor…",
  "Loading session…": "Oturum yükleniyor…",
  "Loading shifts...": "Vardiyalar yükleniyor...",
  "Loading stores…": "Mağazalar yükleniyor…",
  "Loading the report": "Rapor yükleniyor",
  "Loading…": "Yükleniyor…",
  "Location Analytics": "Mağaza analizi",
  "Locations": "Mağazalar",
  "Locked": "Kilitli",
  "Locked at:": "Kilitlenme:",
  "Locked · ready to check out": "Kilitli · ödemeye hazır",
  "Logging in...": "Giriş yapılıyor...",
  "Login": "Giriş yap",
  "Login failed. Please try again.": "Giriş başarısız oldu. Lütfen tekrar deneyin.",
  "Logout": "Çıkış yap",
  "Long gone, mostly one-time guests who were never really retained.": "Çoktan kopmuş; çoğu, hiçbir zaman gerçekten elde tutulamamış tek seferlik misafirler.",
  "Longest session": "En uzun oturum",
  "Longest streak": "En uzun seri",
  "Lost": "Kayıp",
  "Low": "Düşük",
  "Lower number shows first.": "Küçük sayı önce gösterilir.",
  "LOWEST DAY": "EN DÜŞÜK GÜN",
  "Loyal": "Sadık",
  "Loyalty": "Sadakat",
  "Loyalty could not be loaded.": "Sadakat verileri yüklenemedi.",
  "Loyalty settings": "Sadakat ayarları",
  "Loyalty Settings": "Sadakat ayarları",
  "Loyalty · publish": "Loyalty · publish",
  "Lunch, dinner, late": "Öğle, akşam, gece",
  "made from the title": "başlıktan oluşturulur",
  "Made from the title automatically. Only letters, numbers and underscores.": "Başlıktan otomatik oluşturulur. Yalnızca harf, rakam ve alt çizgi.",
  "MAIN": "ANA",
  "Make a new key?": "Yeni anahtar oluşturulsun mu?",
  "Make the new key": "Yeni anahtarı oluştur",
  "Making the file…": "Dosya hazırlanıyor…",
  "Making the report…": "Rapor hazırlanıyor…",
  "Manage promotional banners for your app and website": "Uygulamanız ve web siteniz için tanıtım bannerlarını yönetin",
  "Map": "Harita",
  "Map Load Error": "Harita yükleme hatası",
  "Mark as paid": "Ödendi olarak işaretle",
  "Mark this order as paid?": "Bu sipariş ödendi olarak işaretlensin mi?",
  "Marked deleted for everyone. Say why.": "Herkes için silinmiş olarak işaretlenir. Nedenini yazın.",
  "Markers": "İşaretçiler",
  "Marketing": "Pazarlama",
  "Marketing %": "Pazarlama %",
  "MARKETING & CRM": "PAZARLAMA & CRM",
  "MARKETING DUE": "PAZARLAMA BORCU",
  "MARKETING PAID": "ÖDENEN PAZARLAMA",
  "Match items by a word in their name": "Ürünleri adlarındaki bir kelimeyle eşleştir",
  "Match key: order ID": "Eşleştirme anahtarı: sipariş ID",
  "Max Discount Amount ($)": "Maksimum indirim tutarı ($)",
  "Max Discount for Same Second Product(%)": "Aynı ikinci üründe maksimum indirim (%)",
  "Max total ($)": "Maks. toplam ($)",
  "Max {0} rewarded": "En fazla {0} ödül",
  "Max: ${0}": "En fazla: ${0}",
  "MEASUREMENT HEALTH": "ÖLÇÜM SAĞLIĞI",
  "Member": "Üye",
  "members": "üye",
  "Members": "Üyeler",
  "Members ({0})": "Üyeler ({0})",
  "menu": "menü",
  "MENU & PRODUCTS": "MENÜ & ÜRÜNLER",
  "Menu Engineering": "Menü mühendisliği",
  "Menu has been deleted successfully.": "Menü silindi.",
  "Menu has been saved successfully.": "Menü kaydedildi.",
  "Menu has been updated successfully.": "Menü güncellendi.",
  "Menu image cannnot be empty!.": "Menü görseli boş olamaz!",
  "Menu name cannnot be empty!.": "Menü adı boş olamaz!",
  "Menu sync completed successfully": "Menü eşitlemesi tamamlandı",
  "Menu Title": "Menü başlığı",
  "Menu Type": "Menü türü",
  "Menuboard": "Menü ekranı",
  "Menuboard name cannnot be empty!.": "Menü ekranı adı boş olamaz!",
  "Menuboard Title": "Menü ekranı başlığı",
  "Menus": "Menüler",
  "Menus copied successfully.": "Menüler kopyalandı.",
  "Menus, products, prices and modifiers": "Menüler, ürünler, fiyatlar ve seçenekler",
  "Message": "Mesaj",
  "message": "mesaj",
  "Message customers": "Müşterilere mesaj gönder",
  "Message on Invoice": "Faturadaki mesaj",
  "message removed": "mesaj silindi",
  "Messages": "Mesajlar",
  "messages": "mesaj",
  "Messages are encrypted in your browser; the server only ever stores ciphertext. Choose a passphrase so you can open your messages from another browser or phone. It cannot be recovered for you.": "Mesajlar tarayıcınızda şifrelenir; sunucu yalnızca şifreli metni saklar. Mesajlarınızı başka bir tarayıcıdan veya telefondan açabilmek için bir parola belirleyin. Bu parola sizin için kurtarılamaz.",
  "METHOD": "YÖNTEM",
  "min": "dk",
  "Min qty {0}": "En az {0} adet",
  "Min spend {0}": "En az {0} harcama",
  "Min total ($)": "Min. toplam ($)",
  "Min.": "Min.",
  "Min.Amount:": "Min. tutar:",
  "Minimum": "Minimum",
  "Minimum Price": "Minimum fiyat",
  "Minimum Quantity": "Minimum miktar",
  "minute": "dakika",
  "minutes": "dakika",
  "Mobile": "Mobil",
  "Mobile App": "Mobil uygulama",
  "Mobile app, web ordering, delivery & 3rd party channel breakdown": "Mobil uygulama, web siparişi, teslimat & 3. taraf kanal dağılımı",
  "Mobile: OFF": "Mobil: KAPALI",
  "Mobile: ON": "Mobil: AÇIK",
  "Model": "Model",
  "Modified Date": "Değiştirilme tarihi",
  "Mon": "Pzt",
  "Monday": "Pazartesi",
  "Money": "Tutar",
  "MONEY": "PARA",
  "Money ($)": "Tutar ($)",
  "Money taken off at the till, and orders cancelled": "Kasada düşülen tutarlar ve iptal edilen siparişler",
  "Month": "Ay",
  "month": "ay",
  "Month 0 is the cohort itself, so it is 100% by definition — the shading starts at month 1 so the tint tracks the retention you can actually move. A cell reading": "Ay 0 kohortun kendisidir, bu yüzden tanım gereği %100'dür — renklendirme 1. aydan başlar, böylece renk tonu gerçekten etkileyebileceğiniz elde tutmayı izler. Bir hücredeki",
  "MONTH ORDERS": "AYLIK SİPARİŞ",
  "MONTH REVENUE": "AYLIK CİRO",
  "Month {0}": "Ay {0}",
  "MONTH-1 REPEAT": "1. AY TEKRAR",
  "Monthly": "Aylık",
  "Monthly Report": "Aylık rapor",
  "Monthly report": "Aylık rapor",
  "Monthly Report Error": "Aylık rapor hatası",
  "months": "ay",
  "More filters": "Daha fazla filtre",
  "more than you have": "elinizdekinden fazla",
  "More than {0} stores: the app opens it at the customer's own store.": "{0} mağazadan fazla: uygulama bunu müşterinin kendi mağazasında açar.",
  "Most of the business is still ordered at the counter, which is worth remembering before reading any app figure as the whole picture.": "İşin büyük kısmı hâlâ kasadan sipariş ediliyor; herhangi bir uygulama rakamını resmin tamamı sanmadan önce bunu hatırlamakta fayda var.",
  "Most orders": "En çok sipariş",
  "Most orders are in-store POS tickets synced from the till": "Siparişlerin çoğu, kasadan aktarılan mağaza içi POS fişleridir",
  "Most popular": "En popüler",
  "Move down": "Aşağı taşı",
  "Move it to another time, or repeat it": "Başka bir zamana taşıyın ya da tekrarlayın",
  "Move left": "Sola taşı",
  "Move right": "Sağa taşı",
  "Move up": "Yukarı taşı",
  "Multi-Use": "Çok kullanımlık",
  "Multiple": "Çoklu",
  "MULTIPLE": "ÇOKLU",
  "Must be picked": "Seçilmesi zorunlu",
  "M{0}": "Ay {0}",
  "n={0}": "n={0}",
  "Name": "Ad",
  "NAME": "AD",
  "Name in the app": "Uygulamadaki adı",
  "Name is required": "Ad gerekli",
  "Name Required": "Ad gerekli",
  "Name, email or phone": "Ad, e-posta veya telefon",
  "Narrowing it to visits that landed on a store page looks tempting and is wrong: those are under half of all visits, while most web orders come from sessions that never landed on one.": "Bunu bir mağaza sayfasına ulaşan ziyaretlerle sınırlamak cazip görünür ama yanlıştır: bunlar tüm ziyaretlerin yarısından azıdır, web siparişlerinin çoğu ise hiç mağaza sayfasına uğramayan oturumlardan gelir.",
  "need ordering": "sipariş edilmeli",
  "Needs review": "İnceleme bekliyor",
  "Needs two counts at least three days apart": "En az üç gün arayla iki sayım gerekir",
  "Needs your confirmation": "Onayınızı bekliyor",
  "Net Product Sales (after discount)": "Net ürün satışı (indirim sonrası)",
  "net sales": "net satış",
  "Net sales": "Net satış",
  "NET SALES": "NET SATIŞ",
  "Net sales (after discount)": "Net satış (indirim sonrası)",
  "Net sales are after discounts, so the discount column is what was taken off, not part of the figure. Tips belong to staff and are not in net sales either.": "Net satış indirimlerden sonraki tutardır; bu yüzden indirim sütunu düşülen tutarı gösterir, rakamın bir parçası değildir. Bahşişler personele aittir ve net satışa da dahil değildir.",
  "Net sales per store for any dates, against the days before and last year. A Monday to Sunday week is the figure royalties are worked out from": "İstediğiniz tarihler için mağaza bazında net satış; önceki günlerle ve geçen yılla karşılaştırmalı. Royalti, pazartesiden pazara bir haftanın rakamı üzerinden hesaplanır",
  "Net sales vs the day before": "Net satış, önceki güne göre",
  "Net sales vs the week before": "Net satış, önceki haftaya göre",
  "Net sales vs the {0} days before": "Net satış, önceki {0} güne göre",
  "Never": "Hiçbir zaman",
  "Never counted": "Hiç sayılmamış",
  "Never counted: {0}. Until a store's first count its stock value is only what has been delivered since, so its row reads low.": "Hiç sayım yapılmamış: {0}. Bir mağaza ilk sayımını yapana kadar stok değeri yalnızca o tarihten beri gelen teslimatlardan oluşur; bu yüzden satırı düşük görünür.",
  "Never expires": "Süresiz",
  "Never Ordered": "Hiç sipariş vermemiş",
  "NEVER ORDERED": "HİÇ SİPARİŞ VERMEYEN",
  "New": "Yeni",
  "New Audit": "Yeni denetim",
  "New Bag": "Yeni poşet",
  "New Coupon": "Yeni kupon",
  "New Coupon Item": "Yeni kupon ürünü",
  "New customers": "Yeni müşteriler",
  "New deal": "Yeni kampanya",
  "New delivery": "Yeni teslimat",
  "New group": "Yeni grup",
  "New group…": "Yeni grup…",
  "New Image": "Yeni görsel",
  "New Invoice": "Yeni fatura",
  "New key": "Yeni anahtar",
  "New key…": "Yeni anahtar…",
  "New Menu": "Yeni menü",
  "New Option Item": "Yeni seçenek",
  "New order": "Yeni sipariş",
  "New Product": "Yeni ürün",
  "New Signups": "Yeni kayıtlar",
  "New signups across the brand, and how many of them went on to order": "Marka genelindeki yeni kayıtlar ve bunların kaçının sipariş verdiği",
  "New SMS Campaign": "Yeni SMS kampanyası",
  "New Stock": "Yeni stok",
  "New stories waiting for approval": "Onay bekleyen yeni yazılar",
  "New story": "Yeni yazı",
  "New time": "Yeni zaman",
  "New User": "Yeni kullanıcı",
  "New Vendor": "Yeni tedarikçi",
  "New, unconfirmed": "Yeni, onaylanmamış",
  "New: talk with Connect": "Yeni: Connect ile konuşun",
  "Newer app versions open this. Older ones use Banner Type and Product above, so keep a product on a clickable banner.": "Uygulamanın yeni sürümleri bunu açar. Eski sürümler yukarıdaki Banner türü ve Ürün alanlarını kullanır; bu yüzden tıklanabilir bir bannerda bir ürün seçili tutun.",
  "Newest": "En yeni",
  "Newest first ↓": "Yeniden eskiye ↓",
  "Next": "İleri",
  "Next month": "Sonraki ay",
  "Next week": "Gelecek hafta",
  "Next ›": "İleri ›",
  "Next →": "İleri →",
  "nightly cache, not live": "gecelik önbellek, canlı değil",
  "No": "Hayır",
  "NO": "HAYIR",
  "No AI image yet · status: {0}": "Henüz AI görseli yok · durum: {0}",
  "No answer from the server.": "Sunucudan yanıt gelmedi.",
  "No attempts logged — this code was applied at the till or automatically, never typed into the online coupon box.": "Kayıtlı deneme yok — bu kod kasada ya da otomatik olarak uygulandı, online kupon kutusuna hiç yazılmadı.",
  "No Banners Yet": "Henüz banner yok",
  "No benchmark data for this period.": "Bu dönem için karşılaştırma verisi yok.",
  "No category": "Kategori yok",
  "No changes": "Değişiklik yok",
  "No cohort has reached this month yet": "Henüz hiçbir kohort bu aya ulaşmadı",
  "No cohorts in this window yet. Cohorts are rebuilt nightly.": "Bu aralıkta henüz kohort yok. Kohortlar her gece yeniden oluşturulur.",
  "no comparable period before this": "bundan önce karşılaştırılabilir bir dönem yok",
  "no comparable prior window": "karşılaştırılabilir önceki dönem yok",
  "No Connect change is waiting.": "Bekleyen Connect değişikliği yok.",
  "No coupon activity in this window.": "Bu aralıkta kupon hareketi yok.",
  "No coupon was redeemed in this period.": "Bu dönemde hiç kupon kullanılmadı.",
  "No creations match these filters. Try another filter or a wider time window.": "Bu filtrelere uyan kreasyon yok. Başka bir filtre ya da daha geniş bir zaman aralığı deneyin.",
  "No customers match this filter.": "Bu filtreye uyan müşteri yok.",
  "No customers to show.": "Gösterilecek müşteri yok.",
  "No daily data": "Günlük veri yok",
  "No daily data.": "Günlük veri yok.",
  "No data": "Veri yok",
  "No data available": "Veri bulunmuyor",
  "No data for selected range": "Seçilen aralık için veri yok",
  "No deal ran in this period.": "Bu dönemde yayında olan kampanya yok.",
  "No deals to target yet.": "Henüz hedeflenecek kampanya yok.",
  "No deals yet. Create one to get started.": "Henüz kampanya yok. Başlamak için bir tane oluşturun.",
  "No Deliverect host is configured for this brand.": "Bu marka için Deliverect sunucusu ayarlanmamış.",
  "No detail data": "Ayrıntı verisi yok",
  "No Details": "Ayrıntı yok",
  "No direct messages yet — pick someone below.": "Henüz özel mesaj yok — aşağıdan birini seçin.",
  "No distance data": "Mesafe verisi yok",
  "No encryption key yet: they have not opened the chat": "Henüz şifreleme anahtarı yok: bu kişi sohbeti açmadı",
  "No events recorded.": "Kaydedilmiş etkinlik yok.",
  "No figures for these dates.": "Bu tarihler için rakam yok.",
  "No fulfilment breakdown.": "Servis türü dağılımı yok.",
  "No hourly data": "Saatlik veri yok",
  "No hourly data.": "Saatlik veri yok.",
  "No image": "Görsel yok",
  "No items found.": "Ürün bulunamadı.",
  "No items yet.": "Henüz ürün yok.",
  "No lapsed customers at this threshold.": "Bu eşikte uzaklaşan müşteri yok.",
  "no longer a deal": "artık kampanya değil",
  "No matching products": "Eşleşen ürün yok",
  "no matter what the customer picks.": "— müşteri ne seçerse seçsin.",
  "No members yet.": "Henüz üye yok.",
  "No messages.": "Mesaj yok.",
  "No microphone was found.": "Mikrofon bulunamadı.",
  "No new dates were generated. All pattern dates already exist.": "Yeni tarih oluşturulmadı. Düzendeki tüm tarihler zaten var.",
  "No notification is waiting.": "Bekleyen bildirim yok.",
  "No Notifications Yet": "Henüz bildirim yok",
  "No offer has been shown to a customer yet, so there is nothing to compare.": "Henüz hiçbir müşteriye teklif gösterilmedi; bu yüzden karşılaştırılacak bir şey yok.",
  "No open store is linked to your account.": "Hesabınıza bağlı açık mağaza yok.",
  "no order in {0} days": "{0} gündür sipariş yok",
  "No orders": "Sipariş yok",
  "no orders": "sipariş yok",
  "No orders in this period.": "Bu dönemde sipariş yok.",
  "No orders match these filters — try a wider time window.": "Bu filtrelere uyan sipariş yok — daha geniş bir zaman aralığı deneyin.",
  "No orders match these filters.": "Bu filtrelere uyan sipariş yok.",
  "no orders to rank": "sıralanacak sipariş yok",
  "No passphrase: your messages open in this browser only": "Parola yok: mesajlarınız yalnızca bu tarayıcıda açılır",
  "No permission": "Yetki yok",
  "No picture": "Görsel yok",
  "No pictures in the row.": "Sırada görsel yok.",
  "No points yet.": "Henüz puan yok.",
  "No products found": "Ürün bulunamadı",
  "No products yet.": "Henüz ürün yok.",
  "No result found.": "Sonuç bulunamadı.",
  "No results found": "Sonuç bulunamadı",
  "No roles yet.": "Henüz rol yok.",
  "No schedule": "Zamanlama yok",
  "No sessions match these filters. Try a wider time window or another status.": "Bu filtrelere uyan oturum yok. Daha geniş bir zaman aralığı ya da başka bir durum deneyin.",
  "No shifts found for this store.": "Bu mağaza için vardiya bulunamadı.",
  "No signups from the selected sources in this period.": "Bu dönemde seçilen kaynaklardan kayıt yok.",
  "No SMS campaigns found. Create your first campaign to get started.": "SMS kampanyası bulunamadı. Başlamak için ilk kampanyanızı oluşturun.",
  "No store data for this period.": "Bu dönem için mağaza verisi yok.",
  "No store selected": "Mağaza seçilmemiş",
  "No store took an order in this period.": "Bu dönemde hiçbir mağaza sipariş almadı.",
  "No stores selected": "Mağaza seçilmedi",
  "No stories yet.": "Henüz yazı yok.",
  "No streak rewards for this tier yet.": "Bu seviye için henüz seri ödülü yok.",
  "No target levels have been set yet, so there is nothing to compare stock against. The table below suggests them from what you have actually been using — look them over and save.": "Henüz hedef stok seviyesi belirlenmedi, bu yüzden stoğun karşılaştırılacağı bir değer yok. Aşağıdaki tablo bunları gerçekte kullandıklarınıza göre önerir — gözden geçirip kaydedin.",
  "No toppings or sauces selected.": "Malzeme veya sos seçilmedi.",
  "No trading stores in this month.": "Bu ay satış yapan mağaza yok.",
  "No trading stores in this period.": "Bu dönemde satış yapan mağaza yok.",
  "No trend data available": "Trend verisi yok",
  "No user found.": "Kullanıcı bulunamadı.",
  "No users found.": "Kullanıcı bulunamadı.",
  "No website blog change is waiting.": "Bekleyen web sitesi blog değişikliği yok.",
  "No weekly data": "Haftalık veri yok",
  "Nobody has talked to the AI yet.": "Henüz kimse AI ile konuşmadı.",
  "Nobody has {0} yet.": "Henüz kimsede {0} yok.",
  "Nobody is waiting for access.": "Erişim bekleyen kimse yok.",
  "Nobody matches “{0}”.": "“{0}” ile eşleşen kimse yok.",
  "Nobody matching that has talked to the AI.": "Aramanızla eşleşen kimse AI ile konuşmamış.",
  "None": "Hiçbiri",
  "None of these is one of our campaigns, so none counts towards the numbers above. Rewards are the points customers spent, as the BI dashboard's Rewards. The marketplace figure is what Uber, DoorDash and Skip took off their own orders (a free side, two-for-one, dollars off), as Deliverect records it. Those orders never reach the POS, so they are outside every figure on this page.": "Bunların hiçbiri bizim kampanyalarımızdan biri değil, bu yüzden hiçbiri yukarıdaki rakamlara sayılmaz. Ödüller, müşterilerin harcadığı puanlardır; BI panosundaki Rewards ile aynıdır. Pazaryeri rakamı, Uber, DoorDash ve Skip'in kendi siparişlerinden düştüğü tutardır (bedava yan ürün, bir alana bir bedava, dolar indirimi); Deliverect'in kaydettiği şekliyle. Bu siparişler POS'a hiç ulaşmaz, bu yüzden bu sayfadaki tüm rakamların dışındadır.",
  "Normal": "Normal",
  "Not applied": "Uygulanmadı",
  "NOT APPLIED": "UYGULANMADI",
  "not approved": "onaylanmayan",
  "Not approved": "Onaylanmadı",
  "Not approved.": "Onaylanmadı.",
  "not counted": "sayılmadı",
  "NOT COUNTED IN A WEEK": "BİR HAFTADIR SAYILMAYAN",
  "Not counted lately": "Son zamanlarda sayılmamış",
  "Not counted yet: until the nightly count runs, everyone shows as Bronze.": "Henüz sayılmadı: gece sayımı çalışana kadar herkes Bronz olarak görünür.",
  "Not encrypted: Connect has to read it": "Şifreli değil: Connect'in okuyabilmesi gerekiyor",
  "Not in use": "Kullanımda değil",
  "Not kept": "Saklanmıyor",
  "Not on the website yet": "Henüz web sitesinde değil",
  "Not on this page, and why": "Bu sayfada olmayanlar ve nedeni",
  "Not paid yet": "Henüz ödenmedi",
  "Not part of a campaign": "Kampanyaya dahil olmayanlar",
  "Not reached yet": "Bu aya henüz ulaşılmadı",
  "Not recorded": "Kaydedilmedi",
  "Not saved": "Kaydedilmedi",
  "Not Showing in Branch": "Mağazada gösterilmiyor",
  "Not Showing on Kiosk": "Kioskta gösterilmiyor",
  "Not Showing on Mobile App": "Mobil uygulamada gösterilmiyor",
  "Not Showing on Website": "Web sitesinde gösterilmiyor",
  "not shown on the website": "web sitesinde gösterilmez",
  "NOT STARTED": "BAŞLANMADI",
  "Not switched on": "Açık değil",
  "Not Synced Yet": "Henüz senkronize edilmedi",
  "not used any more": "artık kullanılmıyor",
  "not yet": "henüz değil",
  "Not yet": "Henüz değil",
  "Note": "Not",
  "Note: {0}": "Not: {0}",
  "Nothing": "Hiçbir şey",
  "Nothing changed yet.": "Henüz bir şey değişmedi.",
  "nothing entered yet": "henüz hiçbir şey girilmedi",
  "Nothing has been counted at {0} yet. Once a count is submitted, what is left appears here.": "{0} mağazasında henüz hiçbir şey sayılmadı. Bir sayım gönderildiğinde kalan miktarlar burada görünür.",
  "Nothing has been ordered today at {0}.": "Bugün şu mağazalara hiç sipariş gelmedi: {0}.",
  "Nothing has been recorded as taken against any offer yet, so the": "Henüz hiçbir teklif için alım kaydedilmedi, bu yüzden",
  "Nothing here right now.": "Şu anda burada bir şey yok.",
  "Nothing here yet. Say hello.": "Burada henüz bir şey yok. Merhaba deyin.",
  "Nothing is in stock yet — count first, then anything spoiled can be written off.": "Henüz stokta hiçbir şey yok — önce sayım yapın, ardından bozulan her şeyi atık olarak kaydedebilirsiniz.",
  "Nothing is lost: on the new device press": "Hiçbir şey kaybolmaz: yeni cihazda şu düğmeye basın:",
  "Nothing is waiting for you": "Sizi bekleyen bir şey yok",
  "Nothing matches “{0}”.": "“{0}” ile eşleşen bir şey yok.",
  "Nothing matches “{0}”. Try a word from the page name or what it shows — “sales”, “coupon”, “store”…": "“{0}” ile eşleşen bir şey yok. Sayfa adından ya da sayfanın gösterdiği şeyden bir kelime deneyin — “satış”, “kupon”, “mağaza”…",
  "Nothing matches.": "Eşleşen sonuç yok.",
  "Nothing pinned to": "Şuraya henüz bir şey sabitlenmedi:",
  "Nothing selected = every day.": "Seçim yok = her gün.",
  "Nothing to order": "Sipariş edilecek bir şey yok",
  "Nothing written yet. New notifications wait here for approval before they go out.": "Henüz bir şey yazılmadı. Yeni bildirimler gönderilmeden önce onay için burada bekler.",
  "Nothing yet. Ask Connect for one, for example “Make a PDF report of last week's sales by store”.": "Henüz bir şey yok. Connect'ten bir tane isteyin, örneğin “Geçen haftanın satışlarından mağaza bazında PDF rapor hazırla”.",
  "Nothing {0} right now.": "Şu anda “{0}” durumunda öneri yok.",
  "Nothing — pick permissions by hand": "Hiçbiri — yetkileri elle seçin",
  "notification": "bildirim",
  "Notification created successfully.": "Bildirim oluşturuldu.",
  "Notification Image": "Bildirim görseli",
  "Notification Title": "Bildirim başlığı",
  "Notification Type": "Bildirim türü",
  "Notifications waiting": "Bekleyen bildirimler",
  "Now list what the customer picks, one choice at a time. Each choice becomes a step in the app: “Pick a pizza”, then “Pick a drink”…": "Şimdi müşterinin seçeceklerini tek tek listeleyin. Her seçim uygulamada bir adım olur: “Pick a pizza”, ardından “Pick a drink”…",
  "Now pick the last day.": "Şimdi son günü seçin.",
  "Number of days up to today": "Bugüne kadarki gün sayısı",
  "Number of days up to yesterday": "Düne kadarki gün sayısı",
  "Numbered list": "Numaralı liste",
  "occurrences": "gönderim",
  "of food after discounts, before delivery, tax and tip. 0 counts every order.": "tutarında yemek; indirimler düşülmüş, teslimat, vergi ve bahşiş hariç. 0 her siparişi sayar.",
  "of our web orders reached Analytics": "web siparişlerimizin Analytics'e ulaşan kısmı",
  "Of the people who joined in a given month, how many ordered again": "Belirli bir ayda katılanların kaçı yeniden sipariş verdi",
  "of them at": "tanesini",
  "of these items…": "adet bu ürünlerden…",
  "of those signups, at any time since": "bu kayıtlardan; kayıttan sonra herhangi bir zamanda",
  "of what the food would have sold for": "yemeğin normal satış değerine oranla",
  "of {0} customers with at least one order": "en az bir siparişi olan {0} müşteri içinde",
  "of {0} items": "/ {0} kalem",
  "Off": "Kapalı",
  "off": "kapalı",
  "OFF": "KAPALI",
  "off the order when it is at least $": "indirim uygulanır; sipariş en az $",
  "Offer": "Teklif",
  "Offer performance": "Teklif performansı",
  "Offers that paid off": "Karşılığını veren teklifler",
  "Offers the system has drafted from what has been selling": "Sistemin satılanlara bakarak hazırladığı teklif taslakları",
  "Offers used fewer than five times are left out.": "Beşten az kullanılan teklifler dahil edilmez.",
  "Oldest first ↑": "Eskiden yeniye ↑",
  "On": "Şu tarihte",
  "ON HAND": "MEVCUT",
  "On hand is worked out, not stored: the last count, plus everything recorded as arriving since. It is only ever as good as the last count — that is why the date is in the table rather than hidden away.": "Mevcut miktar saklanmaz, hesaplanır: son sayım ve o zamandan beri gelen olarak kaydedilen her şey. Bu yüzden ancak son sayım kadar doğrudur — tarihin gizlenmeyip tabloda yer almasının nedeni de budur.",
  "On the website": "Web sitesinde",
  "On the website now": "Şu an web sitesinde",
  "on {0}": "{0} günleri",
  "On: every change Connect prepares waits for your Confirm. Off: it runs as soon as you ask; a delete still asks you to type how many go, and Undo stays on the card.": "Açık: Connect'in hazırladığı her değişiklik, siz Onayla'ya basana kadar bekler. Kapalı: istediğiniz anda uygulanır; silme işleminde yine de kaç kaydın silineceğini yazmanız istenir ve Geri al kartta kalır.",
  "One channel, one link. Reusing the Instagram URL in an email folds the two together and neither can be told apart afterwards.": "Bir kanal, bir bağlantı. Instagram URL'sini bir e-postada tekrar kullanmak ikisini birleştirir ve sonradan ikisi birbirinden ayırt edilemez.",
  "One day, hour by hour": "Bir gün, saat saat",
  "One fixed price. You list the choices the customer makes (pizza, drink…).": "Tek bir sabit fiyat. Müşterinin yapacağı seçimleri siz listelersiniz (pizza, içecek…).",
  "One list for every store. A price here sets the stock value everywhere, and the cost of a delivery entered without a price. When the last invoice says something else, \"Use invoice price\" takes it over, with that invoice as its source. An item not in use leaves the count sheets; what was recorded for it stays.": "Tüm mağazalar için tek bir liste. Buradaki fiyat, stok değerini her yerde belirler; fiyatsız girilen bir teslimatın maliyetini de. Son fatura farklı bir fiyat gösteriyorsa \"Fatura fiyatını kullan\" bu fiyatı alır ve kaynak olarak o faturayı gösterir. Kullanımda olmayan bir kalem sayım listelerinden çıkar; onun için kaydedilenler kalır.",
  "One month, and how it compares with the last": "Bir ay ve bir önceki ayla karşılaştırması",
  "one per first-order month": "her ilk sipariş ayı için bir tane",
  "One store": "Tek mağaza",
  "One to three sentences under the title on the card": "Kartta başlığın altında yer alan bir ila üç cümle",
  "One week, day by day": "Bir hafta, gün gün",
  "One-line description": "Tek satırlık açıklama",
  "Online": "Online",
  "Online & Delivery Orders": "Online & teslimat siparişleri",
  "Online App": "Online uygulama",
  "Online Orders": "Online siparişler",
  "Online Orders Error": "Online siparişler hatası",
  "Only at the {0} selected store(s).": "Yalnızca seçili {0} mağazada.",
  "Only at {0}.": "Yalnızca şu mağazalarda: {0}.",
  "Only Delivery": "Yalnızca teslimat",
  "Only entered ({0})": "Yalnızca girilenler ({0})",
  "Only items in stock ({0})": "Yalnızca stokta olan kalemler ({0})",
  "Only items with usage data ({0})": "Yalnızca kullanım verisi olan kalemler ({0})",
  "Only JPG and PNG pictures can go in the row.": "Sıraya yalnızca JPG ve PNG görseller eklenebilir.",
  "Only Pickup": "Yalnızca gel-al",
  "Only someone who covers every store can add items or change prices: the list is shared.": "Yalnızca tüm mağazalardan sorumlu biri kalem ekleyebilir veya fiyat değiştirebilir: liste ortaktır.",
  "Only these sizes?": "Yalnızca bu boylar mı?",
  "Only this Store": "Yalnızca bu mağaza",
  "Only three of the engine's segments can appear here: a customer classed champion, loyal or regular has ordered recently, so they are not lapsed by definition. A dominant": "Burada motorun segmentlerinden yalnızca üçü görünebilir: şampiyon, sadık veya düzenli olarak sınıflanan bir müşteri yakın zamanda sipariş vermiştir, dolayısıyla tanım gereği uzaklaşmış sayılmaz. Baskın bir",
  "Only what I have entered ({0})": "Yalnızca girdiklerim ({0})",
  "Only what is actually on the shelf can be written off — you cannot throw away more than you have. If an item refuses, it usually means a delivery was never recorded rather than that the amount is wrong.": "Yalnızca gerçekten rafta olan atık olarak kaydedilebilir — elinizdekinden fazlasını atamazsınız. Bir kalem kabul edilmiyorsa, bu genellikle miktarın yanlış olduğunu değil, bir teslimatın hiç kaydedilmediğini gösterir.",
  "only {0}": "yalnızca {0} mağaza",
  "Open": "Aç",
  "Open a deal": "Bir kampanya aç",
  "Open a product": "Bir ürün aç",
  "Open a store special": "Mağazaya özel bir ürün aç",
  "Open a web page": "Bir web sayfası aç",
  "Open one to read the whole conversation, oldest message first.": "Sohbetin tamamını okumak için birini açın; en eski mesaj en üstte.",
  "open or locked, this page": "açık veya kilitli, bu sayfada",
  "Open the menu": "Menüyü aç",
  "Open the newest version": "En yeni sürümü aç",
  "Open the store's POS admin tool": "Mağazanın POS yönetim aracını açın",
  "Open · members joining": "Açık · üyeler katılıyor",
  "OPENED": "AÇILIŞ",
  "Opening": "Açılış",
  "Opening Atlas…": "Atlas açılıyor…",
  "Opening hours, delivery area and till users": "Çalışma saatleri, teslimat bölgesi ve kasa kullanıcıları",
  "Opens {0}": "{0} açılır",
  "open–{0}": "açılış–{0}",
  "OPERATING PROFIT": "FAALİYET KÂRI",
  "Operations": "Operasyonlar",
  "OPERATIONS": "OPERASYONLAR",
  "Option Amount: {0}": "Seçenek miktarı: {0}",
  "Option Hash: {0}": "Seçenek hash değeri: {0}",
  "Option item has been added successfully.": "Seçenek eklendi.",
  "Option Name: {0}": "Seçenek adı: {0}",
  "Option Unit: {0}": "Seçenek birimi: {0}",
  "Options item deleted!": "Seçenek silindi!",
  "Options item updated!": "Seçenek güncellendi!",
  "Options Load Error": "Seçenek yükleme hatası",
  "options marked LEFT or RIGHT are on one side only; unmarked options cover the whole pizza.": "SOL veya SAĞ işaretli seçenekler yalnızca bir taraftadır; işaretsiz seçenekler pizzanın tamamını kaplar.",
  "or any": "veya herhangi bir",
  "or drop it here": "ya da buraya bırakın",
  "or drop them here": "ya da buraya bırakın",
  "Or type in Turkish or English. It answers from the same numbers the pages show, with your permissions, and can draw charts and make PDF reports and Excel files.": "Ya da Türkçe veya İngilizce yazın. Sayfalarda görünen rakamlarla, sizin yetkilerinizle yanıt verir; grafik çizebilir, PDF rapor ve Excel dosyası hazırlayabilir.",
  "ORDER": "SİPARİŞ",
  "Order #{0}": "Sipariş #{0}",
  "Order #{0} force-confirmed.": "Sipariş #{0} zorla onaylandı.",
  "Order #{0} marked as paid.": "Sipariş #{0} ödendi olarak işaretlendi.",
  "ORDER %": "SİPARİŞ %",
  "Order & revenue intensity by day of week and hour": "Haftanın günü ve saate göre sipariş & ciro yoğunluğu",
  "Order channel": "Sipariş kanalı",
  "Order in the carousel": "Karuseldeki sıra",
  "Order now": "Order now",
  "Order on the Deals page": "Kampanyalar sayfasındaki sıra",
  "Order this": "Sipariş edilecekler",
  "ordered": "sipariş veren",
  "Ordered": "Sipariş veren",
  "Ordered from {0}": "Sipariş kaynağı: {0}",
  "Ordering regularly.": "Düzenli olarak sipariş veriyor.",
  "orders": "sipariş",
  "Orders": "Siparişler",
  "ORDERS": "SİPARİŞLER",
  "Orders by Channel": "Kanala göre siparişler",
  "Orders by day": "Güne göre siparişler",
  "Orders by hour": "Saate göre siparişler",
  "Orders counted": "Siparişler sayıldı",
  "Orders in 12 months": "12 aydaki siparişler",
  "orders in the last 12 months": "son 12 aydaki siparişler",
  "Orders in the last 12 months": "Son 12 aydaki siparişler",
  "Orders now and then.": "Ara sıra sipariş verir.",
  "Orders of {0} or more get {1} free ({2} per order).": "{0} ve üzeri siparişlerde {1} ücretsiz (sipariş başına {2} adet).",
  "Orders of {0} or more get {1} free.": "{0} ve üzeri siparişlerde {1} ücretsiz.",
  "Orders on a promotion": "Promosyonlu siparişler",
  "ORDERS PER WEEK": "HAFTALIK SİPARİŞ",
  "Orders placed on the website and in the apps": "Web sitesinden ve uygulamalardan verilen siparişler",
  "Orders regularly.": "Düzenli olarak sipariş verir.",
  "orders that got the discount": "indirim alan sipariş",
  "ORDERS {0}": "SİPARİŞLER {0}",
  "Orders, 12 months": "Siparişler, 12 ay",
  "Orders, 7 days": "Siparişler, 7 gün",
  "Other": "Diğer",
  "OTHER": "DİĞER",
  "Our Stories": "Our Stories",
  "Out for delivery": "Teslimata çıktı",
  "Outside the dates this page has": "Bu sayfanın tarih aralığının dışında",
  "Oven": "Fırında",
  "Oven Status": "Fırın durumu",
  "Overview": "Genel bakış",
  "Overview Error": "Genel bakış hatası",
  "P&L": "Kâr/Zarar",
  "PACK SIZE": "PAKET MİKTARI",
  "PACK UNIT": "PAKET BİRİMİ",
  "PACKS IN A CASE": "CASE BAŞINA PAKET",
  "Page": "Sayfa",
  "page the card opens": "kartın açtığı sayfa",
  "Page the card opens": "Kartın açtığı sayfa",
  "Page {0}": "Sayfa {0}",
  "page, in the order it shows them.": "sayfasında, göründükleri sırayla.",
  "Pages of one {0}": "Tek bir belgenin sayfaları",
  "Paid": "Ödendi",
  "Paragraph": "Paragraf",
  "Partly done": "Kısmen tamamlandı",
  "Passcode": "Giriş kodu",
  "Passphrase": "Parola",
  "Passphrase (8 characters or more)": "Parola (en az 8 karakter)",
  "Password": "Şifre",
  "Pasta": "Makarna",
  "Pattern Generation": "Düzenden tarih oluşturma",
  "Pattern Generation Completed": "Düzenden tarihler oluşturuldu",
  "Patterns need an end date: choose one in Expired Date.": "Tekrar düzenleri için bir bitiş tarihi gerekir: Son geçerlilik tarihi alanından bir tarih seçin.",
  "Paused": "Duraklatıldı",
  "Payment": "Ödeme",
  "Payment Breakdown Error": "Ödeme dağılımı hatası",
  "Payment by Service": "Servise göre ödeme",
  "Payment Detail": "Ödeme ayrıntısı",
  "PAYMENT METHOD": "ÖDEME YÖNTEMİ",
  "Payment Method Share": "Ödeme yöntemi payı",
  "Payments": "Ödemeler",
  "PDF": "PDF",
  "PDF report": "PDF raporu",
  "PEAK DAY": "EN YÜKSEK GÜN",
  "Peak Times Error": "Yoğun saatler hatası",
  "Pending": "Bekliyor",
  "pending": "bekliyor",
  "People": "Kişiler",
  "people": "kişi",
  "People found": "Bulunan kişiler",
  "People in the list": "Listedeki kişiler",
  "People still hold this role. Move them first.": "Bu role sahip kişiler var. Önce onları başka bir role taşıyın.",
  "People who used to order and have gone quiet": "Eskiden sipariş verip artık vermeyen kişiler",
  "Per $1": "$1 başına",
  "per order (0 = no cap):": "sipariş başına (0 = sınır yok):",
  "PER UNIT": "BİRİM BAŞINA",
  "PER WEEK": "HAFTALIK",
  "Per-store health metrics with period comparison": "Mağaza bazında sağlık göstergeleri, dönem karşılaştırmalı",
  "Percentage": "Yüzde",
  "Percentage (%)": "Yüzde (%)",
  "PERFORMANCE": "PERFORMANS",
  "Period": "Dönem",
  "PERIOD": "DÖNEM",
  "permission.": "yetkisi gerekir.",
  "Permissions": "Yetkiler",
  "person": "kişi",
  "Phone": "Telefon",
  "Phone number": "Telefon numarası",
  "Phone number cannot be empty!": "Telefon numarası boş olamaz!",
  "Phone:": "Telefon:",
  "Photo approved on #{0}.": "Kreasyon #{0} fotoğrafı onaylandı.",
  "Photo flagged": "Fotoğraf işaretlendi",
  "Photo flagged on #{0}.": "Kreasyon #{0} fotoğrafı işaretlendi.",
  "Photo needs review": "Fotoğraf inceleme bekliyor",
  "Photos awaiting": "Bekleyen fotoğraflar",
  "Photos or PDFs of invoices and bills": "Faturaların fotoğrafları veya PDF'leri",
  "Photos or PDFs: drop them all here. Each one goes to its question for you to check.": "Fotoğraflar veya PDF'ler: hepsini buraya bırakın. Her biri, kontrol etmeniz için kendi sorusuna gider.",
  "Pick a date": "Tarih seçin",
  "Pick a month": "Ay seçin",
  "Pick a store": "Bir mağaza seçin",
  "Pick at least one permission.": "En az bir yetki seçin.",
  "Pick dates": "Tarih aralığı seçin",
  "Pick one": "Birini seçin",
  "Pick the one that sounds like what you want to offer. You can change it later.": "Sunmak istediğinize en yakın olanı seçin. Daha sonra değiştirebilirsiniz.",
  "Pick your own dates": "Tarihleri kendiniz seçin",
  "pick {0}": "{0} adet seçilir",
  "Pickup": "Gel-al",
  "picture": "görsel",
  "Picture": "Görsel",
  "pictures": "görseller",
  "Pictures": "Görseller",
  "Pipeline": "Satış süreci",
  "Pizza": "Pizza",
  "Pizza contents": "Pizza içeriği",
  "Pizza size breakdown & hourly channel analysis": "Pizza boylarına göre dağılım ve saatlik kanal analizi",
  "Pizzamaker": "Pizza ustası",
  "Pizzas customers built and shared in the app. Approve the good ones, flag or hide the rest. Real photos customers upload are reviewed separately from the AI image.": "Müşterilerin uygulamada oluşturup paylaştığı pizzalar. İyi olanları onaylayın, kalanları işaretleyin veya gizleyin. Müşterilerin yüklediği gerçek fotoğraflar, AI görselinden ayrı olarak incelenir.",
  "Pizzas customers built and shared in the app: approve, flag or hide them, and review their photos": "Müşterilerin uygulamada oluşturup paylaştığı pizzalar: onaylayın, işaretleyin veya gizleyin; fotoğraflarını inceleyin",
  "plain": "şifresiz",
  "Plain text again": "Düz metne döndür",
  "Platform": "Platform",
  "PLATFORM": "PLATFORM",
  "Platinum": "Platin",
  "Please add at least one code!": "Lütfen en az bir kod ekleyin!",
  "Please add at least one date!": "Lütfen en az bir tarih ekleyin!",
  "Please add at least one pattern!": "Lütfen en az bir tekrar düzeni ekleyin!",
  "Please choose a JPG, PNG or WebP picture.": "Lütfen JPG, PNG veya WebP biçiminde bir görsel seçin.",
  "Please enter a name.": "Lütfen bir ad girin.",
  "Please enter a passcode.": "Lütfen bir giriş kodu girin.",
  "Please fill all fields!": "Lütfen tüm alanları doldurun!",
  "Please fill all pattern times!": "Lütfen tekrar düzenlerindeki tüm saatleri doldurun!",
  "Please fill date start and date end areas!": "Lütfen başlangıç ve bitiş tarihi alanlarını doldurun!",
  "Please select a product for clickable banner.": "Tıklanabilir banner için bir ürün seçin.",
  "Please select a store": "Lütfen bir mağaza seçin",
  "Please select at least one platform!": "Lütfen en az bir platform seçin!",
  "Please select at least one store": "Lütfen en az bir mağaza seçin",
  "Please select at least one store!": "Lütfen en az bir mağaza seçin!",
  "Please select both source and destination stores.": "Lütfen hem kaynak hem de hedef mağazayı seçin.",
  "Please set start and end date range first!": "Lütfen önce tarih aralığının başlangıç ve bitişini belirleyin!",
  "Please upload both web and app banner images.": "Lütfen hem web hem de uygulama banner görsellerini yükleyin.",
  "PM": "PM",
  "points": "puan",
  "Points": "Puan",
  "Points for each of them": "Her birine verilecek puan",
  "Points history, last 50": "Puan geçmişi, son 50",
  "POS": "POS",
  "POS Print": "POS yazdırma",
  "POS reset happens on the store's own POS server": "POS sıfırlama, mağazanın kendi POS sunucusunda yapılır",
  "POS reset help": "POS sıfırlama yardımı",
  "POS SALES": "POS SATIŞLARI",
  "POS Sync Completed": "POS eşitlemesi tamamlandı",
  "POS View": "POS görünümü",
  "POS {0}": "POS {0}",
  "POS: OFF": "POS: KAPALI",
  "POS: ON": "POS: AÇIK",
  "pre-selects the store, so the code has somewhere to be typed.": "mağazayı önceden seçer; böylece kodun yazılacağı bir yer olur.",
  "Prepare the sync": "Senkronizasyonu hazırla",
  "Preparing Time (secs)": "Hazırlama süresi (sn)",
  "Preparing…": "Hazırlanıyor…",
  "Press": "Şuna basın:",
  "Preview": "Önizleme",
  "Previous": "Önceki",
  "Previous month": "Önceki ay",
  "Price": "Fiyat",
  "PRICE FROM": "FİYAT KAYNAĞI",
  "Price to check": "Kontrol edilecek fiyat",
  "Printing": "Yazdırma",
  "prodcut total content": "ürün toplamı içeriği",
  "Product": "Ürün",
  "PRODUCT": "ÜRÜN",
  "Product Calculation": "Ürün hesaplaması",
  "Product cannot be empty": "Ürün boş olamaz",
  "Product cannot be empty!": "Ürün boş olamaz!",
  "product content": "ürün içeriği",
  "Product copied successfully": "Ürün kopyalandı",
  "Product has been deleted successfully.": "Ürün silindi.",
  "Product has been saved successfully.": "Ürün kaydedildi.",
  "Product image is required!": "Ürün görseli gerekli!",
  "Product is not registered in the system!": "Ürün sistemde kayıtlı değil!",
  "Product Mix Error": "Ürün dağılımı hatası",
  "Product Name": "Ürün adı",
  "Product name is required!": "Ürün adı gerekli!",
  "Product order has been updated successfully.": "Ürün sırası güncellendi.",
  "Product price is required!": "Ürün fiyatı gerekli!",
  "Product Sales": "Ürün satışları",
  "PRODUCT SALES": "ÜRÜN SATIŞLARI",
  "Product Type": "Ürün türü",
  "Product Type & Tax": "Ürün türü ve vergi",
  "Product type not recognized.": "Ürün türü tanınmadı.",
  "Product: {0}": "Ürün: {0}",
  "Products": "Ürünler",
  "Products Load Error": "Ürün yükleme hatası",
  "profit {0}": "kâr {0}",
  "Proposal has been dismissed.": "Öneri geri çevrildi.",
  "Provincial Sales Tax cannot be empty!": "Eyalet Satış Vergisi (PST) boş olamaz!",
  "PST": "PST",
  "PST (%)": "PST (%)",
  "pst content": "pst içeriği",
  "Publish": "Yayımla",
  "Published as deal #{0} — {1}": "Kampanya #{0} olarak yayımlandı — {1}",
  "Push notification": "Anlık bildirim",
  "Push Notifications": "Anlık bildirimler",
  "Put aside": "Kenara ayır",
  "Put aside ·": "Kenara ayrıldı ·",
  "QTY": "MİKTAR",
  "Qty %": "Miktar %",
  "Qty Sold": "Satılan miktar",
  "Quantities are in": "Miktarların birimi:",
  "Quantity": "Miktar",
  "Quantity & Nutrition": "Miktar ve besin değerleri",
  "Quantity by Size": "Boya göre miktar",
  "Question {0} of {1}": "Soru {0}/{1}",
  "Queue 1": "Sıra 1",
  "Queue 2": "Sıra 2",
  "Queue 3": "Sıra 3",
  "quiet": "sakin",
  "Quiet for a while. Worth one attempt.": "Bir süredir sessiz. Bir kez denemeye değer.",
  "Quiet for at least": "Sipariş vermeyeli en az",
  "Ranked by lifetime spend, not by how long they have been gone — a win-back offer is worth sending to the person who used to spend, even if someone else lapsed more recently.": "Ne kadar süredir uzak kaldıklarına göre değil, toplam harcamalarına göre sıralanır — geri kazanma teklifi, başka biri daha yakın zamanda kopmuş olsa bile, eskiden harcama yapan kişiye gönderilmeye değer.",
  "rate": "oran",
  "RATE": "ORAN",
  "Rate settings": "Oran ayarları",
  "Rates": "Oranlar",
  "Reach a minimum order and a chosen item is added free.": "Sipariş belirli bir tutara ulaşınca seçilen bir ürün ücretsiz eklenir.",
  "Reachable": "Ulaşılabilir",
  "Read Now": "Read Now",
  "Ready": "Hazır",
  "Real photo": "Gerçek fotoğraf",
  "Real-time sales from {0} — {1}": "{0} anlık satışları — {1}",
  "REASON": "NEDEN",
  "Reason (optional)": "Neden (isteğe bağlı)",
  "Reason for all lines": "Tüm satırlar için neden",
  "Receive Template Updates": "Şablon güncellemelerini al",
  "receiving template changes": "şablon değişikliklerini alıyor",
  "Recent deliveries": "Son teslimatlar",
  "Recently gone quiet — the group a win-back offer can still reach.": "Yakın zamanda sessizleşmiş — geri kazanma teklifinin hâlâ ulaşabileceği grup.",
  "Record": "Kaydet",
  "Record another": "Bir tane daha kaydet",
  "Record delivery": "Teslimatı kaydet",
  "Record more": "Daha fazla kaydet",
  "Record this delivery?": "Bu teslimat kaydedilsin mi?",
  "Recorded": "Kaydedildi",
  "Recorded as “{0}”. This cannot be undone.": "Kayıt nedeni: “{0}”. Bu işlem geri alınamaz.",
  "Recording the same invoice twice is refused, so a mistake here means entering a correcting count rather than deleting anything.": "Aynı faturanın iki kez kaydedilmesine izin verilmez; bu yüzden buradaki bir hata, bir şey silinerek değil, düzeltici bir sayım girilerek giderilir.",
  "Recovery actions": "Kurtarma işlemleri",
  "Red": "Kırmızı",
  "REDEEM RATE": "KULLANIM ORANI",
  "REDEEMED": "KULLANILAN",
  "Reducted between": "Düşüm tarihi aralığı",
  "Reducted Reports": "Düşüm raporları",
  "Reducted Reports (old)": "Düşüm raporları (eski)",
  "Referral code": "Davet kodu",
  "referral reward": "davet ödülü",
  "Refreshes every minute": "Her dakika yenilenir",
  "REGISTERED": "KAYITLI",
  "Registered, has not ordered.": "Kaydolmuş, sipariş vermemiş.",
  "Regular": "Normal",
  "Reject": "Reddet",
  "Reject it?": "Reddedilsin mi?",
  "Reject this draft?": "Bu taslak reddedilsin mi?",
  "Reject “{0}”?": "“{0}” bildirimi reddedilsin mi?",
  "Rejected": "Reddedildi",
  "Rejected. The writer has your note.": "Reddedildi. Notunuz yazan kişiye iletildi.",
  "Rejected: {0}": "Reddedildi: {0}",
  "Reject…": "Reddet…",
  "Remove": "Kaldır",
  "Remove Common Products": "Ortak ürünleri kaldır",
  "Remove the link": "Bağlantıyı kaldır",
  "Remove this deal": "Bu kampanyayı kaldır",
  "Remove this pattern": "Bu kalıbı kaldır",
  "Removed.": "Kaldırıldı.",
  "Reorder": "Yeniden sipariş",
  "Reorder Error": "Yeniden sipariş hatası",
  "Repeat": "Tekrarla",
  "Repeat every": "Tekrar aralığı",
  "Repeat it": "Tekrar girin",
  "Repeat on": "Tekrar günleri",
  "Replace": "Değiştir",
  "REPORT": "RAPOR",
  "Report assistant": "Rapor asistanı",
  "Report Error": "Rapor hatası",
  "Report Permissions": "Rapor yetkileri",
  "Reports and sheets Connect made for you, kept {0} days. Only you see them.": "Connect’in sizin için hazırladığı raporlar ve tablolar {0} gün saklanır. Bunları yalnızca siz görürsünüz.",
  "Request access": "Erişim iste",
  "Request access…": "Erişim iste…",
  "Request failed": "İstek başarısız oldu",
  "Reschedule": "Yeniden planla",
  "Rescheduled": "Yeniden planlandı",
  "Retention Cohorts Error": "Elde tutma kohortları hatası",
  "Retry the failed stores": "Başarısız mağazaları yeniden dene",
  "Return": "Getiri",
  "Returning": "Geri dönen",
  "REV %": "CİRO %",
  "revenue": "ciro",
  "Revenue": "Ciro",
  "REVENUE": "CİRO",
  "Revenue analysis & orders by ordering channels": "Sipariş kanallarına göre ciro analizi ve siparişler",
  "Revenue basis": "Ciro esası",
  "Revenue by Channel": "Kanala göre ciro",
  "Revenue by Day Part": "Gün dilimine göre ciro",
  "Revenue by Size": "Boya göre ciro",
  "Revenue by Store": "Mağazaya göre ciro",
  "Revenue Comparison": "Ciro karşılaştırması",
  "Revenue Drop": "Ciro düşüşü",
  "REVENUE RANK": "CİRO SIRASI",
  "Revenue Shape": "Ciro profili",
  "Revenue split by meal periods — Breakfast, Lunch, Afternoon, Dinner, Late Night": "Öğün dilimlerine göre ciro — Kahvaltı, Öğle, Öğleden sonra, Akşam, Gece",
  "Revenue split by payment method": "Ödeme yöntemine göre ciro dağılımı",
  "REVENUE {0}": "CİRO {0}",
  "Revenue, this window": "Ciro, bu aralık",
  "Review": "İncele",
  "Review every change ({0})": "Tüm değişiklikleri incele ({0})",
  "Rewards": "Ödüller",
  "Rewards at weeks {0}": "Ödül verilen haftalar: {0}",
  "Rewards QR on the More tab": "More sekmesinde ödül QR kodu",
  "RIGHT": "SAĞ",
  "Right now this only records who should have what. Nothing is enforced yet; the panel behaves exactly as before until the roles you build here are switched on.": "Şu anda bu yalnızca kimin neye sahip olması gerektiğini kaydeder. Henüz hiçbir şey uygulanmıyor; burada oluşturduğunuz roller açılana kadar panel tam olarak eskisi gibi çalışır.",
  "role": "rol",
  "Role": "Rol",
  "Role deleted.": "Rol silindi.",
  "Role name": "Rol adı",
  "role not loaded": "rol yüklenmedi",
  "Role saved.": "Rol kaydedildi.",
  "Role updated.": "Rol güncellendi.",
  "Roles": "Roller",
  "Roles could not be loaded.": "Roller yüklenemedi.",
  "Row of pictures": "Görsel sırası",
  "Royalty": "Royalti",
  "Royalty %": "Royalti %",
  "Royalty & fees": "Royalti ve ücretler",
  "Royalty & Fees": "Royalti ve ücretler",
  "Royalty and marketing fees per store, per month": "Mağaza ve ay bazında royalti ve pazarlama ücretleri",
  "ROYALTY BASIS": "ROYALTİ ESASI",
  "ROYALTY DUE": "ÖDENECEK ROYALTİ",
  "Royalty Error": "Royalti hatası",
  "ROYALTY PAID": "ÖDENEN ROYALTİ",
  "Rules": "Kurallar",
  "Run an offer": "Kampanya başlat",
  "Runs whenever it is switched on.": "Kampanya açık olduğu sürece geçerlidir.",
  "Runs {0}.": "Kampanya {0} geçerlidir.",
  "Salat": "Salata",
  "Sales": "Satış",
  "SALES": "SATIŞ",
  "Sales by Platform": "Platforma göre satış",
  "Sales by Product Types": "Ürün türlerine göre satış",
  "Sales by Products": "Ürünlere göre satış",
  "Sales by Service": "Servise göre satış",
  "Sales by size": "Boya göre satış",
  "sales per $1 off": "$1 indirim başına satış",
  "Sales Reports": "Satış raporları",
  "Sales so far today": "Bugün şu ana kadarki satışlar",
  "Sales summary": "Satış özeti",
  "Sales summary error": "Satış özeti hatası",
  "Sales tax and tips are never in the basis — they were never the store's money to keep. Bottle deposits are left out by default for the same reason: they go back to the customer with the bottle.": "Satış vergisi ve bahşişler asla esasa dahil edilmez — bunlar zaten hiçbir zaman mağazanın kendisine kalacak para değildi. Şişe depozitoları da aynı nedenle varsayılan olarak hariç tutulur: şişeyle birlikte müşteriye geri döner.",
  "Sales to Report": "Raporlanacak satış",
  "Sales vs the day before": "Satış, önceki güne göre",
  "Sales vs the week before": "Satış, önceki haftaya göre",
  "Sales vs the {0} days before": "Satış, önceki {0} güne göre",
  "Sales, 7 days": "Satış, 7 gün",
  "Sales, day by day": "Satış, gün gün",
  "SALES, FINISHED STORES": "SATIŞ, TAMAMLANAN MAĞAZALAR",
  "Same as assigning it on the Users page. They will see it after signing in again.": "Kullanıcılar sayfasında atamakla aynıdır. Yeniden giriş yaptıktan sonra görür.",
  "same orders, after discounts": "aynı siparişler, indirimlerden sonra",
  "Same period before": "Önceki eş dönem",
  "Sat": "Cmt",
  "Saturday": "Cumartesi",
  "Save": "Kaydet",
  "SAVE": "KAYDET",
  "SAVE $12": "SAVE $12",
  "Save and publish": "Kaydet ve yayımla",
  "Save changes": "Değişiklikleri kaydet",
  "Save Changes": "Değişiklikleri kaydet",
  "Save failed.": "Kaydedilemedi.",
  "Save failed. The featured-products service may not be installed yet.": "Kaydedilemedi. Öne çıkan ürünler servisi henüz kurulmamış olabilir.",
  "Save levels": "Seviyeleri kaydet",
  "Save rates": "Oranları kaydet",
  "Save targeting": "Hedeflemeyi kaydet",
  "Save targets and rates": "Hedefleri ve oranları kaydet",
  "Save the corrections": "Düzeltmeleri kaydet",
  "Save the loyalty rules?": "Sadakat kuralları kaydedilsin mi?",
  "Save to publish to the app.": "Uygulamada yayımlamak için kaydedin.",
  "Saved": "Kaydedildi",
  "Saved 1 featured product.": "1 öne çıkan ürün kaydedildi.",
  "Saved links": "Kayıtlı bağlantılar",
  "saved {0}": "son kayıt: {0}",
  "Saved {0} featured products.": "{0} öne çıkan ürün kaydedildi.",
  "Saved.": "Kaydedildi.",
  "Saved. Customers get it from their next voice session.": "Kaydedildi. Müşterilerin bir sonraki sesli oturumundan itibaren geçerli olacak.",
  "Saved. The app uses the new rules from now on.": "Kaydedildi. Uygulama bundan sonra yeni kuralları kullanacak.",
  "Saving puts your changes on the website at once.": "Kaydettiğinizde değişiklikleriniz hemen web sitesinde yayımlanır.",
  "Saving sends it back for approval.": "Kaydettiğinizde yeniden onaya gönderilir.",
  "Saving sends your changes to an administrator. They go on the website once an administrator approves them.": "Kaydettiğinizde değişiklikleriniz bir yöneticiye gönderilir. Bir yönetici onayladığında web sitesinde yayımlanır.",
  "Saving...": "Kaydediliyor...",
  "Saving…": "Kaydediliyor…",
  "Scan bills": "Faturaları tara",
  "Scan or upload": "Tara veya yükle",
  "scheduled": "planlandı",
  "Scheduled": "Planlanan",
  "Scheduled At": "Planlanan zaman",
  "Scheduled time cannot be in the past.": "Planlanan zaman geçmişte olamaz.",
  "Scheduled time is required.": "Planlanan zaman gerekli.",
  "Scheduled: {0}": "Planlanan: {0}",
  "Schedules": "Zamanlamalar",
  "Scope": "Kapsam",
  "Scope:": "Kapsam:",
  "Search by coupon name/code/message": "Kupon adı/kodu/mesajına göre ara",
  "Search by creation name, creator e-mail or customer ID…": "Kreasyon adı, oluşturanın e-postası veya müşteri ID'sine göre ara…",
  "Search by invite code, host e-mail or customer ID…": "Davet kodu, düzenleyenin e-postası veya müşteri ID'sine göre ara…",
  "Search by name or area": "Ada veya alana göre ara",
  "Search by order #, name, email or phone…": "Sipariş #, ad, e-posta veya telefona göre ara…",
  "Search key is too short!": "Arama ifadesi çok kısa!",
  "Search products by name or menu...": "Ürünleri ada veya menüye göre ara...",
  "Search products by name…": "Ürünleri ada göre ara…",
  "Search...": "Ara...",
  "Second Item": "İkinci ürün",
  "Second Item (Max)": "İkinci ürün (maks.)",
  "seconds": "saniye",
  "section. Pick": "bölümü. Seçin:",
  "See how sales are going": "Satışların gidişatını gör",
  "See it on the website": "Web sitesinde gör",
  "Segment": "Segment",
  "SEGMENT": "SEGMENT",
  "Segments": "Segmentler",
  "Select a menu": "Menü seçin",
  "Select a shift": "Bir vardiya seçin",
  "Select a store": "Bir mağaza seçin",
  "Select at least one store.": "En az bir mağaza seçin.",
  "Select Products": "Ürünleri seçin",
  "Select Unit": "Birim seçin",
  "selected above": "yukarıda seçili",
  "selected segment": "seçili segment",
  "Selected Stores": "Seçili mağazalar",
  "selected tier — the two lists are combined with OR, not AND. Targeting a deal also hides it from customers who are not signed in, since there is no profile to match against.": "seçili seviye — iki liste VE ile değil, VEYA ile birleştirilir. Bir kampanyayı hedeflemek, onu oturum açmamış müşterilerden de gizler; çünkü eşleştirilecek bir profil yoktur.",
  "Send": "Gönder",
  "Send a message to the app on a customer's phone": "Müşterinin telefonundaki uygulamaya mesaj gönderin",
  "Send a push notification to the app": "Uygulamaya anlık bildirim gönderin",
  "Send a text message to customers": "Müşterilere kısa mesaj gönderin",
  "Send again": "Tekrar gönder",
  "Send for approval": "Onaya gönder",
  "Send it again at another time, or repeat it": "Başka bir zamanda yeniden gönderin ya da tekrarlayın",
  "Send my last menu change to the tills": "Son menü değişikliğimi kasalara gönder",
  "Send request": "İsteği gönder",
  "Send targeted push notifications to your customers": "Müşterilerinize hedefli anlık bildirimler gönderin",
  "Send to All Customers": "Tüm müşterilere gönder",
  "Send to Brand": "Markaya gönder",
  "Send to Stores": "Mağazalara gönder",
  "Send {0} times": "{0} kez gönder",
  "Sends again once, on {0}.": "{0} tarihinde bir kez yeniden gönderir.",
  "Sends again {0} times: first {1}, last {2}.": "{0} kez yeniden gönderir: ilki {1}, sonuncusu {2}.",
  "Sends exactly what customers' phones will get (as the sender does), to the team's test phones": "Müşteri telefonlarına gidecek olanın aynısını (gönderici gibi) ekibin test telefonlarına gönderir",
  "Sent": "Gönderildi",
  "sent": "gönderildi",
  "Sent {0}": "Gönderildi: {0}",
  "Sent. An administrator will see it in their Approvals.": "Gönderildi. Bir yönetici bunu Onaylar bölümünde görecek.",
  "Sent:": "Gönderildi:",
  "Separate": "Ayrı",
  "Seperated": "Ayrı",
  "Service": "Servis",
  "SERVICE": "SERVİS",
  "Service type": "Servis türü",
  "Service Type": "Servis türü",
  "Session": "Oturum",
  "Session closed for everyone.": "Oturum herkes için kapatıldı.",
  "Session expired (inactive too long)": "Oturumun süresi doldu (çok uzun süre işlem yapılmadı)",
  "Session was cancelled": "Oturum iptal edildi",
  "Session was created": "Oturum oluşturuldu",
  "sessions": "oturumlar",
  "SESSIONS": "OTURUMLAR",
  "Sessions in view": "Görünen oturumlar",
  "Sessions where several people add to one shared cart and check out together.": "Birkaç kişinin tek bir ortak sepete ürün ekleyip birlikte ödeme yaptığı oturumlar.",
  "Set": "Ayarlayın:",
  "Set how much the rewarded item is discounted (100 = free)": "Ödül olarak verilen ürünün ne kadar indirimli olacağını belirleyin (100 = ücretsiz)",
  "Set the amount taken off the order": "Siparişten düşülecek tutarı belirleyin",
  "Set the combo price": "Kombo fiyatını belirleyin",
  "Set the discount percentage": "İndirim yüzdesini belirleyin",
  "Set the minimum order amount": "Minimum sipariş tutarını belirleyin",
  "Set the minimum to 0 to give the discount on every order.": "Her siparişte indirim vermek için minimumu 0 yapın.",
  "Set up a store": "Mağaza ayarla",
  "Set up the encryption first (top of the Chat tab).": "Önce şifrelemeyi kurun (Sohbet sekmesinin en üstünde).",
  "Sets it to paid and clears the remaining balance on the central record only.": "Siparişi ödendi olarak işaretler ve kalan bakiyeyi yalnızca merkezi kayıtta sıfırlar.",
  "Sets the status to 'Confirmed by store'. Your reason is also appended to the store notes.": "Durumu 'Mağaza onayladı' yapar. Gerekçeniz mağaza notlarına da eklenir.",
  "Settings": "Ayarlar",
  "SETTINGS": "AYARLAR",
  "settled": "tam ödendi",
  "Shaded against the busiest single slot ({0} orders), on a square-root ramp: a dinner rush is several times any lunch hour, and a linear ramp would flatten every other trading hour to the same near-empty grey. Hours are 24-hour store local time, and the row is the day the order was placed — a 01:00 Saturday cell is Friday night's late trade. {1}": "Tonlar en yoğun tek zaman dilimine göre verilir ({0} sipariş), karekök ölçeğiyle: akşam yoğunluğu herhangi bir öğle saatinin birkaç katıdır ve doğrusal bir ölçek diğer tüm satış saatlerini aynı, neredeyse boş griye düzleştirirdi. Saatler mağazanın yerel saatine göre 24 saat biçimindedir ve satır, siparişin verildiği gündür — Cumartesi 01:00 hücresi, Cuma gecesinin geç saat satışıdır. {1}",
  "Share": "Pay",
  "SHARE": "PAY",
  "Share of everyone who ever ordered": "Şimdiye kadar sipariş veren herkes içindeki pay",
  "SHARE OF ORDERS": "SİPARİŞ PAYI",
  "Share of signups": "Kayıt payı",
  "SHARE OF THAT TRAFFIC": "BU TRAFİKTEKİ PAY",
  "Shared-cart sessions: who joined, what they added, and a way to close one": "Ortak sepet oturumları: kim katıldı, ne ekledi; ayrıca oturumu kapatma seçeneği",
  "Shift": "Vardiya",
  "Shift Permissions": "Vardiya yetkileri",
  "Shift Report": "Vardiya raporu",
  "Shift Report Error": "Vardiya raporu hatası",
  "Short by": "Eksik",
  "SHORT BY": "EKSİK",
  "short delivery, missing item…": "eksik teslimat, gelmeyen ürün…",
  "Short description shown in the app": "Uygulamada gösterilen kısa açıklama",
  "short text": "kısa metin",
  "Short text": "Kısa metin",
  "Short. “SAVE $12”, “2 FOR 1”, “NEW”.": "Kısa. “SAVE $12”, “2 FOR 1”, “NEW”.",
  "Show": "Göster",
  "Show all {0}": "Tümünü göster ({0})",
  "Show as table": "Tablo olarak göster",
  "Show chart": "Grafiği göster",
  "Show fewer": "Daha az göster",
  "Show less": "Daha az göster",
  "Show password": "Şifreyi göster",
  "Show the coupons in one state": "Kuponları tek bir duruma göre göster",
  "Show this day in the list": "Bu günü listede göster",
  "Showing in Branch": "Şubede gösteriliyor",
  "Showing on Kiosk": "Kioskta gösteriliyor",
  "Showing on Mobile App": "Mobil uygulamada gösteriliyor",
  "Showing on Website": "Web sitesinde gösteriliyor",
  "Showing the last {0} days of {1}. The rate above covers the whole window.": "Son {0} gün gösteriliyor (toplam {1} gün). Yukarıdaki oran tüm dönemi kapsar.",
  "Showing the {0} {1} {2}.": "Gösterilen: {0} kupon ({1}).",
  "Showing {0} of {1} — narrow the filters to see the rest.": "Gösterilen: {0}/{1} — geri kalanını görmek için filtreleri daraltın.",
  "Showing {0}–{1} of {2}": "Gösterilen: {0}–{1} / {2}",
  "shown": "gösterilen",
  "Shown so the basis can be reconciled against a bank statement: total collected is what the customer paid on the POS sales, which is larger than their basis by tax, tips and whatever the rate settings leave out (deposits, and delivery fees when excluded).": "Esasın banka ekstresiyle karşılaştırılabilmesi için gösterilir: toplam tahsilat, müşterinin POS satışlarında ödediği tutardır; bu da esastan vergi, bahşiş ve oran ayarlarının dışarıda bıraktığı kalemler (depozitolar ve hariç tutulduğunda teslimat ücretleri) kadar fazladır.",
  "Shows up as:": "Şurada görünür:",
  "Side panel": "Yan panel",
  "Sign out": "Çıkış yap",
  "Signed up in the iOS or Android app.": "iOS veya Android uygulamasından kaydoldu.",
  "Signed up on the website.": "Web sitesinden kaydoldu.",
  "Signed up via": "Kayıt kanalı",
  "signed up → first order": "kayıt → ilk sipariş",
  "Signups": "Kayıtlar",
  "signups ({0} activated)": "kayıt ({0} aktive oldu)",
  "Signups are brand-wide however the location picker is set.": "Mağaza seçici nasıl ayarlanırsa ayarlansın kayıtlar marka genelindedir.",
  "Signups per day": "Günlük kayıtlar",
  "Signups per day between {0} and {1}": "{0} ile {1} arasındaki günlük kayıtlar",
  "Silver": "Gümüş",
  "Simli face ID": "Simli yüz kimliği",
  "since {0}": "{0} tarihinden beri",
  "Single": "Tekli",
  "SINGLE": "TEKLİ",
  "Single Use": "Tek kullanımlık",
  "Size": "Boy",
  "SIZE": "BOY",
  "Size Detail": "Boy ayrıntısı",
  "Size is required": "Boy gerekli",
  "Size of the free item": "Ücretsiz ürünün boyu",
  "Size Sales Error": "Boy satışları hatası",
  "Size View": "Boy görünümü",
  "Size × Channel Matrix": "Boy × kanal matrisi",
  "Size: {0}": "Boy: {0}",
  "Sizes & Pricing": "Boylar ve fiyatlar",
  "Sizes for the free item:": "Ücretsiz ürün için boylar:",
  "sizes: {0}": "boylar: {0}",
  "SKIP": "SKIP",
  "SKU": "SKU",
  "Slice": "Dilim",
  "Slot {0}": "Parça {0}",
  "Slots": "Kombo parçaları",
  "Slowing down.": "Siparişleri seyrekleşiyor.",
  "Small badge": "Küçük rozet",
  "SMALLEST CHANNEL": "EN KÜÇÜK KANAL",
  "Smallest order that counts for a week": "Haftaya sayılan en küçük sipariş",
  "SMS": "SMS",
  "SMS campaign created successfully": "SMS kampanyası oluşturuldu",
  "SMS Campaigns": "SMS kampanyaları",
  "SMS Error": "SMS hatası",
  "SMS Load Error": "SMS yükleme hatası",
  "SMS Message": "SMS mesajı",
  "SMS message is required": "SMS mesajı gerekli",
  "SMS Panel": "SMS paneli",
  "SMS Save Error": "SMS kaydetme hatası",
  "SMS sent to brand customers successfully": "Marka müşterilerine SMS gönderildi",
  "SMS sent to store customers successfully": "Mağaza müşterilerine SMS gönderildi",
  "So far": "Şu ana kadar",
  "Social Hub": "Social Hub",
  "Social Templates": "Sosyal medya şablonları",
  "Someone joined": "Biri katıldı",
  "Someone left": "Biri ayrıldı",
  "someone may do; their locations say": "yapabileceğini belirler; bağlı olduğu mağazalar ise",
  "Something went wrong!": "Bir sorun oluştu!",
  "Something went wrong, Please try again later": "Bir sorun oluştu, lütfen daha sonra tekrar deneyin",
  "Something went wrong.": "Bir sorun oluştu.",
  "Source": "Kaynak",
  "Source and destination stores must be different.": "Kaynak ve hedef mağaza farklı olmalı.",
  "sparkles": "sparkles",
  "Speak in any language. Each answer shows below as it is saved; you can still type.": "Herhangi bir dilde konuşun. Her cevap kaydedildikçe aşağıda görünür; yine de yazabilirsiniz.",
  "Speak in any language; changes still wait for your Confirm on the card.": "Herhangi bir dilde konuşun; değişiklikler yine de karttaki Onayla düğmesine basmanızı bekler.",
  "Special Product": "Özel ürün",
  "Special Products": "Özel ürünler",
  "Spend": "Harcama",
  "SPEND": "HARCAMA",
  "Spend $60, get a free garlic bread": "$60 harca, ücretsiz sarımsaklı ekmek kazan",
  "Spend & get free": "Harca & ücretsiz kazan",
  "Spend how much, and get what?": "Ne kadar harcasın, karşılığında ne alsın?",
  "spent": "harcandı",
  "spent on order #{0}": "sipariş #{0} için harcandı",
  "Split by shift rather than by clock hour": "Saat yerine vardiyaya göre bölünmüş",
  "staff discount, no coupon, deal or points": "personel indirimi; kupon, kampanya veya puan yok",
  "Standard": "Standart",
  "Start": "Başlat",
  "Start a new count": "Yeni sayım başlat",
  "Start a new role from this one": "Bunu temel alarak yeni rol oluştur",
  "Start date": "Başlangıç tarihi",
  "Start Date": "Başlangıç tarihi",
  "Start from": "Başlangıç noktası",
  "Start syncing.": "Eşitleme başladı.",
  "Start Time": "Başlangıç saati",
  "Start time must be before end time!": "Başlangıç saati bitiş saatinden önce olmalı!",
  "Start Time:": "Başlangıç saati:",
  "Started {0}": "Başlangıç: {0}",
  "started {0}; visits go back much further": "başlangıç: {0}; ziyaret verileri çok daha eskiye uzanır",
  "started, not finished": "başlanmış, bitmemiş",
  "Starting Date": "Başlangıç tarihi",
  "Starts": "Başlangıç",
  "starts {0}": "{0} tarihinde başlıyor",
  "Status": "Durum",
  "Stock Amount": "Stok miktarı",
  "Stock at every store side by side": "Her mağazadaki stok, yan yana",
  "Stock Audit has been saved successfully": "Stok denetimi kaydedildi",
  "Stock Audit has been updated successfully": "Stok denetimi güncellendi",
  "Stock Audit has not been saved successfully": "Stok denetimi kaydedilemedi",
  "Stock Audit has not been updated successfully": "Stok denetimi güncellenemedi",
  "Stock Audit list loaded successfully": "Stok denetimi listesi yüklendi",
  "Stock Audit list not loaded": "Stok denetimi listesi yüklenemedi",
  "Stock cannot be blank!": "Stok boş olamaz!",
  "Stock Count": "Stok sayımı",
  "Stock Count Error": "Stok sayımı hatası",
  "Stock Error": "Stok hatası",
  "Stock has been deleted successfully": "Stok silindi",
  "Stock has been deleted successfully!": "Stok silindi!",
  "Stock has been saved successfully!": "Stok kaydedildi!",
  "Stock has been updated successfully!": "Stok güncellendi!",
  "Stock has not been deleted successfully": "Stok silinemedi",
  "Stock is held per store. Choose which one from the selector at the top left.": "Stok mağaza bazında tutulur. Sol üstteki seçiciden mağazayı seçin.",
  "Stock list": "Stok listesi",
  "Stock Name": "Stok adı",
  "Stock name cannot be empty!": "Stok adı boş olamaz!",
  "Stock on hand": "Eldeki stok",
  "Stock Quantity": "Stok miktarı",
  "Stock Report list not loaded": "Stok raporu listesi yüklenemedi",
  "Stock SKU cannot be empty!": "Stok SKU'su boş olamaz!",
  "Stock Transactions": "Stok hareketleri",
  "Stock Unit": "Stok birimi",
  "Stock unit cannot be empty!": "Stok birimi boş olamaz!",
  "Stock unit price cannot be empty!": "Stok birim fiyatı boş olamaz!",
  "Stock unit price cannot be zero or negative!": "Stok birim fiyatı sıfır veya negatif olamaz!",
  "STOCK VALUE": "STOK DEĞERİ",
  "Stocks": "Stoklar",
  "Stop": "Durdur",
  "Stop talking": "Konuşmayı bitir",
  "Store": "Mağaza",
  "STORE": "MAĞAZA",
  "store #{0}": "mağaza #{0}",
  "Store #{0}": "Mağaza #{0}",
  "Store Benchmark": "Mağaza kıyaslaması",
  "Store Benchmark Error": "Mağaza karşılaştırma hatası",
  "Store Breakdown": "Mağaza dağılımı",
  "Store Comparison": "Mağaza karşılaştırması",
  "STORE COMPARISON": "MAĞAZA KARŞILAŞTIRMASI",
  "Store Dashboard Error": "Mağaza panosu hatası",
  "STORE DEMAND AND STORE PAGE TRAFFIC": "MAĞAZA TALEBİ VE MAĞAZA SAYFASI TRAFİĞİ",
  "Store detail": "Mağaza ayrıntısı",
  "Store league table": "Mağaza sıralama tablosu",
  "Store Location": "Mağaza konumu",
  "Store Menu": "Mağaza menüsü",
  "Store notes:": "Mağaza notları:",
  "STORE PAGE VISITS": "MAĞAZA SAYFASI ZİYARETLERİ",
  "Store performance": "Mağaza performansı",
  "Store Rankings": "Mağaza sıralaması",
  "Store scorecard": "Mağaza karnesi",
  "Store Scorecard": "Mağaza karnesi",
  "Store Scorecard Error": "Mağaza karnesi hatası",
  "Store special: {0}": "Mağazaya özel ürün: {0}",
  "Store Switch Error": "Mağaza değiştirme hatası",
  "STORE {0}": "MAĞAZA {0}",
  "STORE'S MENU": "MAĞAZANIN MENÜSÜ",
  "Store:": "Mağaza:",
  "stores": "mağaza",
  "Stores": "Mağazalar",
  "Stores saved.": "Mağazalar kaydedildi.",
  "Stores today": "Mağazalarda bugün",
  "STORES TRADING": "SATIŞ YAPAN MAĞAZALAR",
  "stores, {0}": "mağaza, {0}",
  "Story": "Yazı",
  "Story Content/Article": "Hikâye içeriği/Makale",
  "Story Cover Page": "Hikâye kapak sayfası",
  "Streak": "Seri",
  "Streak reward": "Seri ödülü",
  "Subheading": "Alt başlık",
  "Submit": "Gönder",
  "Submit count": "Sayımı gönder",
  "Submit this count?": "Bu sayım gönderilsin mi?",
  "Subtotal": "Ara toplam",
  "Subtotal :": "Ara toplam :",
  "Success": "Başarılı",
  "SUGGESTED": "ÖNERİLEN",
  "Suggested deals": "Önerilen kampanyalar",
  "suggested, all stores": "önerilen, tüm mağazalar",
  "Sum: {0}": "Toplam: {0}",
  "Summary": "Özet",
  "Sun": "Paz",
  "Sunday": "Pazar",
  "Suppliers offered first (one per line)": "Önce önerilecek tedarikçiler (her satıra bir tane)",
  "Switch a product back on at this store": "Bir ürünü bu mağazada yeniden aç",
  "Switch off": "Kapat",
  "Switch on": "Aç",
  "Switch to dark": "Koyu temaya geç",
  "Switch to light": "Açık temaya geç",
  "switched off": "kapalı",
  "Sync Deliverect": "Deliverect ile senkronize et",
  "Sync failed": "Eşitleme başarısız oldu",
  "Sync List": "Listeyi senkronize et",
  "Sync paused": "Eşitleme duraklatıldı",
  "Sync to the tills": "Kasalarla eşitle",
  "Sync unavailable": "Eşitleme kullanılamıyor",
  "Synced": "Eşitlendi",
  "Synced successfully.": "Eşitlendi.",
  "Syncing": "Eşitleniyor",
  "Sysco SUPC": "Sysco SUPC",
  "Table": "Tablo",
  "Take $": "Siparişe $",
  "Take back": "Geri al",
  "Take it again": "Yeniden çek",
  "taken": "alınan",
  "Takeout": "Al-götür",
  "Takings and orders for the last few days at a glance": "Son birkaç günün cirosu ve siparişleri tek bakışta",
  "Talk": "Konuş",
  "Talk again": "Yeniden konuş",
  "Talk with Connect": "Connect ile konuş",
  "Talk with Connect in any language": "Connect ile herhangi bir dilde konuş",
  "Talking with Connect": "Connect ile konuşma",
  "Talking with the report assistant": "Rapor asistanıyla konuşma",
  "Tall, about 3 × 4": "Dikey, yaklaşık 3 × 4",
  "Target": "Hedef",
  "TARGET": "HEDEF",
  "Target levels": "Hedef seviyeler",
  "target levels updated": "hedef seviyeler güncellendi",
  "Target Menu": "Hedef menü",
  "Target Store": "Hedef mağaza",
  "Targeted": "Hedefli",
  "Targeting has been updated.": "Hedefleme güncellendi.",
  "Targets and rates": "Hedefler ve oranlar",
  "Tax": "Vergi",
  "TAX": "VERGİ",
  "Taxes (Delivery)": "Vergiler (Teslimat)",
  "Taxes (GST)": "Vergiler (GST)",
  "Taxes (PST)": "Vergiler (PST)",
  "Team chat": "Ekip sohbeti",
  "Term": "Terim",
  "Test": "Test et",
  "Test (live format)": "Test et (canlı biçim)",
  "Test Phone Number:": "Test telefon numarası:",
  "Test SMS": "SMS'i test et",
  "Test SMS sent successfully": "Test SMS'i gönderildi",
  "Text": "Metin",
  "text above the pictures": "görsellerin üstündeki metin",
  "Text above the pictures": "Görsellerin üstündeki metin",
  "text below the pictures": "görsellerin altındaki metin",
  "Text below the pictures": "Görsellerin altındaki metin",
  "That backup does not match the key on the server. Make a new key instead.": "Bu yedek, sunucudaki anahtarla eşleşmiyor. Bunun yerine yeni bir anahtar oluşturun.",
  "That change could not be opened.": "Bu değişiklik açılamadı.",
  "That file is not there any more.": "Bu dosya artık yok.",
  "That is not the passphrase.": "Parola yanlış.",
  "That new story is no longer waiting for approval.": "Bu yeni yazı artık onay beklemiyor.",
  "That picture is {0} MB. The limit is 2 MB — make it smaller and try again.": "Bu görsel {0} MB. Sınır 2 MB — görseli küçültüp yeniden deneyin.",
  "That picture link does not load.": "Bu görsel bağlantısı yüklenmiyor.",
  "That story is not on the website any more.": "Bu yazı artık web sitesinde değil.",
  "That’s everything for {0}. Here is the month. If it looks right, I’ll make the Excel report.": "{0} için hepsi bu kadar. İşte ayın özeti. Doğru görünüyorsa Excel raporunu hazırlayacağım.",
  "The AI host's voice modes, avatar face and session limits": "Uygulamadaki AI asistanının ses modları, avatar yüzü ve oturum sınırları",
  "The app asks the customer which one they want.": "Uygulama, müşteriye hangisini istediğini sorar.",
  "The app uses them at once: tiers are counted again tonight, and streak rewards change straight away.": "Uygulama bunları hemen kullanır: seviyeler bu gece yeniden hesaplanır, seri ödülleri ise anında değişir.",
  "The apps report no visits at all — they carry no analytics SDK, only server-sent purchases. {0} app orders in this window have no denominator anywhere, so adding them would inflate the rate by about half again.": "Uygulamalar hiç ziyaret bildirmez — içlerinde analiz SDK'sı yoktur, yalnızca sunucudan gönderilen satın almalar vardır. Bu dönemdeki {0} uygulama siparişinin hiçbir yerde paydası yoktur; bunları eklemek oranı yaklaşık bir buçuk katına çıkarırdı.",
  "The area a store delivers to, and the fee for each zone": "Mağazanın teslimat yaptığı alan ve her bölgenin ücreti",
  "The area a store delivers to, and the fee for each zone.": "Mağazanın teslimat yaptığı alan ve her bölgenin ücreti.",
  "The article you write in step 3": "3. adımda yazacağınız makale",
  "The assistant is not switched on on this server.": "Asistan bu sunucuda açık değil.",
  "The assistant is the server; its lines are not encrypted": "Asistan sunucunun kendisidir; mesajları şifrelenmez",
  "The assistant is writing": "Asistan yazıyor",
  "The avatar's face": "Avatarın yüzü",
  "The badge, title and picture above are what the carousel card shows. Website picture banners are separate (Marketing → Banners).": "Karusel kartında yukarıdaki rozet, başlık ve görsel gösterilir. Web sitesindeki görselli banner'lar ayrıdır (Pazarlama → Banner'lar).",
  "The banner is saved, but where it goes when tapped is not.": "Banner kaydedildi, ancak dokunulduğunda gideceği yer kaydedilmedi.",
  "The bottom stays as every visit": "Payda tüm ziyaretler olarak kalır",
  "The browser blocked the new tab. Allow pop-ups for Connect and try again.": "Tarayıcı yeni sekmeyi engelledi. Connect için açılır pencerelere izin verin ve tekrar deneyin.",
  "The card opens": "Kart şunu açar:",
  "The card people see on the website's stories page.": "Ziyaretçilerin web sitesindeki hikayeler sayfasında gördüğü kart.",
  "The choices customers add to an item, and what they cost": "Müşterilerin bir ürüne eklediği seçenekler ve fiyatları",
  "The choices customers add to an item, and what they cost.": "Müşterilerin bir ürüne eklediği seçenekler ve fiyatları.",
  "The code customers show in the store to collect points.": "Müşterilerin puan toplamak için mağazada gösterdiği kod.",
  "The customer buys": "Müşteri satın alır:",
  "The customer can choose from these menu categories": "Müşteri bu menü kategorilerinden seçebilir",
  "The customer named this base pizza without customising it.": "Müşteri bu temel pizzayı özelleştirmeden adlandırdı.",
  "The day after": "Sonraki gün",
  "The day before": "Önceki gün",
  "The day split into trading periods": "Satış dilimlerine ayrılmış gün",
  "The deal is created switched OFF — turn it on from the Dashboard when you are ready.": "Kampanya KAPALI olarak oluşturulur — hazır olduğunuzda Pano'dan açın.",
  "The end date is before the start date": "Bitiş tarihi başlangıç tarihinden önce",
  "The end is before the start.": "Bitiş zamanı başlangıçtan önce.",
  "The engine could not validate this draft": "Motor bu taslağı doğrulayamadı",
  "the headline": "ana rakam",
  "The host and members will see it as cancelled. This cannot be undone.": "Düzenleyen ve üyeler bunu iptal edilmiş olarak görür. Bu işlem geri alınamaz.",
  "The internal key is empty (More options)": "Dahili anahtar boş (Diğer seçenekler)",
  "The items every store counts, and their prices": "Her mağazanın saydığı stok kalemleri ve fiyatları",
  "The last 100 messages.": "Son 100 mesaj.",
  "the last 14 days": "son 14 gün",
  "the last 30 days": "son 30 gün",
  "the last 7 days": "son 7 gün",
  "The last 7 days against the 7 before": "Son 7 gün, önceki 7 günle karşılaştırmalı",
  "the last 90 days": "son 90 gün",
  "the last seven complete days, against the seven before": "tamamlanan son yedi gün, önceki yedi günle karşılaştırmalı",
  "The list is shared, so the stock value changes at every store.": "Liste ortak olduğu için stok değeri her mağazada değişir.",
  "The loyalty rules could not be loaded.": "Sadakat kuralları yüklenemedi.",
  "The menu": "Menü",
  "The month": "Ayın tamamı",
  "The new story": "Yeni yazı",
  "The nightly scoring job has not classified these yet.": "Gece çalışan puanlama işi bunları henüz sınıflandırmadı.",
  "The notification has already been sent and cannot be deleted!": "Bildirim zaten gönderildi, silinemez!",
  "The option item could not be deleted.": "Seçenek silinemedi.",
  "The option item could not be loaded.": "Seçenek yüklenemedi.",
  "The PDF reports and Excel files Connect made for you": "Connect'in sizin için hazırladığı PDF raporları ve Excel dosyaları",
  "The people in this list by the day of their latest message, over the last 14 days.": "Bu listedeki kişiler, son 14 gün içinde en son mesaj attıkları güne göre.",
  "The photo": "Fotoğraf",
  "The picture could not be uploaded.": "Resim yüklenemedi.",
  "The picture could not be uploaded. Try again or paste a link instead.": "Görsel yüklenemedi. Yeniden deneyin ya da bunun yerine bir bağlantı yapıştırın.",
  "The picture will be removed.": "Görsel kaldırılacak.",
  "The pizzas pinned to the top of the app's": "Uygulamada şu bölümün en üstüne sabitlenen pizzalar:",
  "The pizzas pinned to the top of the app's Most popular section": "Uygulamanın En popüler bölümünün en üstüne sabitlenen pizzalar",
  "The points the customer and the friend they invited each get once the friend's first online order goes through. A friend who signs up with a code gets these instead of the welcome points.": "Arkadaşın ilk online siparişi tamamlandığında müşterinin ve davet ettiği arkadaşın her birine verilen puan. Kodla kaydolan bir arkadaş, hoş geldin puanı yerine bunları alır.",
  "The promotional images customers see in the app": "Müşterilerin uygulamada gördüğü tanıtım görselleri",
  "The report can’t open": "Rapor açılamıyor",
  "The result didn't find.": "Sonuç bulunamadı.",
  "The row holds {0} pictures: only the first one is added.": "Sıra en fazla {0} görsel alır: yalnızca ilki eklendi.",
  "The row holds {0} pictures: only the first {1} are added.": "Sıra en fazla {0} görsel alır: yalnızca ilk {1} görsel eklendi.",
  "The rule": "Kural",
  "The rules behind the app's loyalty: what each tier needs, the weekly streak rewards and the reward for inviting a friend. The app uses them as soon as they are saved.": "Uygulamadaki sadakat programının kuralları: her seviye için gerekenler, haftalık seri ödülleri ve arkadaş davet etme ödülü. Uygulama, kaydedildikleri anda bunları kullanır.",
  "the same days last year": "geçen yılın aynı günleri",
  "the same figure as every sales page": "tüm satış sayfalarındakiyle aynı rakam",
  "The scanned page": "Taranan sayfa",
  "The separate tool for scheduling social posts": "Sosyal medya gönderilerini planlamak için ayrı araç",
  "The server refused the key.": "Sunucu anahtarı reddetti.",
  "The server refused the request.": "Sunucu isteği reddetti.",
  "The settings could not be loaded.": "Ayarlar yüklenemedi.",
  "The status could not be changed.": "Durum değiştirilemedi.",
  "The stories could not be loaded.": "Hikayeler yüklenemedi.",
  "The stories on the website's": "Web sitesindeki hikayeler:",
  "The stories on the website's Our Stories page: write, change or remove them": "Web sitesinin Our Stories sayfasındaki hikayeler: yazın, değiştirin veya kaldırın",
  "The story after the change": "Değişiklikten sonraki yazı",
  "The story is no longer on the website, so this cannot be approved. Reject it with a note.": "Hikaye artık web sitesinde değil, bu yüzden bu değişiklik onaylanamaz. Bir notla reddedin.",
  "The story is no longer on the website. Reject it with a note.": "Hikaye artık web sitesinde değil. Bir notla reddedin.",
  "the story is off the website.": "yazı web sitesinden kaldırıldı.",
  "The story that would go off the website": "Web sitesinden kaldırılacak yazı",
  "The story's own page, from top to bottom as the website lays it out. Leave out any part you do not need.": "Hikayenin kendi sayfası; web sitesinin yerleşimine göre yukarıdan aşağıya. İhtiyacınız olmayan bölümleri boş bırakın.",
  "The story's own page, or another page of the website.": "Hikayenin kendi sayfası ya da web sitesinin başka bir sayfası.",
  "The system's own figure is deliberately not shown while you count. Seeing it first makes it very hard not to simply agree with it, and then a count confirms a mistake instead of catching it. The difference appears as soon as you submit.": "Siz sayarken sistemin kendi rakamı bilerek gösterilmez. Önce onu görmek, ona öylece katılmamayı çok zorlaştırır; o zaman sayım bir hatayı yakalamak yerine onu onaylar. Fark, gönderdiğiniz anda görünür.",
  "The target is how much you want on the shelf at the start of a week. Suggestions come from your own counts: average weekly use, stretched to cover the {0} days until the next order plus the days waiting for delivery, with {1}% on top so an average week is not also a week you run out.": "Hedef, hafta başında rafta olmasını istediğiniz miktardır. Öneriler kendi sayımlarınızdan gelir: ortalama haftalık kullanım, bir sonraki siparişe kadarki {0} günü ve teslimatı beklerken geçen günleri karşılayacak şekilde uzatılır ve üstüne %{1} eklenir; böylece ortalama bir hafta aynı zamanda stoğun tükendiği bir hafta olmaz.",
  "The title, when left empty": "Boş bırakılırsa başlık kullanılır",
  "The two share columns can be read against each other — a store taking a larger slice of the traffic than of the orders is being looked at more than it is being bought from. The counts themselves cannot be divided into a rate: a session can see several store pages, a fifth of web orders begin a session with no landing page at all because returning from the payment provider starts a new one, and app orders have no page. That is why there is no per-store percentage here.": "İki pay sütunu birbiriyle karşılaştırılabilir — trafikten, siparişlerden aldığından daha büyük pay alan bir mağazaya, sipariş verildiğinden daha çok bakılıyor demektir. Sayıların kendisi bir orana bölünemez: bir oturum birkaç mağaza sayfası görebilir, ödeme sağlayıcısından dönüş yeni bir oturum başlattığı için web siparişlerinin beşte biri hiç giriş sayfası olmayan bir oturumla başlar ve uygulama siparişlerinin sayfası yoktur. Bu yüzden burada mağaza bazında yüzde yok.",
  "The upload failed.": "Yükleme başarısız oldu.",
  "The voice service closed the connection.": "Ses servisi bağlantıyı kapattı.",
  "The voice session ended. Tap the mic to talk again.": "Sesli oturum sona erdi. Yeniden konuşmak için mikrofona dokunun.",
  "The voice session reached its time limit (about ten minutes). Tap the mic to go on.": "Sesli oturum süre sınırına ulaştı (yaklaşık on dakika). Devam etmek için mikrofona dokunun.",
  "The voice session stopped ({0}). Tap the mic to talk again.": "Sesli oturum durdu ({0}). Yeniden konuşmak için mikrofona dokunun.",
  "The website has this now instead:": "Web sitesinde artık bunun yerine şu var:",
  "The website’s {0} changed after {1} asked, so approving would undo that. Reject it with a note and they can ask again from the newest version.": "Web sitesindeki {0}, {1} istekte bulunduktan sonra değişti; bu yüzden onaylamak o değişikliği geri alır. Bir notla reddedin; en yeni sürümden yeniden isteyebilirler.",
  "The website’s {0} changed after {1} asked, so approving would undo that. Reject it with a note and they can ask again.": "Web sitesindeki {0}, {1} istekte bulunduktan sonra değişti; bu yüzden onaylamak o değişikliği geri alır. Bir notla reddedin; yeniden isteyebilirler.",
  "The website’s {0} changed since you asked; open the story and make your change again.": "Web sitesindeki {0}, siz istedikten sonra değişti; yazıyı açın ve değişikliğinizi yeniden yapın.",
  "The week after": "Sonraki hafta",
  "The week before": "Önceki hafta",
  "the whole bill": "faturanın tamamı",
  "The whole combo costs $": "Kombonun tamamı $",
  "The writer gets your note in a direct message.": "Notunuz yazan kişiye doğrudan mesajla iletilir.",
  "The {0} days after": "Sonraki {0} gün",
  "The {0} days before": "Önceki {0} gün",
  "the {0} days before {1}": "{1} öncesindeki {0} gün",
  "them": "onları",
  "There is no option items.": "Hiç seçenek yok.",
  "These add up to {0}, which is {1} above net sales.": "Bunların toplamı {0}; bu, net satışın {1} üzerinde.",
  "These add up to {0}, which is {1} below net sales.": "Bunların toplamı {0}; bu, net satışın {1} altında.",
  "These come from the reporting service, so the figures are produced outside this panel and cannot be changed here.": "Bunlar raporlama servisinden gelir; rakamlar bu panelin dışında üretilir ve burada değiştirilemez.",
  "These keep the voice and avatar costs in check: 1–60 minutes a session, 15–600 seconds of silence.": "Bunlar ses ve avatar maliyetlerini kontrol altında tutar: oturum başına 1–60 dakika, 15–600 saniye sessizlik.",
  "They are created by staff while taking a phone or counter order, so they arrive with an order already attached and usually without an e-mail address — counting them as \"signups\" inflates both the total and the activation rate. Switch them on above to see the full picture.": "Bunları personel telefon ya da tezgâh siparişi alırken oluşturur; bu yüzden bu kayıtlar zaten bir siparişle birlikte ve genellikle e-posta adresi olmadan gelir — bunları \"yeni kayıt\" olarak saymak hem toplamı hem de aktivasyon oranını şişirir. Tam tabloyu görmek için yukarıdan açın.",
  "They buy a number of items and one (or more) of them is free or discounted.": "Müşteriler belirli sayıda ürün alır; bunlardan biri (ya da daha fazlası) ücretsiz veya indirimli olur.",
  "They get your note in a direct message.": "Notunuz isteyen kişiye doğrudan mesajla iletilir.",
  "Things other people wrote or asked for that need a yes from you before they happen.": "Başkalarının yazdığı ya da istediği, gerçekleşmeden önce sizin onayınızı bekleyen şeyler.",
  "Thinking…": "Düşünüyor…",
  "This action cannot be undone.": "Bu işlem geri alınamaz.",
  "This browser cannot do the encryption (no Web Crypto). Use a current Chrome, Safari, Firefox or Edge over https.": "Bu tarayıcı şifrelemeyi yapamıyor (Web Crypto yok). https üzerinden güncel bir Chrome, Safari, Firefox veya Edge kullanın.",
  "This browser only": "Yalnızca bu tarayıcı",
  "This cannot be undone — a correcting count would have to be entered instead.": "Bu işlem geri alınamaz — bunun yerine düzeltici bir sayım girilmesi gerekir.",
  "This card deletes or takes away {0} thing. Undo can put it back.": "Bu kart {0} öğeyi siler veya kaldırır. Geri al ile geri getirilebilir.",
  "This card deletes or takes away {0} things. Undo can put them back.": "Bu kart {0} öğeyi siler veya kaldırır. Geri al ile hepsi geri getirilebilir.",
  "This code already exists!": "Bu kod zaten var!",
  "This date range already exists!": "Bu tarih aralığı zaten var!",
  "This deal does not run at {0}.": "Bu kampanya {0} için geçerli değil.",
  "This deal is switched off: the app will say it is not available.": "Bu kampanya kapalı: uygulama, kampanyanın mevcut olmadığını söyleyecek.",
  "This deal runs only at {0}: customers of other stores are told it is not available there.": "Bu kampanya yalnızca {0} için geçerli: diğer mağazaların müşterilerine kampanyanın orada geçerli olmadığı söylenir.",
  "This is a built-in role and cannot be changed. Copy it to make your own version.": "Bu yerleşik bir roldür ve değiştirilemez. Kendi sürümünüzü oluşturmak için kopyalayın.",
  "This is the first count here, so there is nothing to compare against yet — from now on every count will show what moved.": "Bu, buradaki ilk sayım; bu yüzden henüz karşılaştırılacak bir şey yok — bundan sonra her sayım nelerin değiştiğini gösterecek.",
  "This month": "Bu ay",
  "This notification has already gone out. Saving changes its record only; nothing is sent again. To send the new version, reschedule it.": "Bu bildirim zaten gönderildi. Kaydetmek yalnızca kaydını değiştirir; hiçbir şey yeniden gönderilmez. Yeni sürümü göndermek için yeniden zamanlayın.",
  "This page": "Bu sayfa",
  "this page": "bu sayfada",
  "This price looked wrong when the list was imported": "Liste içe aktarılırken bu fiyat hatalı görünüyordu",
  "This removes the deal for good and customers stop seeing it. Switching it off instead keeps it for later.": "Bu işlem kampanyayı kalıcı olarak kaldırır ve müşteriler artık onu görmez. Bunun yerine kapatırsanız kampanya ileride kullanmak üzere saklanır.",
  "This section is under development.": "Bu bölüm geliştirme aşamasında.",
  "This sends": "Bu işlem",
  "this store": "bu mağaza",
  "This store": "Bu mağaza",
  "This store has no store specials.": "Bu mağazada mağazaya özel ürün yok.",
  "THIS WEEK": "BU HAFTA",
  "This week": "Bu hafta",
  "This week (Mon – Today)": "Bu hafta (Pzt – Bugün)",
  "This week (Sun – Today)": "Bu hafta (Paz – Bugün)",
  "This will send the notification to every customer.": "Bu işlem bildirimi tüm müşterilere gönderecek.",
  "through Connect, the assistant": "asistan Connect aracılığıyla",
  "thrown away in total": "toplam atılan",
  "Thu": "Per",
  "Thursday": "Perşembe",
  "Ticket": "Sepet",
  "TICKET": "SEPET",
  "Tier": "Seviye",
  "Tier mix": "Seviye dağılımı",
  "Tiers": "Seviyeler",
  "Tiers come from": "Seviyelerin kaynağı",
  "Till (POS)": "Kasa (POS)",
  "Till (POS) records are left out by default.": "Kasa (POS) kayıtları varsayılan olarak hariç tutulur.",
  "till user": "kasa kullanıcısı",
  "Till users": "Kasa kullanıcıları",
  "Time window": "Zaman aralığı",
  "Tip": "Bahşiş",
  "TIPS": "BAHŞİŞ",
  "title": "başlık",
  "Title": "Başlık",
  "Title and Body are required.": "Başlık ve metin gerekli.",
  "To": "Bitiş",
  "To close a shift instead: use": "Bunun yerine vardiyayı kapatmak için:",
  "to feature one everywhere, or a single store to feature it only there. Lower position shows first.": "— bir pizzayı her yerde öne çıkarmak için; yalnızca bir mağazada öne çıkarmak için o mağazayı seçin. Sıra numarası küçük olan önce gösterilir.",
  "TO ORDER": "SİPARİŞ EDİLECEK",
  "To Store": "Hedef mağaza",
  "To time": "Bitiş saati",
  "Today": "Bugün",
  "Today (24 h)": "Bugün (24 saat)",
  "Today is not over yet, so its sales are still coming in.": "Bugün henüz bitmedi, bu yüzden satışları hâlâ geliyor.",
  "TODAY ORDERS": "BUGÜNKÜ SİPARİŞLER",
  "TODAY REVENUE": "BUGÜNKÜ CİRO",
  "Today so far": "Bugün şu ana kadar",
  "Tomorrow": "Yarın",
  "took at least one order": "en az bir sipariş aldı",
  "Took back {0} points.": "{0} puan geri alındı.",
  "Top 10 items": "En çok satan 10 ürün",
  "Top 3 Peak Moments": "En yoğun 3 an",
  "Top customers": "En iyi müşteriler",
  "TOP ITEMS": "EN ÇOK SATANLAR",
  "Top Items Today": "Bugün en çok satanlar",
  "top picture": "üst görsel",
  "Top picture": "Üst görsel",
  "Top Products": "En çok satan ürünler",
  "Top Products — {0}": "En çok satan ürünler — {0}",
  "Top spend": "En yüksek harcama",
  "TOP ZONE": "EN YOĞUN BÖLGE",
  "Top {0}": "İlk {0}",
  "Topping Limit": "Malzeme sınırı",
  "Toppings": "Malzemeler",
  "Toppings & options": "Malzemeler & seçenekler",
  "Total": "Toplam",
  "TOTAL": "TOPLAM",
  "Total :": "Toplam :",
  "TOTAL COLLECTED": "TOPLAM TAHSİLAT",
  "TOTAL DISCOUNTS": "TOPLAM İNDİRİM",
  "Total Discounts Applied": "Uygulanan toplam indirim",
  "TOTAL DUE": "ÖDENECEK TOPLAM",
  "TOTAL ITEMS SOLD": "SATILAN TOPLAM ÜRÜN",
  "TOTAL ORDERS": "TOPLAM SİPARİŞ",
  "Total paid": "Ödenen toplam",
  "Total Price": "Toplam fiyat",
  "TOTAL QUANTITY": "TOPLAM MİKTAR",
  "Total Revenue": "Toplam ciro",
  "TOTAL REVENUE": "TOPLAM CİRO",
  "Total sales": "Toplam satış",
  "Total Sales": "Toplam satış",
  "TOTAL SALES": "TOPLAM SATIŞ",
  "Total Sales by Source": "Kaynağa göre toplam satış",
  "Total Taxes": "Toplam vergi",
  "Total {0}": "Toplam {0}",
  "Total: {0}": "Toplam: {0}",
  "Traffic": "Trafik",
  "Tried at one store": "Bir mağazada denendi",
  "Try asking": "Şunları sormayı deneyin",
  "Try at one store first": "Önce tek mağazada dene",
  "Try it": "Dene",
  "Tue": "Sal",
  "Tuesday": "Salı",
  "Turn on": "Etkinleştir",
  "Two extras on the app's screens.": "Uygulama ekranları için iki ek özellik.",
  "Two large pizzas and a side": "Two large pizzas and a side",
  "Type": "Tür",
  "TYPE": "TÜR",
  "Type a date like {0}.": "{0} gibi bir tarih yazın.",
  "Type the platform statement figure, if there is one.": "Varsa platform ekstresindeki rakamı yazın.",
  "Type to search products": "Ürün aramak için yazın",
  "Type {0} to delete": "Silmek için {0} yazın",
  "Type:": "Tür:",
  "typed into the online coupon box": "online kupon kutusuna girilen",
  "UBER": "UBER",
  "Uber / DoorDash / Skip": "Uber / DoorDash / Skip",
  "Uber / DoorDash / Skip promotions": "Uber / DoorDash / Skip promosyonları",
  "Uber, DoorDash and Skip": "Uber, DoorDash ve Skip",
  "Uber, DoorDash and Skip orders that come in through Deliverect never reach the store's POS, so they are not in POS sales; they are counted once, in the third-party columns, from our records (the grey figure). Type the platform's statement figure to replace a recorded one; it is never added on top. Leave a column blank, or 0, to use the record. Blank \"paid\" means nothing has been entered yet; 0 means nothing was collected — the gap column stays empty until one of them is filled.": "Deliverect üzerinden gelen Uber, DoorDash ve Skip siparişleri mağazanın POS'una hiç ulaşmaz, bu yüzden POS satışlarında yer almaz; bunlar kendi kayıtlarımızdan (gri rakam) üçüncü taraf sütunlarında bir kez sayılır. Kayıtlı bir rakamın yerine geçmesi için platform ekstresindeki rakamı yazın; bu rakam asla üstüne eklenmez. Kaydı kullanmak için sütunu boş bırakın ya da 0 yazın. Boş \"ödenen\", henüz hiçbir şey girilmediği; 0 ise hiçbir şey tahsil edilmediği anlamına gelir — bunlardan biri doldurulana kadar fark sütunu boş kalır.",
  "under the bottom picture": "alt görselin altında",
  "Understand the customers": "Müşterileri tanı",
  "Undo": "Geri al",
  "Undo a {0} change": "Bir {0} değişikliğini geri al",
  "Undo changes": "Değişiklikleri geri al",
  "Undo my last change": "Son değişikliğimi geri al",
  "UNIQUE ORDERS": "TEKİL SİPARİŞ",
  "UNIQUE PRODUCTS": "TEKİL ÜRÜN",
  "Unit": "Birim",
  "Unit Multiplier": "Birim çarpanı",
  "Unit Name": "Birim adı",
  "unit name content": "birim adı içeriği",
  "Unit Price": "Birim fiyatı",
  "UNITS": "ADET",
  "Unknown": "Bilinmiyor",
  "Unknown shift": "Bilinmeyen vardiya",
  "Unlink": "Bağlantıyı kaldır",
  "Unlock": "Kilidi aç",
  "Unremovable": "Çıkarılamaz",
  "Unsaved changes": "Kaydedilmemiş değişiklikler",
  "Unsaved changes.": "Kaydedilmemiş değişiklikler.",
  "Unscored": "Puanlanmamış",
  "Untick to make this choice optional.": "Bu seçimi isteğe bağlı yapmak için işareti kaldırın.",
  "Until it is off": "Kapatılana kadar",
  "until {0}": "{0} tarihine kadar",
  "Untitled draft": "Adsız taslak",
  "Unused": "Kullanılmadı",
  "up to 6; the old stories have 3": "en fazla 6; eski hikayelerde 3 tane var",
  "Up to {0} days at a time.": "Tek seferde en fazla {0} gün.",
  "Up to {0} days here": "Burada en fazla {0} gün",
  "up {0}% on the day before": "önceki güne göre %{0} artış",
  "Update": "Güncelle",
  "Update Banner": "Banner'ı güncelle",
  "Update Hours": "Saatleri güncelle",
  "Update Time": "Güncellenme zamanı",
  "Update User": "Güncelleyen kullanıcı",
  "Updated": "Güncellendi",
  "Updated {0}": "Son güncelleme: {0}",
  "Updated {0} · refreshes every 30 s": "Son güncelleme: {0} · 30 sn'de bir yenilenir",
  "Updating...": "Güncelleniyor...",
  "Upload New Image:": "Yeni görsel yükle:",
  "uploaded image": "yüklenen görsel",
  "Uploading…": "Yükleniyor…",
  "Usage": "Kullanım",
  "Usage Type": "Kullanım türü",
  "Use a coupon code": "Kupon kodu kullan",
  "Use a JPG or PNG picture.": "JPG veya PNG bir görsel kullanın.",
  "Use an https:// address or a page of the website starting with /.": "https:// ile başlayan bir adres ya da web sitesinin / ile başlayan bir sayfasını kullanın.",
  "Use in": "Şurada kullan:",
  "Use invoice price": "Fatura fiyatını kullan",
  "Use it": "Bunu kullan",
  "Use the invoice price?": "Fatura fiyatı kullanılsın mı?",
  "Use Type": "Kullanım türü",
  "Use {0} {1}": "Kullan: {0} {1}",
  "Use {0}: {1}": "Payı kullan ({0}): {1}",
  "Used": "Kullanıldı",
  "USED": "KULLANILAN",
  "USED BY THEN": "O ZAMANA KADAR KULLANILAN",
  "Used to order, has gone quiet.": "Eskiden sipariş verirdi, sessizleşti.",
  "user": "kullanıcı",
  "User #{0}": "Kullanıcı #{0}",
  "User has been deleted successfully!": "Kullanıcı silindi!",
  "User has been saved successfully.": "Kullanıcı kaydedildi.",
  "User status updated successfully.": "Kullanıcı durumu güncellendi.",
  "User Type": "Kullanıcı türü",
  "Users": "Kullanıcılar",
  "Users could not be loaded.": "Kullanıcılar yüklenemedi.",
  "Uses": "Kullanım",
  "Usually 1. 0 = no cap.": "Genellikle 1. 0 = sınır yok.",
  "UTM Links": "UTM bağlantıları",
  "UTM Links Error": "UTM bağlantıları hatası",
  "utm_campaign": "utm_campaign",
  "Validation": "Doğrulama",
  "Validation Error": "Doğrulama hatası",
  "VALUE": "DEĞER",
  "Vendor": "Tedarikçi",
  "VENDOR": "TEDARİKÇİ",
  "Vendor has been deleted successfully.": "Tedarikçi silindi.",
  "Vendor has been saved successfully.": "Tedarikçi kaydedildi.",
  "Vendor has been updated successfully.": "Tedarikçi güncellendi.",
  "Vendor is not added!": "Tedarikçi eklenmedi!",
  "Vendor is not as same as invoice vendor!": "Tedarikçi, faturadaki tedarikçiyle aynı değil!",
  "Vendor list cannot be duplicated!": "Tedarikçi listesinde tekrar olamaz!",
  "Vendor list cannot be empty!": "Tedarikçi listesi boş olamaz!",
  "Vendor Name": "Tedarikçi adı",
  "Vendor name cannot be empty!": "Tedarikçi adı boş olamaz!",
  "Vendors": "Tedarikçiler",
  "Version {0}, finished by {1} {2}.": "Sürüm {0}, {1} tarafından tamamlandı ({2}).",
  "View": "Görüntüle",
  "View only": "Yalnızca görüntüleme",
  "VIP": "VIP",
  "Vision AI": "Vision AI",
  "Visitors, orders and where they came from, plus which deals and coupons were used": "Ziyaretçiler, siparişler ve nereden geldikleri; ayrıca hangi kampanya ve kuponların kullanıldığı",
  "VISITS": "ZİYARET",
  "Visits that became orders": "Siparişe dönüşen ziyaretler",
  "Visualize delivery locations, distance zones & peak delivery hours": "Teslimat konumlarını, mesafe bölgelerini & yoğun teslimat saatlerini görselleştirin",
  "Voice AI": "Voice AI",
  "Voice could not start just now.": "Sesli konuşma şu anda başlatılamadı.",
  "Voice could not start.": "Sesli konuşma başlatılamadı.",
  "Voice is off": "Sesli konuşma kapalı",
  "Voice modes customers can choose": "Müşterilerin seçebileceği ses modları",
  "Voice orb": "Ses küresi",
  "Voice session limits": "Sesli oturum sınırları",
  "VS AVG": "ORTALAMAYA GÖRE",
  "VS BEFORE": "ÖNCEKİNE GÖRE",
  "vs prev: {0} · {1} orders": "önceki dönem: {0} · {1} sipariş",
  "VS TARGET": "HEDEFE GÖRE",
  "vs the day before": "önceki güne göre",
  "vs the week before": "önceki haftaya göre",
  "vs the {0} days before": "önceki {0} güne göre",
  "vs {0} prior": "önceki dönem: {0}",
  "Waiting": "Bekliyor",
  "waiting approval": "onay bekliyor",
  "Waiting change": "Bekleyen değişiklik",
  "Waiting for an administrator": "Yönetici onayı bekliyor",
  "waiting for approval": "onay bekliyor",
  "Waiting for approval": "Onay bekliyor",
  "Waiting for the person who asked.": "İsteyen kişi bekleniyor.",
  "waiting for the store to accept": "mağazanın kabul etmesini bekliyor",
  "Waiting — an administrator decides in Approvals (top bar ✓)": "Bekliyor — kararı bir yönetici Onaylar'da verir (üst çubuk ✓)",
  "Warning": "Uyarı",
  "Waste": "Atık",
  "WASTE": "ATIK",
  "Waste and deliveries over": "Atık ve teslimatlar:",
  "Waste belongs to one store. Choose which one from the selector at the top left.": "Atık tek bir mağazaya aittir. Sol üstteki seçiciden mağazayı seçin.",
  "Waste Error": "Atık hatası",
  "Waste is kept apart from sales on purpose. It still comes off the shelf, so it counts towards how much to order — you have to buy back what you throw away — but it is never counted as something a customer bought.": "Atık, satışlardan bilerek ayrı tutulur. Yine de raftan düşer, bu yüzden ne kadar sipariş verileceğine dahil edilir — attığınızı yeniden satın almanız gerekir — ama asla bir müşterinin satın aldığı bir şey olarak sayılmaz.",
  "Web": "Web",
  "WEB": "WEB",
  "WEB ORDER RATE": "WEB SİPARİŞ ORANI",
  "web orders": "web siparişleri",
  "WEB ORDERS": "WEB SİPARİŞLERİ",
  "web visits": "web ziyaretleri",
  "Web: OFF": "Web: KAPALI",
  "Web: ON": "Web: AÇIK",
  "Website": "Web sitesi",
  "Website & app traffic": "Web sitesi & uygulama trafiği",
  "Website & Mobile App": "Web sitesi & mobil uygulama",
  "Website Banner Image": "Web sitesi banner görseli",
  "Website blog": "Web sitesi blogu",
  "Website blog changes waiting": "Bekleyen web sitesi blog değişiklikleri",
  "Website, app, phone and the delivery platforms": "Web sitesi, uygulama, telefon ve teslimat platformları",
  "Wed": "Çar",
  "Wednesday": "Çarşamba",
  "Week": "Hafta",
  "week": "hafta",
  "Week of {0} — {1} data": "{0} haftası — {1} verileri",
  "WEEK ORDERS": "HAFTALIK SİPARİŞ",
  "Weekly": "Haftalık",
  "Weekly Orders": "Haftalık siparişler",
  "Weekly Report": "Haftalık rapor",
  "Weekly Report Error": "Haftalık rapor hatası",
  "Weekly Revenue": "Haftalık ciro",
  "Weekly streak rewards": "Haftalık seri ödülleri",
  "weeks": "hafta",
  "Weeks that start on Sunday or Monday: {0}": "Pazar veya pazartesi başlayan haftalar: {0}",
  "Weight varies per case": "Ağırlık koliden koliye değişir",
  "Weighted across 1 cohort ({0} customers)": "1 kohort üzerinden ağırlıklı ({0} müşteri)",
  "Weighted across {0} cohorts ({1} customers)": "{0} kohort üzerinden ağırlıklı ({1} müşteri)",
  "weighted by cohort size": "kohort büyüklüğüne göre ağırlıklı",
  "Welcome back{0}. {1} of {2} answers were already in for {3}, {4}. Let’s carry on.": "Tekrar hoş geldiniz{0}. {3}, {4} için {1}/{2} yanıt zaten girilmişti. Devam edelim.",
  "Went on to order": "Sonra sipariş verenler",
  "what": "ne",
  "What a typical order is worth, over time": "Tipik bir siparişin zaman içindeki değeri",
  "What changes": "Değişenler",
  "What Connect can do": "Connect neler yapabilir",
  "What coupons and deals gave away, and what came back": "Kupon ve kampanyaların ne verdiği, karşılığında ne geldiği",
  "What customers asked the app's AI host, and its answers": "Müşterilerin uygulamadaki AI asistanına sordukları ve aldıkları cevaplar",
  "What customers asked the app's AI host, and what it answered. Use it to help a customer who had trouble, or to see where the AI falls short.": "Müşterilerin uygulamadaki AI asistanına sordukları ve asistanın verdiği cevaplar. Sorun yaşayan bir müşteriye yardım etmek ya da AI asistanının nerede yetersiz kaldığını görmek için kullanın.",
  "What customers see": "Müşterilerin gördüğü",
  "What do you want to do?": "Ne yapmak istiyorsunuz?",
  "What each store owes in royalty and marketing fees, month by month": "Her mağazanın ay ay ödeyeceği royalti ve pazarlama ücretleri",
  "What each tier needs": "Her seviye için gerekenler",
  "What each tier needs, the weekly streak rewards and the reward for inviting a friend": "Her seviye için gerekenler, haftalık seri ödülleri ve arkadaş davet etme ödülü",
  "what every store shares": "tüm mağazalarda ortak olanlar",
  "What is in the combo, and what does it cost?": "Komboda neler var, fiyatı ne?",
  "What is in the kitchen right now, store by store, with recovery actions for stuck orders": "Şu an mutfakta olanlar, mağaza mağaza; takılı kalan siparişler için kurtarma işlemleriyle",
  "What is in the kitchen right now, store by store.": "Şu an mutfakta olanlar, mağaza mağaza.",
  "What is not in the basis": "Matraha dahil olmayanlar",
  "What is off at this store, or mark a product sold out": "Bu mağazada kapalı olanlar ya da bir ürünü tükendi olarak işaretle",
  "What is the passphrase?": "Parola nedir?",
  "What is waiting for me": "Beni bekleyenler",
  "what it is counted in": "hangi birimle sayıldığı",
  "What kind": "Ne tür",
  "What kind of deal is this?": "Bu ne tür bir kampanya?",
  "What must they buy, and what is added?": "Ne satın almaları gerekiyor, karşılığında ne ekleniyor?",
  "What sold": "Satılanlar",
  "WHAT SOLD, AND WHEN": "NE SATILDI, NE ZAMAN",
  "What the app says": "Uygulamada görünen metin",
  "What the coupons and deals gave away, and what came back": "Kupon ve kampanyaların ne verdiği, karşılığında ne geldiği",
  "What the offers cost": "Tekliflerin maliyeti",
  "What the photos are": "Fotoğrafların türü",
  "What they cost ›": "Maliyetleri ›",
  "WHAT THIS PAGE CAN AND CANNOT SEE": "BU SAYFANIN GÖREBİLDİKLERİ VE GÖREMEDİKLERİ",
  "What this page can see": "Bu sayfanın görebildikleri",
  "What this role is for, in one line": "Bu rolün ne işe yaradığı, tek satırda",
  "What will customers see?": "Müşteriler ne görecek?",
  "What you actually used": "Gerçekte kullandığınız",
  "When each store opens for delivery and pickup": "Her mağazanın teslimat ve gel-al için açık olduğu saatler",
  "When each store opens for delivery and pickup.": "Her mağazanın teslimat ve gel-al için açık olduğu saatler.",
  "When each store takes most of its orders": "Her mağazanın en çok sipariş aldığı zamanlar",
  "When people last talked to the AI": "Kişilerin AI asistanıyla en son ne zaman konuştuğu",
  "When someone clicks it": "Biri tıkladığında",
  "When someone clicks the card": "Biri karta tıkladığında",
  "When tapped": "Dokunulduğunda",
  "When tapped in the apps": "Uygulamalarda dokunulduğunda",
  "When the customer buys": "Müşteri satın aldığında:",
  "When the order is at least $": "Sipariş tutarı en az $",
  "When the orders actually land — every hour of the week, side by side": "Siparişlerin gerçekte geldiği zamanlar — haftanın her saati, yan yana",
  "where": "nerede yapabileceğini",
  "Where & when": "Nerede & ne zaman",
  "Where and when does it run?": "Nerede ve ne zaman geçerli?",
  "Where deliveries went": "Teslimatlar nereye gitti",
  "Where orders came from": "Siparişler nereden geldi",
  "Where the app's customers stand: their tier, points and weekly streak. Find someone to see their points or give some back.": "Uygulama müşterilerinin durumu: seviyeleri, puanları ve haftalık serileri. Puanlarını görmek ya da puan iade etmek için birini bulun.",
  "Where the live ones work": "Aktif olanların geçerli olduğu yerler",
  "Where they signed up": "Nereden kaydoldular",
  "Which hours of which days are busy": "Hangi günlerin hangi saatleri yoğun",
  "Which items are discounted, and by how much?": "Hangi ürünler indirimli, ne kadar?",
  "Which items count?": "Hangi ürünler geçerli?",
  "Which items sold, and how much each brought in": "Hangi ürünlerin satıldığı ve her birinin ne kadar getirdiği",
  "Which menu each store shows, and when": "Her mağazanın hangi menüyü ne zaman gösterdiği",
  "Which menu each store shows, and when.": "Her mağazanın hangi menüyü ne zaman gösterdiği.",
  "Which model answers you (/model)": "Size hangi modelin cevap verdiği (/model)",
  "Which model answers you here. Only your own conversation changes.": "Burada size cevap veren model. Yalnızca kendi konuşmanız değişir.",
  "Which model answers you: Gemini or DeepSeek": "Size hangi modelin cevap verdiği: Gemini veya DeepSeek",
  "Which question it is for": "Hangi soru için",
  "Which reports": "Hangi raporlar",
  "Which role?": "Hangi rol?",
  "Which store the panel is looking at": "Panelin baktığı mağaza",
  "Who can sign in to the till in each store": "Her mağazada kasaya kimlerin giriş yapabileceği",
  "Who can sign in to the till in each store.": "Her mağazada kasaya kimlerin giriş yapabileceği.",
  "Who can sign in to this panel, and which role each one holds": "Bu panele kimlerin giriş yapabileceği ve her birinin rolü",
  "Who has stopped ordering, how much spend went quiet with them, and who you can still reach": "Kimlerin sipariş vermeyi bıraktığı, onlarla birlikte ne kadar harcamanın kesildiği ve hâlâ kimlere ulaşabileceğiniz",
  "Who sees a deal": "Kampanyayı kimler görür",
  "Who signs up, who comes back, who has gone quiet": "Kim kayıt oluyor, kim geri geliyor, kim sessizleşti",
  "Why do you need it? One sentence is enough.": "Neden ihtiyacınız var? Tek cümle yeterli.",
  "Why sales moved": "Satışlar neden değişti",
  "WHY THIS IS NOT 45%": "BU NEDEN %45 DEĞİL",
  "Why? Optional — saved to the audit log.": "Neden? İsteğe bağlı — denetim kaydına yazılır.",
  "Why? Required — this is saved to the audit log.": "Neden? Zorunlu — bu, denetim kaydına yazılır.",
  "Why? Saved to the audit log.": "Neden? Denetim kaydına yazılır.",
  "Wide, like a banner": "Geniş, banner gibi",
  "will be added to stock at": "şu mağazanın stoğuna eklenecek:",
  "Win-back list": "Geri kazanma listesi",
  "With Coupon Code": "Kupon kodlu",
  "With or without photo": "Fotoğraflı veya fotoğrafsız",
  "With this many deals the store list does not fit in the link: the app opens it at the customer's own store.": "Bu kadar çok kampanyayla mağaza listesi bağlantıya sığmıyor: uygulama bunu müşterinin kendi mağazasında açar.",
  "Withdraw": "Geri çek",
  "Withdraw it": "Bunu geri çek",
  "Withdrawn": "Geri çekildi",
  "Work out what is owed": "Ödenecek tutarı hesapla",
  "Working": "İşleniyor",
  "WORKING HOURS": "ÇALIŞMA SAATLERİ",
  "Working Hours": "Çalışma saatleri",
  "Working on it…": "İşlem yapılıyor…",
  "Worth": "Getiri",
  "worth {0}": "toplam {0} değerinde",
  "Write": "Yaz",
  "Write a message… Enter to send": "Bir mesaj yazın… Enter ile gönderin",
  "Write down what is actually on the shelf. Leave anything you do not count empty — it will be left alone rather than recorded as zero.": "Rafta gerçekte ne varsa onu yazın. Saymadığınız her şeyi boş bırakın — sıfır olarak kaydedilmez, olduğu gibi bırakılır.",
  "Write off": "Atık olarak kaydet",
  "Write the first one with": "İlkini yazmak için şunu kullanın:",
  "Write the story here, or below the pictures.": "Hikayeyi buraya ya da görsellerin altına yazın.",
  "Write this off?": "Atık olarak kaydedilsin mi?",
  "XLSX": "XLSX",
  "YEAR ON YEAR": "GEÇEN YILA GÖRE",
  "Year on year compares against the same weekdays 52 weeks back, not the same calendar dates. A store with no orders is ranked — rather than last, so a closed till never looks like a failing one.": "Geçen yılla karşılaştırma, aynı takvim tarihlerine göre değil, 52 hafta önceki aynı hafta günlerine göre yapılır. Siparişi olmayan bir mağazanın sırası sonuncu yerine — olarak gösterilir; böylece kapalı bir kasa hiçbir zaman kötü giden bir kasa gibi görünmez.",
  "Yes": "Evet",
  "YES": "EVET",
  "Yes, it’s right": "Evet, doğru",
  "Yes, Send": "Evet, gönder",
  "Yesterday": "Dün",
  "yet. Use the search below to add pizzas here.": "— buraya pizza eklemek için aşağıdaki aramayı kullanın.",
  "You": "Siz",
  "You can look at these rules; changing them needs the": "Bu kuralları görüntüleyebilirsiniz; değiştirmek için",
  "You can look at these settings; changing them needs the": "Bu ayarları görüntüleyebilirsiniz; değiştirmek için",
  "You have not asked for anything. Use": "Henüz hiçbir şey istemediniz. Bunun için",
  "You pick from {0}'s menu; the same item is matched at the other stores automatically.": "Ürünleri {0} menüsünden seçersiniz; aynı ürün diğer mağazalarda otomatik olarak eşleştirilir.",
  "Your access requests": "Erişim talepleriniz",
  "Your account covers {0} of the stores": "Hesabınız {0} mağazayı kapsıyor",
  "Your change is waiting": "Değişikliğiniz bekliyor",
  "Your change is waiting for approval": "Değişikliğiniz onay bekliyor",
  "Your changes go on the website as soon as you save them; anyone else's wait for an administrator in Approvals.": "Değişiklikleriniz kaydettiğiniz anda web sitesinde yayımlanır; başkalarının değişiklikleri ise Onaylar'da bir yöneticiyi bekler.",
  "Your changes wait for an administrator's approval before they go on the website.": "Değişiklikleriniz web sitesinde yayımlanmadan önce bir yöneticinin onayını bekler.",
  "Your chat key was made on another browser and has no passphrase backup, so the only way here is a new key.": "Sohbet anahtarınız başka bir tarayıcıda oluşturuldu ve parola yedeği yok; bu yüzden burada tek yol yeni bir anahtar.",
  "Your chat key was made on another browser. Enter the passphrase you chose there to use it here.": "Sohbet anahtarınız başka bir tarayıcıda oluşturuldu. Burada kullanmak için orada seçtiğiniz parolayı girin.",
  "Your notifications": "Bildirimleriniz",
  "Your old backup stops working. Messages people sent before now open again once one of them has the panel open (it re-shares the channel keys with your new key).": "Eski yedeğiniz artık çalışmaz. Daha önce gönderilen mesajlar, gönderenlerden biri paneli açtığında yeniden açılır (panel, kanal anahtarlarını yeni anahtarınızla yeniden paylaşır).",
  "Your report": "Raporunuz",
  "Your role can arrange this list but not publish it.": "Rolünüz bu listeyi düzenleyebilir ama yayımlayamaz.",
  "Your role can look at orders but not change them.": "Rolünüz siparişleri görebilir ama değiştiremez.",
  "Your role can see this report but not fill it in.": "Rolünüz bu raporu görebilir ama dolduramaz.",
  "Your role cannot open that page (needs '{0}').": "Rolünüz bu sayfayı açamaz (gereken yetki: '{0}').",
  "Your stores and where they rank — heat-colored by performance": "Mağazalarınız ve sıralamaları — performansa göre renklendirilmiş",
  "Your website blog changes": "Web sitesi blog değişiklikleriniz",
  "Your whole conversation with Connect is removed for you. This cannot be undone.": "Connect ile olan tüm konuşmanız sizin için silinir. Bu işlem geri alınamaz.",
  "YoY": "Yıllık",
  "YYYY-MM-DD": "YYYY-AA-GG",
  "zone": "teslimat bölgesi",
  "{0} (Current)": "{0} (Mevcut)",
  "{0} (off)": "{0} (kapalı)",
  "{0} +{1} more": "{0} +{1} daha",
  "{0} - (Bag)": "{0} - (Poşet)",
  "{0} - (Group)": "{0} - (Grup)",
  "{0} - (Hidden)": "{0} - (Gizli)",
  "{0} - (Template)": "{0} - (Şablon)",
  "{0} - Brand": "{0} - Marka",
  "{0} - Store": "{0} - Mağaza",
  "{0} / BRAND": "{0} / MARKA",
  "{0} / case": "{0} / koli",
  "{0} / STORE": "{0} / MAĞAZA",
  "{0} a person on average": "Kişi başına ortalama {0}",
  "{0} and {1}": "{0} ve {1}",
  "{0} applied": "{0} uygulandı",
  "{0} asks Connect to": "{0}, Connect’ten şunu istiyor:",
  "{0} asks for": "{0} şu rolü istiyor:",
  "{0} asks through Connect to": "{0}, Connect üzerinden şunu istiyor:",
  "{0} asks to": "{0} şunu istiyor:",
  "{0} banners": "{0} banner",
  "{0} by {1} {2}": "{0} ({1} tarafından, {2})",
  "{0} came off today's tickets in discounts of every kind.": "Bugünkü fişlerden her türden indirim olarak {0} düşüldü.",
  "{0} categories": "{0} kategori",
  "{0} change": "{0} değişikliği",
  "{0} changes": "{0} değişiklik",
  "{0} changes waiting": "{0} değişiklik bekliyor",
  "{0} codes": "{0} kod",
  "{0} cohort · month {1}": "{0} kohortu · ay {1}",
  "{0} could not be loaded, so the totals leave it out.": "{0} mağazası yüklenemedi, bu yüzden toplamlara dahil edilmedi.",
  "{0} could not be loaded, so the totals leave them out.": "{0} mağazaları yüklenemedi, bu yüzden toplamlara dahil edilmedi.",
  "{0} coupons · {1} deals": "kupon {0} · kampanya {1}",
  "{0} days": "{0} gün",
  "{0} days ago": "{0} gün önce",
  "{0} days up to today": "Bugüne kadarki {0} gün",
  "{0} days up to yesterday": "Düne kadarki {0} gün",
  "{0} did not answer at {1}, so Gemini answered instead: {2}": "{0} yanıt vermedi ({1}); bu yüzden onun yerine Gemini yanıt verdi: {2}",
  "{0} done, {1} being made, {2} new": "{0} tamamlandı, {1} hazırlanıyor, {2} yeni",
  "{0} failed": "{0} başarısız",
  "{0} from anything": "tüm menüden {0}",
  "{0} from {1}": "{1} arasından {0}",
  "{0} gets your note in a direct message.": "Notunuz {0} adlı kişiye doğrudan mesajla iletilir.",
  "{0} gets your note in their chat with Connect.": "Notunuz {0} adlı kişiye, Connect ile olan sohbetinde iletilir.",
  "{0} given away": "{0} indirim olarak verildi",
  "{0} given away in coupons and deals": "{0} kupon ve kampanya indirimi",
  "{0} has no figures in the sales reports.": "Satış raporlarında {0} mağazasına ait rakam yok.",
  "{0} have no figures in the sales reports.": "Satış raporlarında {0} mağazalarına ait rakam yok.",
  "{0} have ordered at least once": "{0} en az bir kez sipariş verdi",
  "{0} hours ago": "{0} saat önce",
  "{0} in the prior period": "önceki dönemde {0}",
  "{0} in {1}": "{1}: {0}",
  "{0} in {1}: {2}": "{1} için {0}: {2}",
  "{0} item(s)": "{0} ürün",
  "{0} items": "{0} ürün",
  "{0} items counted at {1}.": "{0} kalem sayıldı ({1}).",
  "{0} items have been counted once. Usage needs two counts to exist at all, so they will appear here after the next count.": "{0} kalem yalnızca bir kez sayıldı. Kullanım ancak iki sayımla hesaplanabildiği için bu kalemler bir sonraki sayımdan sonra burada görünecek.",
  "{0} items have no usage figure yet. Usage needs two counts at least {1} days apart — a same-day recount is a correction, not a week of consumption, so it is left out rather than counted as an enormous week.": "{0} kalemin henüz kullanım rakamı yok. Kullanım için iki sayım arasında en az {1} gün olmalı — aynı gün yapılan yeniden sayım bir düzeltmedir, bir haftalık tüketim değildir; bu yüzden çok büyük bir hafta olarak sayılmak yerine dışarıda bırakılır.",
  "{0} items on invoice": "{0} kalem, fatura no",
  "{0} items show more stock than could possibly be there. That is not a rounding error — either a count was mistyped, or a delivery arrived and was never recorded. Worth resolving before trusting the rest.": "{0} kalem, mümkün olabilecekten fazla stok gösteriyor. Bu bir yuvarlama hatası değil — ya bir sayım yanlış girildi ya da gelen bir teslimat hiç kaydedilmedi. Geri kalan rakamlara güvenmeden önce bunu çözmekte fayda var.",
  "{0} items sold — {1} data": "{0} ürün satıldı — {1} verileri",
  "{0} items will be recorded at": "{0} kalemin kaydedileceği mağaza",
  "{0} lines could not be saved": "{0} satır kaydedilemedi",
  "{0} lines were not recorded": "{0} satır kaydedilmedi",
  "{0} locations": "{0} mağaza",
  "{0} marketplace orders": "{0} pazaryeri siparişi",
  "{0} member": "{0} üye",
  "{0} min ago": "{0} dk önce",
  "{0} months": "{0} ay",
  "{0} More options (usually not needed)": "{0} Diğer seçenekler (genelde gerekmez)",
  "{0} not changed, edited since": "{0} değiştirilmedi, sonradan düzenlenmiş",
  "{0} notifications": "{0} bildirim",
  "{0} of all signups": "tüm kayıtlar içinde {0}",
  "{0} of registered": "kayıtlı müşteriler içinde {0}",
  "{0} of stock": "{0} değerinde stok",
  "{0} of them by e-mail, the rest by phone only": "{0} kişiye e-postayla, kalanına yalnızca telefonla ulaşılabilir",
  "{0} of {1}": "{0}/{1}",
  "{0} of {1} answered": "{0}/{1} yanıtlandı",
  "{0} of {1} customers ordered ({2})": "{1} müşteriden {0} kişi sipariş verdi ({2})",
  "{0} of {1} on": "{0}/{1} açık",
  "{0} of {1} online": "{0}/{1} çevrimiçi",
  "{0} of {1} permissions selected": "{0}/{1} yetki seçildi",
  "{0} of {1} stores": "{0}/{1} mağaza",
  "{0} off": "{0} indirim",
  "{0} off every order.": "Her siparişte {0} indirim.",
  "{0} off orders of {1} or more.": "{1} ve üzeri siparişlerde {0} indirim.",
  "{0} on an offer": "{0} teklifli",
  "{0} orders": "{0} sipariş",
  "{0} orders on points": "puanla verilen {0} sipariş",
  "{0} orders today": "bugün {0} sipariş",
  "{0} orders · avg {1}": "{0} sipariş · ort. {1}",
  "{0} orders · complete day": "{0} sipariş · tam gün",
  "{0} orders · {1} average": "{0} sipariş · ortalama {1}",
  "{0} orders · {1} coupon, {2} deal": "{0} sipariş · {1} kupon, {2} kampanya",
  "{0} orders · {1}%": "{0} sipariş · %{1}",
  "{0} over": "{0} fazla",
  "{0} per customer": "Müşteri başına {0}",
  "{0} photos: are they": "{0} fotoğraf: bunlar",
  "{0} POS orders": "{0} POS siparişi",
  "{0} pts": "{0} puan",
  "{0} qualifying products": "{0} geçerli ürün",
  "{0} reward products": "{0} ödül ürünü",
  "{0} seconds": "{0} saniye",
  "{0} seen against {1} placed": "{0} görüldü / {1} verildi",
  "{0} segments": "{0} segment",
  "{0} separate {1}s": "{0} ayrı belge",
  "{0} short": "{0} eksik",
  "{0} shown": "{0} gösteriliyor",
  "{0} sold": "{0} adet satıldı",
  "{0} specific products": "{0} belirli ürün",
  "{0} stores": "{0} mağaza",
  "{0} tiers": "{0} seviye",
  "{0} to do": "{0} yapılacak",
  "{0} unsaved": "Kaydedilmemiş: {0}",
  "{0} uses": "{0} kullanım",
  "{0} vs last week": "{0} geçen haftaya göre",
  "{0} vs yesterday": "{0} düne göre",
  "{0} waiting for you": "Sizi bekleyen: {0}",
  "{0} wants to add “{1}”": "{0}, “{1}” yazısını eklemek istiyor",
  "{0} wants to change “{1}”": "{0}, “{1}” yazısını değiştirmek istiyor",
  "{0} wants to delete “{1}”": "{0}, “{1}” yazısını silmek istiyor",
  "{0} web orders from {1} visits": "{1} ziyaretten {0} web siparişi",
  "{0} weeks": "{0} hafta",
  "{0} works one store at a time. Choose the store to open it for.": "{0} aynı anda tek bir mağaza için çalışır. Hangi mağaza için açılacağını seçin.",
  "{0} {1} on hand": "Mevcut: {0} {1}",
  "{0} {1} Share is a share of the mix, not of net sales.": "{0} {1} Pay, net satışın değil, bu dağılımın payıdır.",
  "{0} {1} talked to it in the last 7 days": "Son 7 günde {0} kişi onunla konuştu",
  "{0} {1} used or put aside": "{0}: kullanılan ya da kenara ayrılan {1} belge",
  "{0} {1} will come off stock at": "{0} kalemin stoktan düşüleceği mağaza",
  "{0} {1} written off on {2}": "{2} tarihinde {0} kalem stoktan düşüldü",
  "{0} {1} — OPEN": "{0} {1} — AÇIK",
  "{0} {1}% vs last month": "{0} %{1} geçen aya göre",
  "{0} {1}% vs prior week": "{0} %{1} önceki haftaya göre",
  "{0} · already sent": "{0} · zaten gönderildi",
  "{0} · kept until {1}": "{0} · {1} tarihine kadar saklanır",
  "{0} · loading": "{0} · yükleniyor",
  "{0} · no longer kept": "{0} · artık saklanmıyor",
  "{0} · {1} of {2} answered": "{0} · {1}/{2} yanıtlandı",
  "{0} · {1}% rev": "{0} · %{1} ciro",
  "{0} — Channel Details": "{0} — Kanal ayrıntıları",
  "{0} — home": "{0} — ana sayfa",
  "{0} — not in the rate": "{0} — orana dahil değil",
  "{0} — {1} live data": "{0} — {1} canlı verileri",
  "{0} — {1} orders, {2}": "{0} — {1} sipariş, {2}",
  "{0}% of all orders, never measurable here": "tüm siparişler içindeki payı %{0}; burada hiçbir zaman ölçülemez",
  "{0}% of basis": "matrah üzerinden %{0}",
  "{0}% of revenue": "ciro payı %{0}",
  "{0}% off": "%{0} indirim",
  "{0}% off {1} once {2} are in the cart, on up to {3} item(s).": "Şu ürünlerde %{0} indirim, sepette {2} adet olduğunda ve en fazla {3} üründe: {1}.",
  "{0}% off {1} once {2} are in the cart.": "Şu ürünlerde %{0} indirim, sepette {2} adet olduğunda: {1}.",
  "{0}% off {1}, on up to {2} item(s).": "Şu ürünlerde %{0} indirim, en fazla {2} üründe: {1}.",
  "{0}% off {1}.": "Şu ürünlerde %{0} indirim: {1}.",
  "{0}% peak": "zirve %{0}",
  "{0}% vs {1}": "{1} ile kıyasla {0}%",
  "{0}+ orders a year": "yılda {0}+ sipariş",
  "{0}+ points": "{0}+ puan",
  "{0}, today": "{0}, bugün",
  "{0}/250 characters": "{0}/250 karakter",
  "{0}/blogs/": "{0}/blogs/",
  "{0}/blogs/{1}": "{0}/blogs/{1}",
  "{0}/events/blogs": "{0}/events/blogs",
  "{0}: formatting": "{0}: biçimlendirme",
  "{0}: time": "{0}: saat",
  "{0}: {1} orders ({2}%)": "{0}: {1} sipariş (%{2})",
  "{0}: {1} — {2} orders": "{0}: {1} — {2} sipariş",
  "{0}: {1}, {2}. Change": "{0}: {1}, {2}. Değiştir",
  "{0}: {1}. Change": "{0}: {1}. Değiştir",
  "{0}h": "{0}",
  "{0}w": "{0} hafta",
  "{0}W{1}": "{0}H{1}",
  "{0}–close": "{0}–kapanış",
  "{0}’s report for {1} is finished.": "{0} için {1} raporu tamamlandı.",
  "· by {0}": "· oluşturan: {0}",
  "· changed {0}": "· son değişiklik: {0}",
  "· coupon {0}": "· kupon {0}",
  "· its address is taken now": "· adresi artık kullanımda",
  "· not in use": "· kullanımda değil",
  "· reads the panel for you; write @connect in any channel to call it there": "· paneli sizin için okur; herhangi bir kanalda çağırmak için @connect yazın",
  "· {0} by {1}": "· {0} ({1} tarafından)",
  "· {0} in / {1} out": "· {0} girdi / {1} çıktı",
  "· {0} of discounts already taken off": "· {0} indirim zaten düşülmüş",
  "· {0} stores": "· {0} mağaza",
  "· −{0} deal": "· −{0} kampanya indirimi",
  "· 🔒 end-to-end encrypted": "· 🔒 uçtan uca şifreli",
  "— goes out to customers at its scheduled time.": "— planlanan saatte müşterilere gönderilir.",
  "— its order tables are not in this database.": "— sipariş tabloları bu veritabanında değil.",
  "— nothing scheduled here": "— burada planlanmış bir şey yok",
  "— the app cannot open this link": "— uygulama bu bağlantıyı açamaz",
  "— {0} items": "— {0} kalem",
  "“Buy” must be at least 2 for a buy-some-get-one deal": "“Birkaç al, bir tane kazan” kampanyasında alınacak adet en az 2 olmalı",
  "“Never ordered” is its own segment here, not a lifecycle stage — those accounts registered and stopped, so churn and days-since have nothing to measure yet.": "“Hiç sipariş vermemiş” burada bir yaşam döngüsü aşaması değil, kendi başına bir segmenttir — bu hesaplar kaydolup orada kaldı, bu yüzden kayıp riski ve son siparişten beri geçen gün için henüz ölçülecek bir şey yok.",
  "“Rate” is conversions divided by impressions. An arm with very few impressions can show a misleadingly high rate — the engine allows for that, a glance at this table does not.": "“Oran”, dönüşümlerin gösterimlere bölünmesidir. Çok az gösterimi olan bir varyant yanıltıcı derecede yüksek bir oran gösterebilir — motor bunu hesaba katar, ama tabloya şöyle bir göz atmak bunu hesaba katmaz.",
  "“{0}” disappears from everyone’s list. Its messages stay in the database for the record.": "“{0}” grubu herkesin listesinden kalkar. Mesajları kayıt için veritabanında kalır.",
  "“{0}” is removed for good.": "“{0}” dosyası kalıcı olarak silinir.",
  "• List": "• Liste",
  "…and gets": "…ve alır:",
  "…or only these exact items": "…ya da yalnızca şu ürünler",
  "…or paste a link": "…ya da bağlantı yapıştır",
  "…this is added at": "…şu ürün eklenir,",
  "‹ Prev": "‹ Önceki",
  "← Previous": "← Önceki",
  "↻ Refresh": "↻ Yenile",
  "↻ Reload": "↻ Yenile",
  "− Discounts": "− İndirimler",
  "− Total Tips": "− Toplam bahşiş",
  "⌘K": "⌘K",
  "♥ {0} likes · 🛒 {1} orders": "♥ {0} beğeni · 🛒 {1} sipariş",
  "⚠ Force-closed from the panel": "⚠ Panelden zorla kapatıldı",
  "✓ Approve": "✓ Onayla",
  "🔒 Encrypted end to end · your key {0}": "🔒 Uçtan uca şifreli · anahtarınız: {0}",
  "🔒 Finish the encryption setup above to write here.": "🔒 Buraya yazmak için yukarıdaki şifreleme kurulumunu tamamlayın.",
};
